export type Language = 'es' | 'en' | 'ca';

export const translations = {
  es: {
    hero: {
      title: "Descubre el menú del día, sin dar vueltas.",
      subtitle: "El acceso anticipado está abierto. Únete a los primeros testers que descubren el menú del día en España.",
    },
    earlyAccess: {
      title: "Acceso early bird (MVP cerrado)",
      body: "El acceso anticipado ya está abierto. Únete a los primeros testers y ayuda a dar forma a MenúHunter.",
      emailPlaceholder: "Tu email",
      button: "Únete al acceso anticipado",
      platformIos: "iOS",
      platformAndroid: "Android",
      platformAria: "Plataforma",
      successTitle: "¡Estás en la lista!",
      successWithPlatform:
        "Estás en la lista de acceso anticipado para {{platform}}. Te enviaremos un correo cuando tu plaza esté lista, con instrucciones de acceso anticipado para {{platform}}.",
      existsTitle: "Ya estás apuntado",
      existsWithPlatform:
        "Ya estabas en la lista; hemos actualizado tu preferencia a {{platform}}. Te enviaremos un correo cuando tu plaza esté lista, con instrucciones de acceso anticipado para {{platform}}.",
      instagramLabel: "Ver @menuhunter.app en Instagram",
      instagramButton: "Ver en Instagram",
      disclaimer: "Sin spam. Solo avisos de acceso y novedades.",
      targetContext: "Parece que intentabas abrir un enlace de la app. Déjanos tu email y te avisamos cuando puedas abrirlo desde MenúHunter.",
      errorPlatform: "Selecciona iOS o Android.",
    },
    menuShare: {
      earlyAccessCta: "Acceso early bird",
      subtitle: "¿Quieres usar MenúHunter cuando lancemos?",
    },
    download: {
      ios: "Descargar para iOS",
      android: "Descargar para Android",
      appStore: "Descargar en App Store",
      playStore: "Obtener en Google Play",
      scanToDownload: "Escanea para descargar MenúHunter",
      freeOnStores: "Gratis en Android e iOS",
      orVisit: "O visita:",
      openInApp: "Abrir en la app MenúHunter",
      continueOnWeb: "Continuar en la web",
    },
    common: {
      goHome: "Ir al inicio",
      language: "Idioma",
      footerNav: "Pie de página",
      toggleTheme: "Cambiar tema",
      switchToLightMode: "Cambiar a modo claro",
      switchToDarkMode: "Cambiar a modo oscuro",
    },
    menuSource: {
      community: "Subido por usuario",
      venue: "Verificado por restaurante",
      staff: "Equipo MenúHunter",
    },
    menuFreshness: {
      uploadedToday: "Subido hoy",
      uploadedYesterday: "Subido ayer",
      uploadedHoursAgo: "Subido hace {hours} h",
      uploadedDaysAgo: "Subido hace {count} días",
      uploadedOnDate: "Subido el {date}",
    },
    product: {
      explore: "Explorar",
      search: "Buscar",
      capture: "Capturar",
      saved: "Guardados",
      account: "Cuenta",
      login: {
        title: "Iniciar sesión",
        subtitle: "Inicia sesión para guardar menús y capturar fotos.",
        emailLabel: "Correo electrónico",
        passwordLabel: "Contraseña",
        signInButton: "Iniciar sesión",
        googleButton: "Continuar con Google",
        appleButton: "Continuar con Apple",
        browseGuest: "Explorar sin iniciar sesión",
        loading: "Cargando…",
        signInErrorGeneric: "No se pudo iniciar sesión. Inténtalo de nuevo.",
        forgotPasswordLink: "¿Has olvidado tu contraseña?",
      },
      forgotPassword: {
        title: "¿Has olvidado tu contraseña?",
        subtitle: "Introduce tu correo y te enviaremos un enlace para restablecerla.",
        emailLabel: "Correo electrónico",
        sendButton: "Enviar enlace",
        sending: "Enviando…",
        success:
          "Si existe una cuenta con ese correo, recibirás un enlace en breve. Revisa tu bandeja de entrada.",
        invalidEmail: "Introduce un correo electrónico válido.",
        sendErrorGeneric: "No se pudo enviar el correo. Inténtalo de nuevo.",
        backToLogin: "Volver a iniciar sesión",
      },
      getApp: "Descargar app",
      pwaInstall: {
        title: "Instalar la web app de MenúHunter",
        description: "Añade MenúHunter a este ordenador para acceder rápidamente.",
        install: "Instalar web app",
        dismiss: "Ahora no",
      },
      appBanner: "Vive la experiencia completa en la app MenúHunter",
      exploreViewportError:
        "No pudimos cargar menús en esta zona. Prueba a mover el mapa o actualizar la página.",
      accountPage: {
        loading: "Cargando…",
        personalSection: "Tu cuenta",
        savedMenus: "Menús guardados",
        settings: "Ajustes",
        notifications: "Preferencias de notificaciones",
        restaurantSectionTitle: "Panel del restaurante",
        restaurantSectionHint:
          "Gestiona el menú del día, el perfil de tu local y tu equipo.",
        openRestaurantPanel: "Abrir panel del restaurante",
        managingRestaurant: "Gestionas {name}",
        noRestaurantAccessTitle: "¿Tienes un restaurante?",
        noRestaurantAccessBody:
          "El acceso al panel del restaurante aparece cuando gestionas tu local en MenúHunter o cuando alguien de tu equipo te añade.",
        claimRestaurant: "Gestionar mi restaurante",
        signOut: "Cerrar sesión",
      },
      accountSettingsPage: {
        backToAccount: "Volver a la cuenta",
        loading: "Cargando…",
        title: "Ajustes",
        subtitle: "Personaliza cómo ves MenúHunter en la web.",
        themeSection: "Apariencia",
        themeLight: "Claro",
        themeDark: "Oscuro",
        themeSystem: "Sistema",
        languageSection: "Idioma",
        languageEs: "Español",
        languageEn: "English",
        languageCa: "Català",
      },
      accountSavedPage: {
        backToAccount: "Volver a la cuenta",
        loading: "Cargando menús guardados…",
        title: "Menús guardados",
        subtitle: "Tus menús del día guardados para volver a ellos cuando quieras.",
        emptyTitle: "Aún no has guardado ningún menú",
        emptyBody: "Explora menús cerca de ti y guarda los que te interesen.",
        exploreCta: "Explorar cerca",
      },
      accountNotificationsPage: {
        backToAccount: "Volver a la cuenta",
        loading: "Cargando…",
        title: "Notificaciones",
        subtitle:
          "Las notificaciones push requieren la app móvil. Estas preferencias se aplican cuando usas la app.",
        nearbyLabel: "Menús nuevos cerca de mí",
        nearbyHint:
          "Recibe avisos cuando se publica un menú del día cerca de tu ubicación.",
        favoritesLabel: "Actualizaciones de favoritos",
        favoritesHint:
          "Recibe avisos cuando un restaurante guardado publica un menú nuevo.",
        save: "Guardar preferencias",
        saving: "Guardando…",
        saved: "Preferencias guardadas",
      },
    },
    restaurantPanel: {
      shellTitle: "Panel del restaurante",
      nav: {
        dashboard: "Resumen",
        menus: "Menús",
        billing: "Facturación",
        team: "Equipo",
        qrcode: "Código QR",
        profile: "Perfil",
      },
      home: {
        title: "Panel de tu restaurante",
        summaryTitle: "Tu restaurante",
        restaurantLabel: "Restaurante",
        statusLabel: "Estado",
        performanceTitle: "Rendimiento",
        performanceHint:
          "Estas cifras muestran cómo interactúan los comensales con tu menú en MenúHunter.",
        performanceComingSoon:
          "Pronto añadiremos métricas de rendimiento más detalladas.",
        thisWeek: "Esta semana",
        kpiMenuViews: "Vistas del menú (7 días)",
        kpiSaved: "Guardado por usuarios",
        kpiNearby: "Restaurantes cercanos",
        kpiNearbyPrice: "Precio medio cercano",
        noRestaurant: "Aún no gestionas ningún restaurante.",
        loading: "Cargando…",
      },
      status: {
        active: "Suscripción activa",
        trialActive: "Acceso activo",
        notSubscribed: "Sin suscripción activa",
        trialEnded: "Acceso finalizado",
        subscriptionInactive: "Suscripción inactiva",
      },
      menus: {
        title: "Menús",
        subtitle:
          "Gestiona las fotos de tu menú del día. El menú actual es el que ven los comensales en MenúHunter.",
        addMenu: "Añadir foto de menú",
        view: "Ver",
        viewMenu: "Ver menú",
        emptyTitle: "Aún no hay menús",
        emptyBody:
          "Sube una foto de tu carta o menú del día para que los comensales cercanos puedan encontrarte.",
        emptyCta: "Subir primer menú",
        noRestaurant: "Aún no gestionas ningún restaurante.",
        loading: "Cargando menús…",
        menuFallbackTitle: "Menú",
        currentBadge: "Actual",
        verification: {
          verified: "Publicado",
          pending: "En revisión",
          needsFix: "Necesita cambios",
          unknown: "Estado desconocido",
        },
      },
      billing: {
        title: "Facturación",
        subtitle:
          "Consulta el estado de tu suscripción y gestiona los pagos de forma segura.",
        summaryTitle: "Tu suscripción",
        planLabel: "Plan",
        planMonthly: "Mensual",
        planAnnual: "Anual",
        trialEndsLabel: "El acceso continúa hasta",
        renewsOnLabel: "Próxima renovación",
        accessUntilLabel: "Acceso hasta",
        cancelScheduledBadge: "Cancelación programada",
        statusPastDue: "Pago pendiente",
        noSubscriptionBody:
          "No tienes una suscripción activa. Puedes suscribirte desde la app MenúHunter o contactar con soporte si necesitas ayuda.",
        loading: "Cargando facturación…",
        appleTitle: "Suscripción en iPhone",
        appleBody:
          "Esta suscripción se compró en la app de iOS. No se puede gestionar desde la web con el portal de pagos.",
        appleManageHint:
          "Gestiona tu suscripción desde la plataforma donde la compraste: Ajustes → Apple ID → Suscripciones en tu iPhone.",
        portalTitle: "Gestionar en la app",
        portalHint:
          "Las suscripciones Pro de Google Play se gestionan en la app MenúHunter o en Google Play → Suscripciones.",
        manageSubscription: "Abrir app MenúHunter",
        opening: "Abriendo…",
        portalUnavailable:
          "La facturación web con Stripe ya no está disponible. Gestiona Pro en la app (App Store o Google Play).",
        signInAgain: "Inicia sesión de nuevo para gestionar la facturación.",
        noPermission: "No tienes permiso para gestionar la facturación de este restaurante.",
        noBillingAccount: "Todavía no hay una cuenta de facturación vinculada a este restaurante.",
        noRestaurant: "Aún no gestionas ningún restaurante.",
      },
      team: {
        title: "Equipo",
        subtitle:
          "Consulta quién puede gestionar tu restaurante desde el panel de MenúHunter.",
        contextTitle: "Tu restaurante",
        restaurantLabel: "Restaurante",
        accessTitle: "Acceso al equipo",
        accessBody:
          "Las personas con acceso al equipo pueden actualizar el menú, el perfil del restaurante y otros ajustes en el panel. Solo debe tener acceso quien realmente gestiona el local.",
        membersTitle: "Personas con acceso",
        membersHint: "Estas cuentas pueden entrar al panel de tu restaurante.",
        emptyTitle: "Nadie más por ahora",
        emptyBody:
          "Cuando se añadan más personas con acceso, aparecerán aquí con su correo y su nivel de acceso.",
        memberFallback: "Persona del equipo",
        joinedLabel: "En el equipo desde {date}",
        manageNote:
          "Para invitar o quitar personas del equipo, usa la app MenúHunter en tu móvil.",
        noRestaurant: "Aún no gestionas ningún restaurante.",
        loading: "Cargando equipo…",
        roles: {
          owner: "Titular",
          manager: "Gestor",
          staff: "Colaborador",
          unknown: "Acceso",
        },
      },
      qr: {
        title: "Código QR",
        subtitle:
          "Lleva a los comensales directamente a la página de tu menú en MenúHunter.",
        contextTitle: "Tu restaurante",
        restaurantLabel: "Restaurante",
        aboutTitle: "Para qué sirve",
        aboutBody:
          "Al escanear el código, los comensales abren la página pública de tu restaurante con el menú del día actualizado.",
        usesTitle: "Dónde usarlo",
        useTables: "En mesas o tentempiés",
        useWindows: "En el escaparate o la puerta",
        useFlyers: "En carteles o flyers impresos",
        useSocial: "En redes sociales o WhatsApp",
        scanHint:
          "Imprime el código o muéstralo en pantalla para que lo escaneen con la cámara del móvil.",
        linkTitle: "Enlace público",
        linkHint: "Comparte este enlace si prefieres no usar un código QR.",
        copyLink: "Copiar enlace",
        linkCopied: "Enlace copiado",
        copyFailed: "No se pudo copiar el enlace",
        openPublicPage: "Abrir página pública",
        noRestaurant: "Aún no gestionas ningún restaurante.",
        loading: "Cargando…",
        alt: "Código QR del restaurante",
        stickerLangLabel: "Idioma de la pegatina",
        langEs: "ES",
        langCa: "CA",
        downloadSvg: "Descargar SVG",
        downloadPng: "Descargar PNG",
        downloadPdf: "Descargar PDF",
        layoutLabel: "Diseño de hoja",
        cutLines: "Marcas de corte",
        downloading: "Descargando…",
        downloadFailed: "No se pudo descargar el archivo",
        partnerTitle: "Encargar pegatinas",
        partnerBody:
          "Pide pegatinas impresas a nuestro partner con el diseño MenúHunter listo para imprimir.",
        partnerOrder: "Encargar pegatinas",
        partnerCopyCode: "Copiar código",
        partnerCodeCopied: "Código copiado",
        partnerRecommendedLayout: "Diseño recomendado",
      },
      profile: {
        title: "Perfil del restaurante",
        subtitle:
          "Esta información aparece en la página pública de tu restaurante en MenúHunter.",
        basicSection: "Información básica",
        nameLabel: "Nombre del restaurante",
        nameHint: "El nombre que verán los comensales al buscar tu local.",
        namePlaceholder: "Ej. Bar La Plaza",
        addressLabel: "Dirección",
        addressHint: "Ayuda a ubicar tu restaurante en el mapa y en las búsquedas.",
        addressPlaceholder: "Calle, número, ciudad…",
        publicPageLabel: "Página pública",
        publicPageHint: "Así ven los comensales tu restaurante en la web.",
        viewPublicPage: "Ver página pública",
        save: "Guardar cambios",
        saving: "Guardando…",
        saved: "Cambios guardados",
        saveError: "No se pudieron guardar los cambios. Inténtalo de nuevo.",
        loading: "Cargando perfil…",
        noRestaurant: "Aún no gestionas ningún restaurante.",
        missingNameHint: "Añade el nombre de tu restaurante para que los comensales te reconozcan.",
        missingAddressHint: "La dirección ayuda a mostrar tu local en el mapa.",
      },
      common: {
        emDash: "—",
        loading: "Cargando…",
      },
    },
    communityCta: {
      compactPrefix: "¿Has visto un menú?",
      compactLink: "Súbelo en 10 segundos",
      compactSuffix: "y ayuda a mantener frescos los menús cerca de ti.",
      bannerTitle: "¿Has visto un menú? Súbelo en 10 segundos.",
      bannerBody:
        "Con la app de MenúHunter puedes ayudar a mantener actualizados los menús del día en tu ciudad — empezamos en Barcelona. Sin promesas de pago: solo comunidad.",
      bannerLink: "Descargar la app →",
    },
    menuDetailPage: {
      loading: "Cargando menú…",
      notFoundTitle: "Menú no encontrado",
      notFoundBody: "El menú que buscas no existe o ha sido eliminado.",
      backHome: "Volver al inicio",
      openAppPrompt:
        "Abre este menú en MenúHunter para ver más detalles y guardar favoritos.",
      openInApp: "Abrir en la app",
      downloadApp: "Descargar la app",
      menuOfTheDay: "Menú del día",
      tagsLabel: "Etiquetas",
      allergensLabel: "Alérgenos",
      menuTextUnavailableShort: "Texto del menú no disponible todavía.",
      menuTextUnavailableLong:
        "Texto del menú no disponible todavía, pero puedes ver la imagen del menú subida.",
      photoAlt: "Menú de {name}",
      viewRestaurant: "Ver restaurante",
    },
    explorePage: {
      title: "Menús cerca",
      nearMe: "Cerca de mí",
      searchThisArea: "Buscar en esta zona",
      updating: "Actualizando…",
      menuFoundOne: "1 menú encontrado",
      menuFoundMany: "menús encontrados",
      recentUploadOne: "1 subido recientemente",
      recentUploadMany: "subidos recientemente",
      onMapOne: "1 restaurante en el mapa",
      onMapMany: "restaurantes en el mapa",
      recentShortOne: "1 sub. rec.",
      recentShortMany: "sub. rec.",
      onMapShort: "en mapa",
      listedRestaurants: "Restaurantes listados",
      noMenuRestaurants: "Restaurantes sin menú",
      listedRestaurant: "Restaurante listado",
      viewMenu: "Ver menú",
      viewRestaurant: "Ver restaurante",
      viewMenuWithName: "Ver menú —",
      viewRestaurantWithName: "Ver restaurante —",
      restaurant: "Restaurante",
      adjustListPanel: "Ajustar panel de lista",
      loading: "Cargando…",
      emptyTitle: "No hay restaurantes en esta zona",
      emptyBody:
        "Prueba a alejar el mapa, moverte a otra zona o activar tu ubicación con «Cerca de mí».",
      listedOnlyHint:
        "No hay menús capturados en esta zona. Estos restaurantes aparecen en el mapa como listados.",
      hideNoMenu: "Ocultar restaurantes sin menú",
      showNoMenu: "Mostrar restaurantes sin menú",
      restaurantFallback: "Restaurante",
      restaurantMarkerAria: "Restaurante",
      menuPriceAria: "Precio del menú: {price}",
      loadingMap: "Cargando mapa…",
      mapLoadError: "No se pudo cargar Google Maps",
      mapUnavailable: "El mapa no está disponible temporalmente.",
      mapListStillAvailable: "La lista de restaurantes sigue disponible.",
      closeSelectedDetail: "Cerrar detalle",
      drawerDetails: "Detalles",
      drawerMenuDelDia: "Menú del día",
      drawerLastUpload: "Última subida",
      drawerIncludes: "Incluye",
      drawerIncludeDrink: "Bebida",
      drawerIncludeBread: "Pan",
      drawerIncludeDessert: "Postre",
      drawerIncludeCoffee: "Café",
      drawerNotes: "Notas",
      drawerDishes: "Platos",
      drawerDishesHint: "Abre el menú completo para ver todos los platos.",
      drawerNoDishesHint: "Los platos detallados están en la página del menú.",
    },
    searchPage: {
      title: "Buscar",
      placeholder: "Buscar restaurantes o zonas",
      locationHint:
        "Por defecto se busca en Barcelona. Usa Explorar → Cerca de mí para tu ubicación.",
      loading: "Buscando…",
      emptyTitle: "No se encontraron resultados",
      emptyBody: "Prueba con otro restaurante, barrio o zona.",
    },
    features: {
      realMenus: {
        title: "Menús Reales",
        description: "Ve fotos reales de menús capturadas diariamente de restaurantes cerca de ti.",
      },
      locationBased: {
        title: "Basado en Ubicación",
        description: "Encuentra restaurantes y menús basados en tu ubicación actual.",
      },
      dailyUpdates: {
        title: "Actualizaciones Diarias",
        description: "Los menús se actualizan diariamente para que siempre veas lo que está disponible hoy.",
      },
    },
    staff: {
      question: "¿Eres personal?",
      login: "Inicia sesión en el panel de administración",
    },
    footer: {
      copyright: "MenúHunter™. Todos los derechos reservados.",
    },
    scan: {
      hero: {
        headline: "Descubre el menú del día de hoy cerca de ti",
        subheadline: "Encuentra ofertas de menú cerca, mira platos y precios del día y elige dónde comer en segundos.",
        desktopHelper: "Abre esto en tu móvil para descargar",
        links: {
          exploreMenus: "Explorar menús del día",
          interactiveMap: "Ver mapa interactivo",
          restaurants: "Para restaurantes",
        },
      },
      cta: {
        appStore: "Descargar en App Store",
        googlePlay: "Consíguelo en Google Play",
      },
      trust: {
        free: "Gratis",
        barcelona: "Creciendo cada día",
        updated: "Actualizado a diario",
        pills: [
          "Gratis para usuarios",
          "iPhone y Android",
          "Menús reales",
          "Actualizado a diario",
          "Restaurantes verificados",
        ],
      },
      howItWorks: {
        title: "Cómo funciona",
        find: "Encuentra menús cerca",
        see: "Ver precios y platos",
        save: "Guarda tus favoritos",
      },
      value: {
        title: "Por qué MenúHunter",
        updated: "Actualizado a diario",
        barcelona: "Hecho para cazadores de menú en España",
        fast: "Compara opciones de menú cerca en segundos",
      },
      showcase: {
        title: "Cómo se ve",
        subtitle: "Menús en el mapa, platos de hoy y favoritos en una sola app.",
        map: "Mapa",
        menus: "Menús",
        today: "Hoy",
      },
      benefits: {
        eyebrow: "Para comensales",
        title: "Todo lo que necesitas para elegir",
        find: {
          title: "Menús cerca",
          desc: "Encuentra ofertas de menú a tu alrededor y compara en segundos.",
        },
        map: {
          title: "Explora menús en el mapa",
          desc: "Localiza restaurantes y menús por zona y elige con el mapa.",
        },
        dishes: {
          title: "Platos y precios reales",
          desc: "Ve el menú del día y los precios antes de decidir.",
        },
        featured: {
          title: "Menús destacados",
          desc: "Descubre opciones destacadas y recomendadas cerca.",
        },
        latest: {
          title: "Últimas subidas",
          desc: "Revisa las últimas actualizaciones de menú del día.",
        },
        favourites: {
          title: "Guarda favoritos",
          desc: "Guarda tus sitios favoritos y decide más rápido.",
        },
      },
      neighbourhoods: {
        eyebrow: "Explorar por barrio",
        title: "Explora por barrio",
        subtitle: "Descubre los mejores menús de mediodía en cada barrio.",
      },
      owner: {
        eyebrow: "Para restaurantes",
        headline: "¿Quieres tu restaurante en MenúHunter?",
        intro: "MenúHunter ayuda a la gente que está cerca a descubrir tu menú del día, precios y platos. Las herramientas para gestionar tu restaurante llegarán pronto; por ahora, la mejor forma de entender la plataforma es descargar la app y ver cómo aparecen los restaurantes a los comensales cercanos.",
        benefit1: "Comprueba cómo se ven los menús para los comensales cercanos",
        benefit2: "Descubre cómo se muestran los restaurantes en el mapa",
        benefit3: "Mantén tu menú visible para quien busca comer cerca",
        benefit4: "Las herramientas para gestionar tu restaurante llegarán pronto",
      },
      sections: {
        nearby: {
          title: "Menús cerca de ti",
          desc: "Encuentra menús cercanos, mira qué hay disponible a tu alrededor y compara opciones en segundos.",
        },
        dishes: {
          eyebrow: "Detalle del menú",
          title: "Platos y precios",
          desc: "Ve los platos del día y los precios antes de elegir.",
          bullet1: "Platos y precios reales del día",
          bullet2: "Fotos de menús y cartas capturadas",
          bullet3: "Información clara de restaurante y menú",
          bullet4: "Decide mejor antes de ir",
        },
        feed: {
          eyebrow: "Descubrimiento",
          title: "Descubre cada día",
          desc: "Menús nuevos a diario y opciones destacadas cerca.",
          bullet1: "Menús recién subidos",
          bullet2: "Opciones destacadas y locales",
          bullet3: "Descubrimiento cercano en un vistazo",
          bullet4: "Navega rápido por las opciones del día",
        },
      },
      restaurant: {
        heading: "¿Tienes un restaurante?",
        copy: "Gestiona tu página y mantén tu menú del día visible.",
        button: "Descarga la app",
      },
    },
    homePage: {
      hero: {
        title: "Menú del día, más rápido",
        subtitle:
          "Descubre menús del día cerca, fotos reales, precios, favoritos y alertas — todo en un mapa.",
        downloadLabel: "Descarga MenúHunter",
        exploreMapCta: "Explorar el mapa",
        mapAlt: "Mapa de menús del día en MenúHunter",
        exploreMenus: "Explorar menús del día",
        interactiveMap: "Ver mapa interactivo",
        forRestaurants: "Para restaurantes",
        showcase: {
          cards: [
            {
              title: "Encuentra el menú de hoy",
              subtitle: "Explora el mapa del menú del día cerca de ti y filtra por zona.",
              imageAlt: "Mapa de menús del día en MenúHunter",
            },
            {
              title: "Fotos reales del menú",
              subtitle: "Compara platos, precios y capturas reales de la comunidad.",
              imageAlt: "Detalle de menú con fotos en MenúHunter",
            },
            {
              title: "Comparte listas",
              subtitle: "Invita amigos y comparte rutas de menú del día.",
              imageAlt: "Listas compartidas de menú del día en MenúHunter",
            },
            {
              title: "Alertas de menú",
              subtitle: "Te avisamos cuando hay novedades cerca o en tus favoritos.",
              imageAlt: "Alertas de menú del día en MenúHunter",
            },
          ],
        },
      },
      trust: {
        pills: [
          "Gratis para usuarios",
          "iPhone y Android",
          "Menús reales",
          "Subido por la comunidad",
          "Menús frescos",
          "Restaurantes verificados",
        ],
      },
      howItWorks: {
        title: "Cómo funciona",
        subtitle: "Descubre, compara y contribuye al mapa del menú del día cerca de ti.",
        stepLabel: "Paso",
        steps: [
          {
            title: "Encuentra menús cerca de ti",
            description:
              "Explora el mapa colaborativo del menú del día cerca de ti y filtra por zona.",
          },
          {
            title: "Mira fotos, precio y distancia",
            description:
              "Compara menús con fotos reales, precio actualizado y ubicación en el mapa.",
          },
          {
            title: "Sube un menú y ayuda a otros",
            description:
              "Contribuye con un menú del día que hayas visto y mejora el mapa para todos.",
          },
        ],
      },
      differentiators: {
        title: "Por qué MenúHunter es diferente",
        items: [
          {
            title: "Impulsado por la comunidad",
            description:
              "Menús reales subidos por personas en tu ciudad, no directorios genéricos.",
          },
          {
            title: "Menús frescos de hoy",
            description:
              "Priorizamos capturas recientes para que veas qué se sirve hoy y esta semana.",
          },
          {
            title: "Restaurantes verificados",
            description:
              "Los locales pueden gestionar y verificar su perfil como capa de confianza.",
          },
          {
            title: "iPhone y Android",
            description:
              "La experiencia completa está en la app móvil, disponible en ambas tiendas.",
          },
        ],
      },
      restaurants: {
        eyebrow: "Para restaurantes",
        headline: "Haz que te encuentren cuando buscan menú del día",
        subtitle:
          "Publica el menú de hoy y sé más visible para comensales cercanos. Sin comisiones.",
        primaryCta: "Gestionar mi restaurante",
        secondaryCta: "Ver todo para restaurantes",
        claimHint: "Gestiona tu restaurante desde la app en pocos pasos.",
        menuAlt: "Detalle de menú del día en MenúHunter",
      },
      neighborhoods: {
        title: "Explora por barrios",
        subtitle: "Explora menús del día por zona — empezamos en Barcelona.",
        items: [
          { slug: "menu-del-dia-barcelona", label: "Barcelona" },
          { slug: "menu-del-dia-barcelona-eixample", label: "Eixample" },
          { slug: "menu-del-dia-barcelona-gracia", label: "Gràcia" },
          { slug: "menu-del-dia-barcelona-sant-antoni", label: "Sant Antoni" },
          { slug: "menu-del-dia-barcelona-poblenou", label: "Poblenou" },
          { slug: "menu-del-dia-barcelona-el-raval", label: "El Raval" },
          { slug: "menu-del-dia-barcelona-gotic", label: "Gòtic" },
          { slug: "menu-del-dia-barcelona-born", label: "Born" },
        ],
      },
      closing: {
        title: "Descarga MenúHunter",
        subtitle: "El mapa colaborativo del menú del día, en tu bolsillo. Lanzamiento en Barcelona.",
        openMap: "Abrir mapa interactivo",
      },
    },
    communityPage: {
      hero: {
        title: "Restaurantes y vecinos, juntos en el mapa",
        subtitle:
          "Los locales publican su menú del día y la comunidad ayuda a cubrir huecos con fotos reales. Así el mapa se mantiene fresco y útil.",
      },
      stats: {
        ariaLabel: "Cifras en vivo de MenúHunter",
        restaurantsListed: "Restaurantes en el mapa",
        liveNote: "Cifra en vivo · se actualiza sola",
      },
      contribute: {
        title: "¿Has visto un menú? Súbelo en 10 segundos",
        body: "Cuando un local aún no ha publicado el de hoy, tu foto ayuda a todo el mundo. Abre la app, captura la pizarra y mantén fresco el mapa — empezamos en Barcelona.",
        downloadLabel: "Descarga MenúHunter",
        cta: "Ir a descargar",
      },
      restaurants: {
        title: "¿Tienes un restaurante?",
        body: "Publica el menú del día, controla tu perfil y destaca cuando la gente busca cerca. La comunidad complementa; tú mandas en tu local.",
        cta: "Ver para restaurantes",
      },
      follow: {
        title: "Síguenos",
        body: "Hallazgos del día, tips de ciudad y novedades de la app en redes.",
        socialNavAria: "Redes sociales de MenúHunter",
      },
      explore: {
        title: "Mira el mapa en vivo",
        body: "Menús de restaurantes y de la comunidad, filtrados por zona, cerca de ti.",
        cta: "Abrir el mapa",
      },
      ways: {
        title: "Más formas de participar",
        subtitle: "Cada aportación — tuya o del local — hace el mapa más útil.",
        items: [
          {
            title: "Sube un menú como comensal",
            description: "Captura el menú del día desde la app y ayuda a cubrir huecos.",
          },
          {
            title: "Gestiona tu restaurante",
            description: "Publica el menú oficial, verifica el perfil y llega a comensales cercanos.",
          },
          {
            title: "Explora el mapa en vivo",
            description: "Descubre qué hay hoy y encuentra dónde comer.",
          },
          {
            title: "Etiquétanos cuando encuentres una joya",
            description: "Comparte en Instagram y menciona @menuhunter.app.",
          },
          {
            title: "Creadores y partners",
            description: "¿Haces contenido o quieres colaborar? Escríbenos a team@menuhunter.app.",
          },
          {
            title: "Actualiza menús desfasados",
            description: "¿Precio o platos incorrectos? Sube la pizarra de hoy y lo corregimos entre todos.",
          },
        ],
      },
    },
    restaurantsPage: {
      hero: {
        eyebrow: "PARA RESTAURANTES",
        title: "Da más visibilidad a tu menú del día",
        subtitle:
          "Llega a personas cercanas que buscan dónde comer en MenúHunter, desde la app y la web.",
        phoneAlt: "Menú del día de un restaurante en MenúHunter",
        chips: {
          noCommissions: "Cuenta gratis para restaurantes",
          planMonthlyAnnual: "Plan mensual o anual",
          platforms: "iPhone y Android",
          availableAcrossSpain: "Disponible en toda España",
        },
      },
      heroValueProps: {
        title: "Por qué los restaurantes usan MenúHunter",
        items: [
          {
            title: "Publica en segundos",
            description:
              "Haz una foto del menú de hoy y MenúHunter lo convierte en un menú digital claro.",
          },
          {
            title: "Aparece cerca de tus clientes",
            description:
              "Tu restaurante aparece en el mapa cuando alguien busca un menú del día cerca.",
          },
          {
            title: "Publica gratis",
            description:
              "Los restaurantes pueden publicar su menú del día fácilmente y mantenerlo actualizado sin complicaciones.",
          },
        ],
      },
      cta: {
        startTrial: "Gestionar mi restaurante",
        seeHowItWorks: "Cómo funciona",
        downloadApp: "Descargar la app",
        howToClaim: "Cómo gestionar tu restaurante",
        claimRestaurant: "Gestiona tu restaurante",
        showMenuFree: "Muestra tu menú gratis",
      },
      claim: {
        invalidLink:
          "Este enlace no incluye un restaurante válido. Para gestionar tu restaurante, descarga la app de MenúHunter, crea una cuenta y busca tu local para iniciar la solicitud desde la app.",
        loading: "Cargando datos del restaurante…",
        bannerWithName:
          "¿Gestionas {{name}}? Descarga MenúHunter, crea una cuenta y gestiona tu restaurante desde la app para publicar el menú del día, revisar la información y aparecer como restaurante verificado.",
        bannerGeneric:
          "¿Gestionas este restaurante? Descarga MenúHunter, crea una cuenta y gestiona tu restaurante desde la app para publicar el menú del día, revisar la información y aparecer como restaurante verificado.",
      },
      valueProps: {
        title: "Por qué unirte a MenúHunter",
        subtitle:
          "El mapa colaborativo del menú del día, con restaurantes verificados y menús reales de la comunidad.",
        items: [
          {
            title: "Publica tu menú del día en 10 segundos",
            description:
              "Haz una foto del menú de hoy y MenúHunter lo convierte en un menú digital claro, listo para que la gente lo vea.",
          },
          {
            title: "Aparece en el mapa cuando la gente busca dónde comer",
            description:
              "Tu restaurante se muestra a personas cercanas que exploran menús del día.",
          },
          {
            title: "Acceso gratis para restaurantes",
            description:
              "Los restaurantes pueden publicar su menú del día gratis, mantenerlo actualizado y usar herramientas sencillas pensadas para menús diarios.",
          },
          {
            title: "Controla fotos, precio, horario e información",
            description: "Actualiza tu ficha y el menú cuando quieras desde la app.",
          },
          {
            title: "Perfil verificado para generar confianza",
            description:
              "Al gestionar y verificar, los comensales ven que gestionas tu local.",
          },
          {
            title: "Disponible en iPhone, Android y web",
            description:
              "La gente puede encontrar tu menú del día desde la app o la web, tanto si está cerca como si busca opciones para comer desde la oficina.",
          },
        ],
      },
      pricing: {
        headline: "Elige cómo aparece tu restaurante en MenúHunter",
        supporting:
          "Empieza gratis con todo lo necesario para publicar y mantener visible tu menú del día. Pasa a Pro cuando quieras más alcance, más visibilidad y datos sobre tus clientes.",
        tagline: "Los restaurantes Free aparecen en el listado. Los restaurantes Pro destacan.",
        trialBadge: "Pro",
        plans: {
          free: {
            name: "Free",
            price: "€0",
            billingLabel: "/ mes",
            commitment: "Sin tarjeta. Sin cuota mensual.",
            tagline: "Gestiona tu restaurante y mantén al día todo lo que necesitan los clientes, sin tarjeta ni cuota mensual.",
            cta: "Continuar con Free",
            features: {
              claimRestaurant: "Gestiona y verifica tu restaurante",
              publishMenu: "Publica y actualiza tu Menú del Día",
              detailsHours: "Gestiona los datos del restaurante y el horario",
              photosSocial: "Añade fotos y enlaces sociales",
              menuQr: "Crea y comparte el código QR de tu menú",
              searchAndMap: "Aparece en la búsqueda y en el mapa con el marcador estándar",
              basicViews: "Consulta visualizaciones básicas del menú y guardados",
              noMonthlyCharge: "Sin cuota mensual",
            },
          },
          pro: {
            name: "Pro",
            monthlyPrice: "€14.99",
            monthlyLabel: "/ mes",
            annualPrice: "€149.99",
            annualLabel: "/ año",
            trialBadge: "",
            tagline:
              "Todo lo de Free, más herramientas para ganar visibilidad, entender el interés de los clientes y hacer que vuelvan.",
            cta: "Explorar Pro",
            features: {
              boostedVisibility: "Mayor visibilidad en MenuHunter",
              featuredCarousels: "Elegibilidad para Destacados en Inicio",
              followerNotifications: "Avisos a las personas que guardaron tu restaurante",
              analytics: "Analíticas avanzadas del restaurante",
              enhancedProfile: "Perfil de restaurante mejorado",
              teamAccess: "Acceso para varios miembros del equipo",
              prioritySupport: "Soporte prioritario y acceso anticipado a nuevas herramientas",
            },
          },
        },
        features: {
          profile: "Perfil de restaurante en MenúHunter",
          discovery: "Haz que te encuentren personas que buscan menú del día",
          updateDaily: "Muestra el menú de hoy a tus clientes — cada día",
          qrCode: "Comparte el menú de hoy con un código QR único",
          photos: "Controla tus fotos y destaca en el mapa",
          editAnytime: "Edita horarios, precio y detalles del menú cuando quieras",
          verified: "Insignia de propietario verificado",
          noCommission: "Sin comisiones por cliente ni venta",
          trial: "Plan mensual o anual",
          cancel: "Cancela cuando quieras",
        },
      },
      howItWorks: {
        title: "Cómo funciona para restaurantes",
        subtitle:
          "Gestionar o verificar tu perfil añade una capa de confianza. Mientras tanto, la comunidad también puede ayudar a que tu local aparezca en el mapa.",
        stepLabel: "Paso",
        steps: [
          {
            title: "Gestiona o añade tu restaurante",
            description:
              "Si ya apareces en el mapa, reclámalo. Si no, créalo en pocos pasos desde la app.",
          },
          {
            title: "Publica el menú del día",
            description:
              "Sube la foto del menú de hoy para que la gente vea precio y platos actuales.",
          },
          {
            title: "Aparece en el mapa y llega a personas cercanas",
            description:
              "Cuando publicas, tu restaurante gana visibilidad para quien busca dónde comer cerca.",
          },
        ],
      },
      community: {
        title: "Mapa impulsado por la comunidad",
        body:
          "MenúHunter no depende solo de que cada restaurante publique todos los días. La comunidad también puede subir menús reales, ayudando a que más locales aparezcan en el mapa. Cuando un restaurante se verifica, gana control sobre su perfil y una capa extra de confianza.",
      },
      faq: {
        title: "Preguntas frecuentes",
        items: [
          {
            q: "¿MenúHunter cobra comisión?",
            a: "No. No cobramos comisión por cliente ni venta. Solo la suscripción mensual o anual.",
          },
          {
            q: "¿Cuánto cuesta?",
            a: "Free no tiene cargo mensual. Pro cuesta {{monthlyPrice}} €/mes o {{annualPrice}} €/año.",
          },
          {
            q: "¿Puedo usar MenúHunter gratis?",
            a: "Sí. Los restaurantes pueden publicar su menú del día gratis. Los planes de pago son opcionales y añaden más visibilidad, alcance y herramientas para restaurantes.",
          },
          {
            q: "¿Puedo controlar las fotos y la información de mi restaurante?",
            a: "Sí. Al gestionar tu perfil puedes actualizar menú, fotos, horarios y datos de contacto.",
          },
          {
            q: "¿Qué significa restaurante verificado?",
            a: "Indica que el local ha gestionado su perfil y puede publicar y mantener su información con una capa extra de confianza.",
          },
          {
            q: "¿Los usuarios también pueden subir menús?",
            a: "Sí. La comunidad puede aportar menús reales. Cuando verificas tu restaurante, tú controlas tu perfil y cómo se presenta.",
          },
          {
            q: "¿Necesito una app especial para restaurantes?",
            a: "Gestionas tu restaurante desde la app MenúHunter (iPhone o Android). Te guiamos en el proceso de alta o gestión.",
          },
        ],
      },
      claimFlow: {
        title: "Cómo gestionar tu restaurante",
        body:
          "Para gestionar tu restaurante en MenúHunter, descarga la app, crea una cuenta y busca tu restaurante. Desde la ficha del restaurante podrás iniciar la gestión y completar el proceso dentro de la app.",
        steps: [
          "Descarga la app MenúHunter desde la App Store o Google Play.",
          "Crea una cuenta o inicia sesión con tu correo.",
          "Usa el buscador para encontrar tu restaurante.",
          "Abre la ficha de tu restaurante y empieza la gestión desde la app.",
          "Si tienes un código promocional u oferta, úsalo durante el flujo de gestión.",
        ],
        ctaTitle: "Empieza desde la app",
        ctaBody:
          "Abre MenúHunter en tu móvil para gestionar tu restaurante, publicar tu menú del día y gestionar tu visibilidad.",
        supportFallback:
          "Si tienes problemas para gestionar tu restaurante desde la app, puedes contactar con soporte.",
      },
      links: {
        navAria: "Enlaces útiles",
        home: "Inicio",
        barcelonaMenus: "Menús en Barcelona",
        download: "Descargar app",
        support: "Soporte",
        privacy: "Privacidad",
        terms: "Términos",
      },
    },
    supportPage: {
      documentTitle: "Soporte | MenúHunter",
      metaDescription:
        "Contacta con el soporte de MenúHunter para cuenta, restaurantes, menús, suscripción o problemas con la app.",
      title: "Soporte",
      intro:
        "Contacta con MenúHunter para problemas de cuenta, gestión de restaurante, menús, suscripción o la aplicación. La forma más rápida es desde la app; también puedes escribirnos por correo si no puedes usarla.",
      emailEyebrow: "Correo",
      emailTitle: "Escríbenos",
      emailBody:
        "Para ayuda con tu cuenta, un restaurante, un menú, la suscripción o la app, escríbenos a:",
      emailCta: "Enviar correo a soporte",
      appEyebrow: "En la app",
      appTitle: "Soporte desde MenúHunter",
      appIntro: "La forma recomendada de contactar con nuestro equipo:",
      appStep1: "Abre MenúHunter en tu móvil.",
      appStep2: "Ve a la pestaña Perfil (ajustes de tu cuenta).",
      appStep3: "Toca Soporte, junto a Privacidad y Términos.",
      appDetail:
        "Después, elige el tipo de incidencia, añade un título y una descripción, y opcionalmente adjunta hasta 3 capturas antes de enviar la solicitud.",
      mockupAlt: "Pantalla de contacto con soporte en la app MenúHunter",
      mockupImageSrc: "/images/support/in-app-support-es.png",
      includeEyebrow: "Qué incluir",
      includeTitle: "Para ayudarte más rápido",
      includeEmail: "El correo electrónico que usas en la app",
      includeRestaurant: "El nombre del restaurante, si aplica",
      includeScreenshots: "Capturas de pantalla, si son útiles",
      includeDescription: "Una descripción breve del problema",
      issuesEyebrow: "Tipos de incidencia",
      issuesTitle: "Sobre qué puedes escribirnos",
      issueAccount: "Problemas de cuenta",
      issueSubscription: "Suscripción y pagos",
      issueClaiming: "Gestionar un restaurante",
      issueMenu: "Información incorrecta del menú",
      issueTechnical: "Problema técnico",
      issueOther: "Otro",
      fallback:
        "Si no puedes usar la app, en casos excepcionales puedes escribir a soporte@menuhunter.app.",
      downloadHint: "¿Aún no tienes la app?",
      downloadLink: "Descargar MenúHunter",
      footerRestaurantsLink: "Para restaurantes",
    },
    restaurantLanding: {
      invalidLink: "Enlace de restaurante no válido",
      invalidId: "ID de restaurante no válido",
      downloadMenuhunter: "Descargar MenúHunter",
      opening: "Abriendo MenúHunter…",
      redirectHint: "Si la app no se abre, serás redirigido a la tienda de aplicaciones.",
      viewMenuHint: "Para ver el menú de este restaurante, descarga la app MenúHunter.",
      downloadOnAppStore: "Descargar en App Store",
      downloadOnPlay: "Descargar en Google Play",
      seeAllOptions: "Ver todas las opciones de descarga",
    },
    restaurantSharePage: {
      loading: "Cargando restaurante…",
      notFoundTitle: "Restaurante no disponible",
      notFoundBody: "Este enlace no corresponde a un restaurante público o ya no está disponible.",
      ctaHint: "Para alertas y la mejor experiencia, abre MenúHunter en el móvil.",
      openInApp: "Abrir en la app",
      downloadApp: "Descargar MenúHunter",
      claimBanner: {
        headline: "¿Eres el propietario o gestionas este restaurante?",
        subtext: "Descarga la app y gestiona la ficha desde MenúHunter",
        cta: "Gestionar en la app",
      },
      menusHeading: "Menús del día",
      noMenus: "Aún no hay un menú publicado para este restaurante. Vuelve pronto o abre la app para más detalles.",
      viewMenuLink: "Ver menú",
      backHome: "← Volver al inicio",
      errorTitle: "No se pudo cargar",
      errorBody: "Comprueba tu conexión e inténtalo de nuevo.",
      tabMenu: "Menú",
      tabPhotos: "Fotos",
      tabReviews: "Reseñas",
      tabInfo: "Info",
      tabDirections: "Cómo llegar",
      tabClaim: "Gestionar",
      reviewsTabTitle: "Reseñas en la app",
      reviewsTabBody:
        "Las valoraciones y reseñas de comensales están disponibles en MenúHunter para móvil. Descarga la app para leer y dejar opiniones.",
      claimTabIntro:
        "¿Eres el propietario o gestionas este restaurante? Descarga MenúHunter, crea una cuenta y gestiona la ficha desde la app.",
      claimTabButton: "Gestionar en la app",
      categoryDaily: "Menú del Día",
      categoryChristmas: "Navidad ({count})",
      christmasHeading: "Menús de Navidad",
      christmasEmpty: "No hay paquetes de Navidad públicos para este restaurante.",
      christmasUntitled: "Paquete de Navidad",
      christmasPerPerson: "por persona",
      christmasPerPackage: "por menú",
      christmasOpenImages: "Ver fotos del menú",
      christmasBackToRestaurant: "Ver restaurante",
      availability: {
        archived: "Retirado",
        upcoming: "Próximamente",
        available: "Disponible",
        expired: "Caducado",
        season_confirmed: "Temporada confirmada",
        undated_unconfirmed: "Sin fechas",
      },
      viewerClose: "Cerrar",
      viewerPrevious: "Anterior",
      viewerNext: "Siguiente",
      viewerZoomIn: "Ampliar",
      viewerZoomOut: "Reducir",
      viewerBroken: "No se pudo cargar la imagen",
      viewerLoading: "Cargando…",
      viewerOf: "de",
      offeringNotFoundTitle: "Menú de Navidad no disponible",
      offeringNotFoundBody:
        "Este enlace no corresponde a un menú de Navidad público o ya no está disponible.",
      offeringWithdrawn: "Este paquete ya no está publicado.",
      offeringDatesRange: "Fechas confirmadas: {from} – {to}",
      offeringDatesFrom: "Desde {from}",
      offeringDatesUntil: "Hasta {to}",
      offeringSeasonLabel: "Temporada: {label}",
    },
    verifyClaim: {
      loadingTitle: "Verificando tu solicitud...",
      loadingMessage: "Espera mientras verificamos tu correo electrónico.",
      successTitle: "¡Correo verificado!",
      successMessage: "Gracias — tu correo está verificado. Ya puedes gestionar tu restaurante en la app de MenúHunter.",
      successTeamMessage: "",
      viewInApp: "",
      openApp: "Abrir app MenúHunter",
      viewOnWeb: "Ver en la web",
      errorTitle: "Verificación fallida",
      errorMissingToken: "Falta el enlace de verificación.",
      errorInvalidToken:
        "Enlace no válido, caducado o sustituido por uno nuevo. Si pediste otro correo de verificación, usa solo el enlace del mensaje más reciente.",
      errorRpcFailure: "No se pudo completar la verificación por un error del servidor. Inténtalo de nuevo más tarde.",
      errorClaimNotFound: "No se encontró la solicitud asociada a este enlace.",
      errorVerificationFailed: "La verificación falló. El enlace puede haber caducado o ya haberse usado.",
      errorPaymentNotStarted: "El pago no ha comenzado. Vuelve a la app para completar el pago y luego verifica tu correo.",
      errorGeneric: "Ocurrió un error durante la verificación.",
      errorServerError: "Ha ocurrido un error en el servidor. Inténtalo de nuevo más tarde.",
      resendTitle: "Reenviar correo de verificación",
      emailLabel: "Correo electrónico",
      emailPlaceholder: "tu@email.com",
      resendButton: "Reenviar correo de verificación",
      resendSending: "Enviando...",
      resendSent:
        "¡Correo enviado! Revisa tu bandeja de entrada. Si ya habías pedido otro, solo el último mensaje tiene un enlace válido.",
      resendSectionHint:
        "Si pides un correo nuevo, los enlaces antiguos dejan de funcionar. Abre siempre el enlace del mensaje más reciente.",
      resendNoClaim: "No hay ninguna solicitud con este correo.",
      resendError: "Error al reenviar el correo.",
      loadingFallback: "Cargando...",
      closeTab: "Puedes cerrar esta pestaña.",
      emailRequired: "El correo electrónico es obligatorio",
    },
    admin: {
      dashboard: "Panel de Administración",
      logout: "Cerrar Sesión",
      navGroups: {
        dashboard: "Panel",
        dailyOperations: "Operaciones diarias",
        accountsAccess: "Cuentas y accesos",
        geographyRecords: "Geografía y registros",
        batchContentTools: "Herramientas de contenido por lotes",
      },
      tabs: {
        metrics: "Métricas",
        reviewMenus: "Revisión de menús",
        coverage: "Cobertura",
        citiesListing: "Ciudades del selector",
        users: "Usuarios y roles",
        restaurantLifecycle: "Ciclo de vida",
        onboarding: "Operaciones de prueba",
        photos: "Moderación de fotos",
        pushNotifications: "Notificaciones push",
        feedback: "Feedback de producto",
        supportTickets: "Tickets de soporte",
        interviews: "Entrevistas de campo",
        founderAccess: "Acceso founder",
        complimentaryPro: "Pro gratuito",
        promoCodes: "Códigos promocionales",
        restaurants: "Búsqueda de restaurantes",
        map: "Mapa de cobertura",
        areaDensity: "Densidad por zona (5 km)",
      },
      coveragePage: {
        title: "Densidad de área (5 km)",
        subtitle:
          "Análisis avanzado por celdas geográficas (~5 km). Útil para expansión local; no sustituye la puntuación de activación de ciudad en Cobertura y activación de ciudades.",
      },
      directory: {
        mapTitle: "Mapa de cobertura",
        mapSubtitle:
          "Inspecciona la cobertura geocodificada y previsualiza la oferta por ciudad. Los restaurantes sin coordenadas no aparecen aquí — revísalos en Restaurantes.",
        mapMissingCoordsNote:
          "Los registros sin coordenadas se gestionan desde la búsqueda de Restaurantes.",
        restaurantsSubtitle:
          "Búsqueda y depuración de registros: estado, propietario, asignación de ciudad y acciones admin. Usa Cobertura y activación de ciudades para decisiones de listado.",
        usersSubtitle:
          "Soporte de cuentas, gestión de roles, usuarios deshabilitados y acciones admin a nivel usuario.",
        mapLegendTitle: "Leyenda",
        mapLegendClaimed: "Gestionado",
        mapLegendUnclaimed: "Comunidad / sin gestionar",
        mapLegendHidden: "Oculto o eliminado",
        mapLegendNoMenu: "Sin menú",
        mapViewLifecycle: "Ver en ciclo de vida",
        mapViewOwner: "Ver propietario",
      },
      restaurantsLookup: {
        title: "Búsqueda de restaurantes",
        subtitle:
          "Búsqueda de registros, corrección de visibilidad, asignación de ciudad y acciones admin/debug. Usa Cobertura y activación de ciudades para decisiones de listado y Ciclo de vida del restaurante para flujos comerciales o de reclamación.",
        visibilityFlowNote:
          "Flujo de visibilidad: activo → oculto → eliminado. El borrado permanente es destructivo y solo debe usarse en casos claros de limpieza admin.",
        searchPlaceholder: "Buscar (nombre, dirección, Place ID o UUID del restaurante)…",
        bulkAssignCity: "Asignar ciudad a restaurantes sin ciudad",
        bulkAssignModalTitle: "Asignar ciudad a restaurantes sin ciudad",
        bulkAssignModalWarning:
          "Acción global de mantenimiento. Actualiza todos los restaurantes con ciudad vacía, no solo las filas visibles en esta tabla.",
        bulkAssignTypeConfirm: "Escribe ASSIGN CITY para confirmar",
        badgeMissingCoords: "Sin coordenadas",
        badgeNoCity: "Sin ciudad",
        badgeNoMenus: "Sin menús",
        filteredByOwner: "Filtrado por propietario",
        clearOwnerFilter: "Quitar filtro de propietario",
        navigate: "Navegar",
        viewPublicPage: "Ver página pública",
        previewOnMap: "Ver en mapa de cobertura",
        cityActivation: "Ciudades del selector",
        restaurantLifecycle: "Ciclo de vida del restaurante",
        entitlementsDebug: "Depuración de permisos",
        ownerAccount: "Cuenta del propietario",
        maintenance: "Mantenimiento",
        visibility: "Visibilidad",
        destructive: "Destructivo",
        hardDeleteHelper:
          "El borrado permanente elimina el registro del restaurante. Solo para casos claros de limpieza admin.",
        confirmCityTitle: "¿Cambiar la ciudad asignada?",
        confirmCityBody:
          "Afecta el filtrado admin, el análisis de cobertura y la revisión de activación de ciudad. ¿Continuar?",
        paginationPrevious: "Anterior",
        paginationNext: "Siguiente",
        paginationPage: "Página {page} de {totalPages}",
        paginationShowing: "Mostrando {from}–{to} de {total}",
      },
      restaurantLifecycle: {
        title: "Ciclo de vida del restaurante",
        subtitle:
          "Seguimiento de oferta, estado de reclamación, cuentas de pago, cuentas founder y restaurantes reclamados inactivos.",
        queues: {
          outreach: "Cola de outreach",
          claimed_free: "Reclamados Free",
          pro_founder: "Pro y Founder",
          stale_claimed: "Inactivos reclamados",
          billing_attention: "Atención facturación",
        },
        queueLabels: {
          outreach: "Restaurantes de comunidad a contactar",
          claimed_free: "Reclamados, sin Pro",
          pro_founder: "Cuentas de pago o founder",
          stale_claimed: "Reclamados pero inactivos",
          billing_attention: "Problemas de suscripción",
        },
        queueHelp: {
          outreach:
            "Restaurantes sin reclamar con actividad de menús comunitarios. Buenos candidatos para outreach de reclamación.",
          claimed_free:
            "Restaurantes en plan gratuito. Monitoriza actividad e identifica candidatos a upgrade.",
          pro_founder:
            "Restaurantes con entitlement Pro por pago o acceso founder.",
          stale_claimed:
            "Restaurantes reclamados o gestionados sin actividad de menú en vivo en los últimos 30 días.",
          billing_attention: "Restaurantes con discrepancias de suscripción o entitlement.",
        },
        queueSummary: {
          outreach: "{{count}} restaurantes a contactar para reclamación.",
          claimed_free: "{{count}} restaurantes en plan gratuito.",
          pro_founder: "{{count}} cuentas de pago o founder.",
          stale_claimed: "{{count}} restaurantes necesitan actualización de menú o seguimiento.",
          billing_attention: "{{count}} restaurantes con problemas de suscripción.",
        },
        statusBadges: {
          community: "Comunidad",
          high_value: "Alto valor",
          free: "Free",
          pro: "Pro",
          founder: "Founder",
          stale: "Inactivo",
          billing_issue: "Facturación",
          active: "Activo",
        },
        staffActions: {
          claim_outreach: "Invitar a reclamar",
          stale_follow_up: "Pedir actualización de menú",
          check_billing: "Revisar facturación",
          founder_monitor: "Monitorizar cuenta founder",
          publish_menu: "Necesita menú publicado",
          no_action: "Sin acción",
        },
        filters: {
          search: "Buscar",
          searchPlaceholder: "Nombre, ciudad, email…",
          city: "Ciudad",
          provider: "Proveedor",
          all: "Todos",
        },
        table: {
          restaurant: "Restaurante",
          status: "Estado",
          activity: "Actividad",
          contact: "Contacto",
          nextStep: "Siguiente paso",
          actions: "Acciones",
          noLiveMenus: "Sin menús en vivo",
          menuSummary: "{{count}} menú · {{community}} comunidad / {{owner}} propietario",
          menuSummaryPlural: "{{count}} menús · {{community}} comunidad / {{owner}} propietario",
          noOwnerContact: "Sin contacto del propietario",
          claimed: "Reclamado",
          unclaimed: "Sin reclamar",
          empty: "Ningún restaurante en esta cola coincide con los filtros.",
          showing: "Mostrando {{shown}} de {{total}}",
          showMore: "Mostrar más",
          details: "Detalles",
          hideDetails: "Ocultar detalles",
        },
        details: {
          planKey: "Clave de plan",
          providerStatus: "Proveedor / estado",
          liveMenus: "Menús en vivo",
          communityMenus: "Menús comunidad",
          ownerMenus: "Menús propietario",
          lastMenuAt: "Último menú",
          claimStatus: "Estado de reclamo",
          commercialSegment: "Segmento comercial",
          operationalStatus: "Estado operativo",
          billingWarning: "Aviso sync facturación",
        },
        links: {
          openRestaurant: "Abrir restaurante",
          entitlements: "Entitlements",
          founder: "Founder access",
          copyEmail: "Copiar email",
          emailCopied: "Email copiado",
        },
      },
      interviews: {
        title: "Entrevistas de campo",
        subtitle:
          "Entrevistas de descubrimiento realizadas desde Field Tools en la app móvil (Restaurant Insights y Consumer Insights).",
        tabs: {
          restaurant: "Restaurantes",
          consumer: "Consumidores",
        },
        metrics: {
          totalActive: "Entrevistas activas",
          thisWeek: "Esta semana",
          test: "Prueba",
          linkedRestaurants: "Con restaurante vinculado",
          topInterviewers: "Entrevistas por miembro del equipo (top 5)",
        },
        filters: {
          search: "Buscar",
          searchPlaceholder: "Restaurante, ciudad, nombre o email del entrevistador…",
          city: "Ciudad",
          cityPlaceholder: "slug de ciudad",
          interviewer: "Entrevistador",
          allInterviewers: "Todos los entrevistadores",
          visibility: "Visibilidad",
          visibilityActive: "Activas",
          visibilityTest: "Prueba",
          visibilityDeleted: "Eliminadas",
          visibilityAll: "Todas",
          apply: "Aplicar filtros",
        },
        table: {
          date: "Fecha",
          respondent: "Restaurante / contexto",
          city: "Ciudad",
          conductedBy: "Realizada por",
          outcome: "Resultado",
          status: "Estado",
          actions: "Acciones",
        },
        unknownInterviewer: "Entrevistador desconocido",
        confirmAccountability:
          "{{type}} · {{respondent}} — realizada por {{interviewer}} el {{date}}.",
        statusActive: "Activa",
        statusTest: "Prueba",
        statusDeleted: "Eliminada",
        view: "Ver",
        markTest: "Marcar prueba",
        unmarkTest: "Quitar prueba",
        deleteInterview: "Eliminar",
        exportCsv: "Exportar CSV",
        empty: "No se encontraron entrevistas.",
        showing: "Mostrando {{shown}} de {{total}}",
        detailTitle: "Detalle de entrevista",
        detailPlaceholder: "Selecciona una entrevista para ver las respuestas completas.",
        detailCompleted: "Completada",
        detailConductedBy: "Realizada por",
        detailConductedById: "UUID",
        detailAppVersion: "Versión de la app",
        detailCity: "Ciudad",
        detailRestaurant: "Restaurante",
        detailDuration: "Duración",
        detailDeleted: "Eliminada",
        detailDeletedBy: "Eliminada por",
        detailAnswers: "Respuestas",
        openRestaurant: "Abrir restaurante",
        close: "Cerrar",
        prevPage: "Anterior",
        nextPage: "Siguiente",
        pageOf: "Página {{page}} de {{total}}",
        csvDownloaded: "CSV descargado.",
        actionSuccess: "Entrevista actualizada.",
        actionFailed: "No se pudo actualizar la entrevista.",
        cancel: "Cancelar",
        confirmMarkTestTitle: "Marcar como prueba",
        confirmMarkTestMessage: "Esta entrevista se excluirá de las métricas operativas y del panel móvil.",
        confirmUnmarkTestTitle: "Quitar marca de prueba",
        confirmUnmarkTestMessage: "Esta entrevista volverá a contarse como entrevista real.",
        confirmDeleteTitle: "Eliminar entrevista",
        confirmDeleteMessage: "Se hará un borrado lógico. La fila permanecerá en la base de datos con motivo de eliminación.",
        deleteReasonTitle: "Motivo de eliminación",
        deleteReasonMessage: "Indica por qué se elimina esta entrevista (obligatorio).",
        deleteReasonPlaceholder: "p. ej. entrevista de prueba del equipo",
        deleteReasonRequired: "El motivo es obligatorio.",
      },
      cities: {
        title: "Ciudades del selector",
        subtitle:
          "Añade o quita ciudades del selector de la app. Con 10 o más restaurantes con menú en vivo, una ciudad queda en alcance para añadirla.",
        subtitleDecision:
          "El listado es manual. Las ciudades con ≥10 menús en vivo aparecen como En alcance; añadir requiere una región GPS.",
        introManualListing:
          "El listado es manual. Nada se añade solo al selector del consumidor.",
        listingPolicyTitle: "Cómo funciona",
        listingPolicyBody:
          "Tres estados simples para el día a día. Los detalles de activación siguen en el panel avanzado abajo.",
        listingPolicyInSelector:
          "En el selector: ya visible en el selector de ciudad de la app. Usa Quitar para ocultarla.",
        listingPolicyScoped:
          "En alcance: ≥10 restaurantes con menú en vivo y aún no listada. Lista para Añadir cuando tenga región GPS.",
        listingPolicyBelow:
          "Por debajo: menos de 10 restaurantes con menú en vivo. No es candidata principal.",
        listingPolicyRegionBlock:
          "Añadir está bloqueado sin una región GPS activa (necesaria para ubicación y cobertura).",
        listingPolicyReady:
          "Ready: al menos 30 restaurantes con menús en vivo, al menos 15 activos en los últimos 30 días, último menú en 7 días y una región de ciudad activa.",
        listingPolicyStrong:
          "Strong: al menos 50 restaurantes con menús en vivo, al menos 25 activos en los últimos 30 días, último menú en 3 días y una región de ciudad activa.",
        listingPolicyHidden:
          "Hidden: menos de 10 visibles, menos de 5 activos en 30 días, sin región, sin menú, último menú de más de 60 días, o bucket other.",
        listingPolicyWatch:
          "Watch: todo lo que está entre Hidden y Ready.",
        listingPolicyAreaDensityNote:
          "La densidad de área es útil para expansión local, pero las decisiones de listado deben usar el estado de activación de ciudad.",
        badgeReadyToList: "Lista para listar",
        badgeReadyToListHelp:
          "Esta ciudad cumple la barra de preparación pero no está listada en los selectores de la app.",
        badgeListedButWeak: "Listada pero débil",
        badgeListedButWeakHelp:
          "Esta ciudad es visible para usuarios pero está por debajo de la barra recomendada de listado.",
        badgeRecommendedHidden: "Ocultar recomendado",
        badgeRecommendedHiddenHelp:
          "Mantener sin listar hasta mejorar oferta, frescura y regiones.",
        badgeWatchStatus: "Watch",
        badgeWatchHelp:
          "En camino o necesita revisión antes de listar.",
        previewOnMap: "Ver en mapa",
        viewRestaurants: "Ver restaurantes",
        expansionWarning:
          "Las nuevas ciudades pueden necesitar soporte en la app y una región GPS para funcionar correctamente de principio a fin.",
        readOnlyBanner:
          "Acceso de solo lectura. Los cambios en ciudades requieren una cuenta admin.",
        activationError:
          "No se pudieron cargar las métricas de activación. Los recuentos y el estado no están disponibles.",
        readinessError:
          "No se pudieron cargar las métricas de preparación. Los recuentos y el estado Ready no están disponibles.",
        summaryListed: "Listadas",
        summaryInSelector: "En el selector",
        summaryScoped: "En alcance (≥10)",
        summaryBelow: "Por debajo",
        summaryNeedsReview: "Revisar",
        summaryReadyToList: "Listas para listar",
        summaryMissingRegion: "Sin región",
        summaryStaleListed: "Listadas obsoletas",
        summaryReadyUnlisted: "Listas sin listar",
        filterAll: "Todas",
        filterInSelector: "En el selector",
        filterScoped: "En alcance",
        filterBelow: "Por debajo",
        filterNeedsReview: "Revisar",
        filterStaleListed: "Listadas obsoletas",
        filterReadyUnlisted: "Listas para listar",
        filterWatch: "Watch",
        filterHidden: "Ocultas",
        filterMissingRegion: "Sin región",
        bucketInSelector: "En el selector",
        bucketScoped: "En alcance",
        bucketBelow: "Por debajo",
        addToSelector: "Añadir",
        removeFromSelector: "Quitar",
        noFilterResults: "Ninguna ciudad coincide con este filtro.",
        columnCity: "Ciudad",
        columnStatus: "Estado",
        columnLiveMenus: "Menús en vivo",
        columnDecision: "Decisión",
        columnActivation: "Activación",
        columnListed: "Listada",
        columnSupply: "Oferta",
        columnFreshness: "Frescura",
        columnRegion: "Región",
        columnActions: "Acciones",
        columnVisible: "Visibles",
        columnActive30d: "Activas 30d",
        columnLastActivity: "Última actividad",
        columnClaimed: "Reclamados",
        columnUploadMix: "Propietario / comunidad 30d",
        columnEnabled: "Habilitada",
        columnPriority: "Prioridad",
        regionOk: "OK",
        regionMissing: "Falta",
        regionCount: "· {n} región",
        noLiveMenus: "Sin menús en vivo",
        staleListedWarning: "Obsoleta",
        reviewPill: "Listada pero débil",
        readyPill: "Lista para listar",
        supplyVisible: "{n} visibles",
        supplyActive30d: "{n} activas 30d",
        systemBucket: "Bucket sistema",
        neverListable: "Nunca listable",
        disabledLabel: "Deshabilitada",
        blockerLowRecentActivity: "Poca actividad reciente",
        blockerNoLiveMenus: "Sin menús en vivo",
        blockerMissingRegion: "Falta región GPS",
        blockerLowClaimRate: "Baja tasa de reclamación",
        blockerLowVisible: "Poca oferta visible",
        blockerLowActive30d: "Poca actividad 30d",
        blockerListedButWeak: "Listada bajo umbral",
        blockerCommunityOnly: "Solo oferta comunitaria",
        detailsButton: "Detalles",
        actionsLabel: "Acciones",
        detailsClaimed: "Reclamados:",
        detailsManaged: "Gestionados:",
        detailsUploadMix: "Propietario / comunidad 30d:",
        detailsActive7d: "Activas 7d:",
        detailsLastMenuAt: "Último menú:",
        okToList: "OK para listar",
        listBlockedNoRegion: "No se puede listar: añade una región GPS activa primero.",
        listBlockedOther: "El bucket “other” no puede listarse en el selector.",
        listAnywayTitle: "¿Añadir ciudad por debajo del umbral?",
        listAnywayMessage:
          "Esta ciudad tiene menos de 10 restaurantes con menú en vivo. Añadirla igual puede mostrar poca oferta en el selector.",
        listAnywayConfirm: "Añadir igualmente",
        disableWhileListedTitle: "¿Deshabilitar ciudad listada?",
        disableWhileListedMessage:
          "Esta ciudad sigue listada en el selector. Considera quitarla de la lista primero.",
        disableWhileListedConfirm: "Deshabilitar igualmente",
        columnEnabledTitle: "Válida internamente (reclamaciones, RPCs)",
        columnListedTitle: "Aparece en el selector de ubicación de la app",
        columnStatusTitle: "Señal de oferta alineada con consumidor; no lista automáticamente",
        addCity: "Añadir ciudad",
        editCity: "Editar ciudad",
        loading: "Cargando…",
        enabledLabel: "Habilitada (válida internamente)",
        listedLabel: "Listada (selector de la app)",
        officialLabel: "Oficial",
        sortPriorityLabel: "Prioridad (menor = primero en selectores)",
        slugLabel: "Slug (minúsculas, URL)",
        labelEn: "Etiqueta (EN) *",
        labelEs: "Etiqueta (ES)",
        labelCa: "Etiqueta (CA)",
        cancel: "Cancelar",
        update: "Actualizar",
        add: "Añadir",
        saving: "Guardando…",
        activationStatus: {
          strong: "Strong",
          ready: "Ready",
          watch: "Watch",
          hidden: "Oculta",
        },
        statusListed: "Listada",
        statusReady: "Ready",
        statusHidden: "Oculta",
        statusUnknown: "—",
        yes: "Sí",
        no: "No",
        enable: "Habilitar",
        disable: "Deshabilitar",
        list: "Listar",
        unlist: "Quitar de lista",
        edit: "Editar",
        cityUpdated: "Ciudad actualizada.",
        cityAdded: "Ciudad añadida.",
        cityEnabled: "Ciudad habilitada.",
        cityDisabled: "Ciudad deshabilitada.",
        cityListed: "Ciudad añadida al selector.",
        cityUnlisted: "Ciudad quitada del selector.",
        slugRequired: "Slug y etiqueta en inglés son obligatorios.",
        loadFailed: "Error al cargar ciudades:",
        reasonLabels: {
          other_never_listable: "Other nunca es listable",
          visible_lt_10: "Menos de 10 restaurantes visibles",
          active_30d_lt_5: "Menos de 5 restaurantes activos en 30d",
          no_region: "Sin región GPS",
          no_live_menus: "Sin menús en vivo",
          stale_60d: "Última actividad hace más de 60 días",
          visible_lt_30: "Menos de 30 restaurantes visibles",
          active_30d_lt_15: "Menos de 15 restaurantes activos en 30d",
          last_activity_older_than_7d: "Última actividad hace más de 7 días",
        },
        warningLabels: {
          listed_but_hidden: "Listada pero recomendada oculta",
          listed_but_watch: "Listada pero en watch",
          ready_but_unlisted: "Ready pero no listada",
          strong_but_unlisted: "Strong pero no listada",
          missing_region: "Falta región GPS",
          community_only_supply: "Solo oferta comunitaria",
          low_claim_rate: "Baja tasa de reclamación",
        },
        expansionTitle: "Oportunidades de expansión",
        expansionSubtitle:
          "Clusters de cobertura que pueden necesitar ciudad, región o backfill antes de activarse.",
        expansionExpand: "Mostrar",
        expansionCollapse: "Ocultar",
        expansionError: "No se pudieron cargar las oportunidades de expansión.",
        expansionLoading: "Cargando oportunidades…",
        expansionNoResults: "Ningún cluster coincide con este filtro.",
        clusterNearLabel: "Cluster cerca de {lat}, {lng}",
        oppFilterActionable: "Accionables",
        oppFilterReadyForReview: "Listas para revisión",
        oppFilterNeedsRegion: "Necesitan región",
        oppFilterNeedsBackfill: "Necesitan backfill",
        oppFilterNeedsCity: "Necesitan ciudad",
        oppFilterAll: "Ver todas",
        oppSummaryTotal: "{n} total",
        oppSummaryReady: "{n} listas para revisión",
        oppSummaryRegion: "{n} necesitan región",
        oppSummaryBackfill: "{n} necesitan backfill",
        oppSummaryCity: "{n} necesitan ciudad",
        oppColumnArea: "Zona",
        oppColumnSupply: "Oferta",
        oppColumnFreshness: "Frescura",
        oppColumnSetup: "Configuración",
        oppColumnLocation: "Ubicación",
        oppColumnVisible: "Visibles",
        oppColumnActive30d: "Activas 30d",
        oppColumnLastActivity: "Última actividad",
        oppColumnLinkedCity: "Ciudad vinculada",
        oppColumnRegion: "Región",
        oppColumnStatus: "Estado",
        oppViewCoverage: "Avanzado: densidad de área",
        oppAreaDensityHelp:
          "La densidad de área es un drill-down de expansión local (~5 km). No es la puntuación principal de listado de ciudad.",
        oppCopySlug: "Copiar slug",
        oppOpenCity: "Abrir ciudad",
        oppCopiedSlug: "Copiado al portapapeles.",
        oppCopyFailed: "No se pudo copiar.",
        deleteCity: "Eliminar ciudad",
        deleteCityTitle: "¿Eliminar ciudad {slug}?",
        deleteCityMessage:
          "Solo elimina la fila del registro de ciudades. Está permitido porque la ciudad está deshabilitada, no listada, no tiene región y no tiene oferta visible.",
        deleteCityConfirm: "Eliminar",
        cityDeleted: "Ciudad eliminada.",
        cannotDeleteCity: "No se puede eliminar la ciudad",
        dismissOpportunity: "Descartar",
        dismissOpportunityTitle: "¿Descartar esta oportunidad?",
        dismissOpportunityMessage:
          "Oculta el cluster de cobertura del panel de oportunidades. No elimina restaurantes, menús ni datos de ciudad.",
        dismissOpportunityConfirm: "Descartar",
        opportunityDismissed: "Oportunidad descartada.",
        showDismissed: "Ver descartadas",
        hideDismissed: "Ocultar descartadas",
        dismissedEmpty: "No hay oportunidades descartadas.",
        opportunityStatus: {
          needs_city: "Necesita ciudad",
          needs_region: "Necesita región",
          needs_backfill: "Necesita backfill",
          watch: "Watch",
          ready_for_review: "Lista para revisión",
        },
        opportunitySetup: {
          needs_city: "Necesita ciudad",
          needs_region: "Necesita región",
          needs_backfill: "Necesita backfill",
          watch: "Poca actividad",
          ready_for_review: "Lista para revisión",
        },
        opportunityReasons: {
          no_linked_city: "Sin ciudad vinculada",
          missing_region: "Falta región GPS",
          misassigned_restaurants: "Restaurantes mal asignados",
          other_bucketed: "Restaurantes en other",
          low_visible: "Pocos visibles",
          low_active_30d: "Poca actividad 30d",
          ready_supply: "Oferta cumple umbral ready",
        },
      },
      metrics: {
        title: "Panel de Métricas",
        kpi: {
          availableRestaurants: "Restaurantes visibles",
          publishedCapturesAllTime: "Capturas publicadas (total)",
          menus24h: "Menús (24h)",
          menus7d: "Menús (7d)",
          menus30d: "Menús (30d)",
          users: "Usuarios",
          unavailable: "No disponible",
        },
        charts: {
          menusOverTime: "Menús Agregados en el Tiempo",
          menusTooltip: "Menús",
        },
        filters: {
          day: "Día",
          week: "Semana",
          month: "Mes",
          to: "a",
        },
        empty: {
          noDataForRange: "No hay datos disponibles para el rango de fechas seleccionado",
          loading: "Cargando datos del gráfico...",
        },
      },
      review: {
        title: "Revisar Menús",
        help: "Ayuda",
        queue: {
          title: "Cola de Revisión",
          searchPlaceholder: "Buscar restaurantes...",
          noMenusFound: "No se encontraron menús",
          selectMenu: "Selecciona un menú para revisar",
        },
        status: {
          all: "Todos",
          unverified: "Pendiente de Revisión",
          verified: "Revisado",
          needsFix: "Necesita Corrección",
        },
        photo: {
          title: "Foto del Menú",
          resetZoom: "Restablecer Zoom",
          noPhoto: "No hay foto disponible",
        },
        preview: {
          title: "Vista Previa de la App",
          description: "Esto muestra exactamente cómo los clientes verán el menú en la app.",
          noContent: "No hay contenido del menú disponible",
        },
        editor: {
          title: "Estructura del Menú",
          importOcr: "Importar OCR al editor",
          unsavedChanges: "Cambios sin guardar",
          saved: "Guardado",
          menuDate: "Fecha del Menú",
          priceEur: "Precio (EUR)",
          internalNote: "Nota Interna",
          sectionsItems: "Secciones y Elementos",
          addSection: "+ Agregar Sección",
          sectionName: "Nombre de la sección",
          addItem: "+ Agregar Elemento",
          itemName: "Nombre del elemento",
          description: "Descripción (opcional)",
          noSections: "Aún no hay secciones. Haz clic en \"Agregar Sección\" para comenzar.",
        },
        ocrDetails: {
          title: "Detalles OCR",
          menuTextRaw: "menu_text_raw",
          menuTextEdited: "menu_text_edited",
          dishesExtracted: "dishes_extracted",
          empty: "(vacío)",
        },
        metadata: {
          title: "Metadatos del Menú",
          includesBread: "Incluye Pan",
          includesDrink: "Incluye Bebida",
          dessertCoffeeOption: "Opción Postre/Café",
          notSpecified: "No especificado",
          dessert: "Postre",
          coffee: "Café",
          both: "Ambos",
          neither: "Ninguno",
          servingDays: "Días de servicio",
          weekdaysOnly: "Solo Días Laborables",
          everyDay: "Todos los días",
          saturdayOnly: "Solo sábado",
          sundayOnly: "Solo domingo",
          weekendsOnly: "Solo fines de semana",
          startHour: "Hora de Inicio (24h)",
          endHour: "Hora de Fin (24h)",
          cuisineType: "Tipo de Cocina",
          customCuisineType: "Tipo de Cocina Personalizado",
          notes: "Notas",
          notesPlaceholder: "Notas adicionales...",
        },
        actions: {
          save: "Guardar",
          saving: "Guardando...",
          needsFix: "Necesita Corrección",
          markReviewed: "Marcar como Revisado",
          shortcuts: "Atajos: j/k navegar, r=revisado, f=necesita corrección, Ctrl/Cmd+S=guardar",
        },
        tooltips: {
          photo: "La foto original del menú capturada por usuarios. Verifica que:\n• La foto es clara y legible\n• Coincide con el nombre del restaurante\n• Todos los elementos del menú son visibles\n• La fecha del menú es correcta\n\nUsa la rueda del mouse para hacer zoom, haz clic y arrastra para desplazarte cuando esté ampliado.",
          restaurant: "Verifica que este nombre de restaurante coincida con la foto del menú. Si el nombre no coincide, marca el menú como 'Necesita Corrección' con una nota explicando la discrepancia.",
          preview: "Esto muestra exactamente cómo los clientes verán el menú en la app. Usa esto para verificar que todas las correcciones que hagas se mostrarán correctamente.",
          menuDate: "La fecha para la cual este menú es válido. Verifica que coincida con la fecha mostrada en la foto. Esto ayuda a los clientes a saber si el menú es actual.",
          price: "El precio total del menú en euros. Verifica que coincida con lo mostrado en la foto. Verifica errores de punto decimal (ej., 12.50 vs 125.00).",
          sections: "Organiza los elementos del menú en secciones (ej., Primeros, Segundos, Postres). Cada elemento debe tener:\n• Un nombre claro y preciso\n• Descripción opcional\n• Ortografía correcta y caracteres especiales\n\nVerifica que los elementos coincidan con la foto y estén en las secciones correctas.",
          sectionName: "Los nombres de las secciones agrupan elementos relacionados (ej., 'Primeros', 'Segundos', 'Postres'). Verifica que la agrupación coincida con la estructura del menú en la foto.",
          itemName: "Nombre del elemento del menú. Verifica la ortografía, caracteres especiales (ñ, é, ü), y que coincida con lo mostrado en la foto. Errores comunes de OCR: confusión de caracteres (0/O, 1/I, 5/S).",
          save: "Guarda tus cambios sin cambiar el estado de revisión. Los cambios se guardan automáticamente cada 2 segundos, pero puedes guardar manualmente en cualquier momento. Usa Ctrl/Cmd+S como atajo.",
          needsFix: "Marca este menú como que necesita correcciones cuando:\n• La foto está demasiado borrosa o ilegible\n• El nombre del restaurante no coincide\n• Faltan elementos críticos\n• La extracción OCR está demasiado incompleta\n\nSiempre agrega una nota explicando qué necesita corregirse.",
          reviewed: "Aprueba este menú cuando:\n• La foto es clara y coincide con el restaurante\n• Todos los elementos están correctamente extraídos\n• Los precios son precisos\n• Las secciones están correctamente organizadas\n• Cualquier error de OCR ha sido corregido\n\nEsto hace que el menú sea visible para los clientes.",
        },
      },
      users: {
        title: "Usuarios y roles",
        subtitle:
          "Usa esta página para soporte de cuentas, gestión de roles, usuarios deshabilitados y acciones admin a nivel usuario.",
        crossLinksNote:
          "Usa Búsqueda de restaurantes para registros, Ciclo de vida del restaurante para flujos comerciales/reclamación, Founder access para grants founder y Entitlements para depuración de facturación/acceso.",
        stateNote:
          "Los usuarios deshabilitados no pueden usar su cuenta mientras estén deshabilitados. Los usuarios eliminados están borrados de forma soft en admin y no se eliminan permanentemente con esta acción.",
        navigate: "Navegar",
        accountActivity: "Actividad de cuenta",
        support: "Soporte",
        accountStatus: "Estado de cuenta",
        rolesSecurity: "Roles y seguridad",
        destructive: "Destructivo",
        linkRestaurantsLookup: "Búsqueda de restaurantes",
        linkRestaurantLifecycle: "Ciclo de vida del restaurante",
        linkFounderAccess: "Founder access",
        linkEntitlements: "Entitlements",
        paginationPrevious: "Anterior",
        paginationNext: "Siguiente",
        paginationPage: "Página {page} de {totalPages}",
        paginationShowing: "Mostrando {from}–{to} de {total}",
        list: {
          searchPlaceholder: "Buscar por email, nombre o UUID de usuario…",
          roleFilter: "Filtrar por rol",
          statusFilter: "Filtrar por estado",
          userTypeFilter: "Filtrar por tipo",
          noUsers: "No se encontraron usuarios",
          columns: {
            user: "Usuario",
            role: "Rol",
            userType: "Tipo",
            status: "Estado",
            created: "Creado",
            lastSeen: "Última Visita",
            actions: "Acciones",
          },
        },
        detail: {
          profile: "Perfil",
          kpis: "KPIs",
          edit: "Editar Usuario",
          auditLog: "Registro de Auditoría",
          kpiLabels: {
            menusCreated: "Menús Creados",
            reviewsCompleted: "Revisiones Completadas",
            flagsReceived: "Reportes Recibidos",
            uploads: "Cargas",
            lastActivity: "Última Actividad",
            days7: "7d",
            days30: "30d",
            total: "Total",
          },
        },
        edit: {
          changeRole: "Cambiar Rol",
          changeUserType: "Cambiar Tipo de Usuario",
          disableAccount: "Deshabilitar Cuenta",
          enableAccount: "Habilitar Cuenta",
          addNote: "Agregar Nota Interna",
          deleteUser: "Eliminar Usuario",
          role: "Rol",
          userType: "Tipo de Usuario",
          name: "Nombre",
          status: "Estado",
          notes: "Notas Internas",
          reason: "Razón",
          confirmDisableTitle: "¿Deshabilitar este usuario?",
          confirmDisableMessage: "Este usuario no podrá usar su cuenta mientras esté deshabilitado.",
          confirmEnableTitle: "¿Habilitar este usuario?",
          confirmEnableMessage: "Este usuario podrá usar su cuenta de nuevo.",
          confirmRoleTitle: "¿Cambiar el rol del usuario?",
          confirmRoleBody:
            "Esto cambia el nivel de acceso del usuario en los flujos admin/app de MenuHunter. ¿Continuar?",
          confirmDelete: "Marca al usuario como eliminado en admin. Escribe DELETE para confirmar:",
          softDeleteUser: "Eliminar (soft)",
          softDeleteHelper:
            "Marca al usuario como eliminado en admin. No es lo mismo que el pipeline de eliminación de cuenta del consumidor.",
          saveRole: "Guardar rol",
          save: "Guardar",
          cancel: "Cancelar",
        },
        status: {
          active: "Activo",
          disabled: "Deshabilitado",
          deleted: "Eliminado",
        },
        roles: {
          admin: "Admin",
          employee: "Empleado",
          staff: "Personal",
          restaurant: "Restaurante",
          user: "Usuario",
        },
        userTypes: {
          consumer: "Consumidor",
          capture: "Captura",
          staff: "Personal",
        },
        auditLog: {
          title: "Registro de Auditoría",
          noLogs: "No hay registros de auditoría disponibles",
          columns: {
            timestamp: "Fecha/Hora",
            actor: "Actor",
            action: "Acción",
            summary: "Resumen",
          },
          actions: {
            user_disable: "Usuario deshabilitado",
            user_enable: "Usuario habilitado",
            user_role_change: "Rol cambiado",
            user_delete: "Usuario eliminado (soft)",
            user_note_update: "Nota actualizada",
            user_type_change: "Tipo de usuario cambiado",
            user_name_update: "Nombre actualizado",
            userDisable: "Usuario deshabilitado",
            userEnable: "Usuario habilitado",
            userRoleChange: "Rol cambiado",
            userDelete: "Usuario eliminado (soft)",
            userNoteUpdate: "Nota actualizada",
          },
        },
        errors: {
          loadFailed: "Error al cargar usuarios",
          updateFailed: "Error al actualizar usuario",
          deleteFailed: "Error al eliminar usuario",
          unauthorized: "No autorizado",
          adminOnly: "Solo administradores pueden realizar esta acción",
        },
      },
      onboarding: {
        title: "Onboarding & Trials",
        kpi: {
          eligibleUnclaimed: "Elegibles No Reclamados",
          claimsPending: "Reclamos Pendientes",
          activeTrials: "Pruebas Activas",
          expiringSoon: "Expiran en 14 Días",
        },
        filters: {
          status: "Estado",
          claimed: "Reclamado",
          all: "Todos",
          claimedOnly: "Reclamado",
          unclaimedOnly: "No Reclamado",
          city: "Ciudad",
          barrio: "Barrio",
          nearEligible: "Cerca de Elegible",
          expiring14Days: "Expiran en 14 Días",
          search: "Buscar restaurante...",
        },
        status: {
          not_started: "No Iniciado",
          near_eligible: "Cerca de Elegible",
          eligible: "Elegible",
          claimed_pending: "Reclamado Pendiente",
          active: "Activo",
          expired: "Expirado",
          converted: "Convertido",
        },
        table: {
          restaurant: "Restaurante",
          location: "Ubicación",
          engagement: "Compromiso (30d)",
          progress: "Progreso",
          trialStatus: "Estado de Prueba",
          claimed: "Reclamado",
          claimStatus: "Estado de Reclamo",
          trialEnds: "Prueba Termina",
          actions: "Acciones",
          viewDetails: "Ver Detalles",
          openInApp: "Abrir en App",
          menuViews: "Vistas",
          favorites: "Favoritos",
          uploads: "Cargas",
          yes: "Sí",
          no: "No",
          none: "Ninguno",
          pending: "Pendiente",
          approved: "Aprobado",
          rejected: "Rechazado",
        },
        drawer: {
          restaurantInfo: "Información del Restaurante",
          trialInfo: "Información de Prueba",
          claimInfo: "Información de Reclamo",
          managers: "Gerentes",
          engagement: "Compromiso (30 días)",
          triggeredBy: "Desencadenado Por",
          actionButtons: {
            approveClaim: "Aprobar Reclamo",
            startTrial: "Iniciar Prueba",
            copyOutreach: "Copiar Mensaje de Contacto",
          },
          fields: {
            name: "Nombre",
            address: "Dirección",
            googlePlaceId: "Google Place ID",
            restaurantId: "ID del Restaurante",
            status: "Estado",
            started: "Iniciado",
            ends: "Termina",
            triggered: "Desencadenado",
            latestClaim: "Último Reclamo",
            submittedBy: "Enviado Por",
            submittedAt: "Enviado En",
            contactEmail: "Email de Contacto",
            contactName: "Nombre de Contacto",
            user: "Usuario",
            role: "Rol",
            verifiedLevel: "Nivel Verificado",
            menuViews: "Vistas de Menú",
            favorites: "Favoritos",
            uploads: "Cargas",
            closestThreshold: "Umbral Más Cercano",
          },
        },
        empty: {
          noRestaurants: "No se encontraron restaurantes",
          selectRestaurant: "Selecciona un restaurante para ver detalles",
        },
        errors: {
          loadFailed: "Error al cargar datos",
          approveFailed: "Error al aprobar reclamo",
          startTrialFailed: "Error al iniciar prueba",
          copyFailed: "Error al copiar mensaje",
        },
        success: {
          claimApproved: "Reclamo aprobado exitosamente",
          trialStarted: "Prueba iniciada exitosamente",
          messageCopied: "Mensaje copiado al portapapeles",
        },
      },
      trialOps: {
        pageTitle: "Operaciones de prueba",
        rulesHint:
          "La columna Estado muestra un solo estado operativo (primero la suscripción de Stripe; si falta, la fila de prueba en BD). Live/test sigue viniendo de la suscripción sincronizada. Etiquetas pequeñas: Revisar / Necesita sinc = desacuerdo BD/Stripe (detalles en el panel); Legado = onboarding migrado. Usa Desincronizaciones o Solo desincronización para limpieza. Método de pago en caché desde Stripe.",
        stripeMode: {
          label: "Modo Stripe",
          liveOnly: "Solo live",
          testOnly: "Solo test",
          unknownOnly: "Desconocido",
          kpiHint:
            "Por defecto solo Live (oculta suscripciones de prueba). Los KPI y la tabla siguen el filtro de modo Stripe y el conjunto de datos.",
          badgeLive: "Live",
          badgeTest: "Test",
          badgeUnknown: "?",
        },
        scope: {
          label: "Conjunto de datos",
          trialFocus: "Enfoque en prueba",
          allRecords: "Todos los registros",
          kpiHintTrialFocus:
            "Vista inicial: trialing, prueba activa en BD, expirada sin convertir o desincronización BD/Stripe (se ocultan convertidos/pagados salvo desincronización).",
          kpiHintAll:
            "Todos los registros: incluye convertidos y filas sin relevancia de prueba actual.",
          filtersCaption:
            "Los KPI reflejan el conjunto (enfoque vs todos); la vista rápida y los KPI filtran la tabla; la búsqueda y los filtros avanzados solo reducen filas.",
        },
        presets: {
          label: "Vista rápida",
          all: "Todas",
          active: "Activas",
          expiring: "Expiran en 7 días",
          expiredNc: "Expiradas (sin convertir)",
          mismatches: "Desincronizaciones",
          converted: "Convertidas",
          withExtensions: "Con extensiones",
        },
        kpi: {
          activeTrials: "Pruebas activas",
          expiring7d: "Expiran en 7 días",
          expiredNotConverted: "Expiradas, no convertidas",
          converted: "Convertidas a pago",
          avgDaysRemaining: "Días restantes (media)",
          extendedThisMonth: "Pruebas extendidas (este mes)",
        },
        filters: {
          search: "Buscar nombre, email, ciudad…",
          stripeMode: "Modo Stripe",
          operationalStatus: "Estado operativo",
          claimStatus: "Estado del reclamo",
          paymentMethod: "Método de pago",
          plan: "Plan",
          trialSource: "Origen de prueba",
          legacy: "Legado / migrado",
          legacyTooltip:
            "Muestra restaurantes cuyo registro de prueba u onboarding proviene de un flujo anterior o datos migrados, no solo del modelo actual de reclamación.",
          all: "Todos",
          yes: "Sí",
          no: "No",
          unknown: "Desconocido",
          mismatchOnly: "Solo desincronización DB/Stripe",
          mismatchTooltip:
            "Limpieza de datos: filas donde la prueba en BD y la suscripción en Stripe no coinciden. La gravedad (Necesita sinc / Revisar) está en la columna Estado; abre la fila para detalles BD vs Stripe.",
        },
        opStatus: {
          trialActive: "Acceso activo",
          paidActive: "Pago activo",
          expired: "Expirada",
          canceled: "Cancelada",
          unknown: "Desconocido",
        },
        dataQuality: {
          legacy: "Legado",
          needsSync: "Necesita sinc",
          review: "Revisar",
        },
        table: {
          restaurant: "Restaurante",
          city: "Ciudad",
          ownerContact: "Propietario / contacto",
          operationalStatus: "Estado",
          start: "Inicio",
          end: "Fin",
          daysLeft: "Días",
          payment: "Pago",
          extensions: "Ext.",
          promo: "Promo",
          lastActivity: "Última actividad",
          followUp: "Seguimiento",
          actions: "Acciones",
          openRowActions: "Abrir menú de acciones de la fila",
          operationalStatusTooltip:
            "Un solo estado operativo: usa el estado de la suscripción en Stripe (trialing → Prueba activa, active → Pago activo, etc.). Si no hay Stripe, se infiere desde la fila de prueba en BD. Una etiqueta pequeña puede marcar datos legados o un desajuste BD/Stripe (abre la fila para detalles). El modo test/desconocido solo aparece si no es live.",
        },
        payment: {
          yes: "Registrado",
          no: "Ninguno",
          unknown: "Desconocido",
        },
        drawer: {
          title: "Restaurante",
          billing: "Facturación",
          stripeCustomer: "Abrir cliente en Stripe",
          audit: "Historial de extensiones",
          notes: "Notas internas",
          followUp: "Estado de seguimiento",
          saveNotes: "Guardar notas y estado",
          saved: "Guardado",
          loadingAudit: "Cargando historial…",
          noAudit: "Sin extensiones aún.",
          mismatchWarningSoft:
            "Stripe muestra esta suscripción en trialing, pero la fila de prueba en BD sigue en not_started/expirado/convertido. Suele ser retraso de metadatos; los webhooks deberían alinear. El restaurante está en prueba en facturación.",
          mismatchWarningHard:
            "El estado de prueba en BD y el de suscripción en Stripe no coinciden de forma que conviene revisar (p. ej. cancelado/unpaid mientras la BD sigue en prueba activa). Revisa webhooks y facturación.",
          operationalStatusField: "Estado operativo",
          dbTrialRow: "Fila de prueba (BD)",
          billingStatusCached: "Facturación (caché)",
          stripeSubscriptionState: "Suscripción Stripe",
          adminLinksTitle: "Enlaces de administración",
          linkEntitlements: "Depuración de derechos",
          linkRestaurant: "Restaurantes (admin)",
          stripeSubscription: "Suscripción en Stripe",
          stripeEnvironmentLineLive: "Datos Stripe: modo live (producción).",
          stripeEnvironmentLineTest: "Datos Stripe: modo test.",
          stripeEnvironmentLineUnknown:
            "Modo Stripe desconocido (sin sincronizar o fila antigua): confirma en Stripe antes de actuar.",
          stripeLinkHintLive: "Abre el dashboard live de Stripe",
          stripeLinkHintTest: "Abre el dashboard test de Stripe",
          stripeLinkHintUnknown: "Abre dashboard live; confirma el ID en Stripe si hace falta",
          dbTrialEnd: "Fin prueba (DB)",
          stripeTrialEnd: "Fin prueba (Stripe)",
        },
        extend: {
          title: "Extender prueba",
          currentEnd: "Fin actual de prueba",
          preset7: "+7 días",
          preset14: "+14 días",
          preset30: "+30 días",
          custom: "Fecha de fin personalizada",
          reason: "Motivo (obligatorio)",
          internalNote: "Nota interna (opcional)",
          submit: "Aplicar",
          cancel: "Cancelar",
          success: "Fin de prueba actualizado",
          failed: "No se pudo extender la prueba",
        },
        pristineReset: {
          title: "Restablecer prueba a estado inicial",
          warning:
            "Cancela suscripciones en Stripe para este restaurante y borra el historial en BD para que el reclamo vuelva a ver la prueba como nueva. Irreversible en facturación.",
          reason: "Motivo (obligatorio)",
          internalNote: "Nota interna (opcional)",
          submit: "Restablecer",
          cancel: "Cancelar",
          success: "Prueba restablecida",
          failed: "No se pudo restablecer la prueba",
          driftToast:
            "Aún hay filas de suscripción que cuentan para la elegibilidad. Revisa webhooks o la BD.",
          verificationFailed: "Restablecimiento hecho, pero no se pudo verificar el estado en BD.",
          blockedManagedToast:
            "Restablecimiento bloqueado: el restaurante tiene propietario registrado, gestores activos o una suscripción live en estado facturable. Cancelar puede revocar el acceso.",
          blockedSubscription:
            "Hay una suscripción en vivo (trialing, active, past_due o unpaid) en la base de datos.",
          overrideWarning:
            "Anular solo en casos excepcionales. Escribe la frase exacta para confirmar que entiendes el riesgo.",
          overrideToggleLabel: "Anular protección (peligroso)",
          confirmPhraseInstruction:
            "Escribe exactamente: RESET ACTIVE RESTAURANT",
          invalidConfirmation: "Frase de confirmación incorrecta.",
        },
      },
      common: {
        loading: "Cargando...",
        error: "Error",
        noData: "Sin datos",
      },
    },
  },
  en: {
    hero: {
      title: "Find today's menú del día, without the guesswork.",
      subtitle: "Early access is open. Join the first testers discovering menú del día across Spain.",
    },
    earlyAccess: {
      title: "Early bird access (closed MVP)",
      body: "Early access is now open. Join the first testers and help shape MenúHunter.",
      emailPlaceholder: "Your email",
      button: "Join early access",
      platformIos: "iOS",
      platformAndroid: "Android",
      platformAria: "Device platform",
      successTitle: "You're on the list!",
      successWithPlatform:
        "You're on the {{platform}} early access list. We'll email you when your spot is ready, with early access instructions for {{platform}}.",
      existsTitle: "You're already signed up",
      existsWithPlatform:
        "You're already on the list — we've updated your preference to {{platform}}. We'll email you when your spot is ready, with early access instructions for {{platform}}.",
      instagramLabel: "See @menuhunter.app on Instagram",
      instagramButton: "See on Instagram",
      disclaimer: "No spam. Just access updates and news.",
      targetContext: "It looks like you were trying to open an app link. Leave your email and we'll let you know when you can open it from MenúHunter.",
      errorPlatform: "Please select iOS or Android.",
    },
    menuShare: {
      earlyAccessCta: "Early bird access",
      subtitle: "Want to use MenúHunter when we launch?",
    },
    download: {
      ios: "Download for iOS",
      android: "Download for Android",
      appStore: "Download on App Store",
      playStore: "Get it on Google Play",
      scanToDownload: "Scan to download MenúHunter",
      freeOnStores: "Free on Android & iOS",
      orVisit: "Or visit:",
      openInApp: "Open in the MenúHunter app",
      continueOnWeb: "Continue on web",
    },
    common: {
      goHome: "Go to home",
      language: "Language",
      footerNav: "Footer",
      toggleTheme: "Change theme",
      switchToLightMode: "Switch to light mode",
      switchToDarkMode: "Switch to dark mode",
    },
    menuSource: {
      community: "Uploaded by user",
      venue: "Verified by restaurant",
      staff: "MenúHunter team",
    },
    menuFreshness: {
      uploadedToday: "Uploaded today",
      uploadedYesterday: "Uploaded yesterday",
      uploadedHoursAgo: "Uploaded {hours}h ago",
      uploadedDaysAgo: "Uploaded {count} days ago",
      uploadedOnDate: "Uploaded {date}",
    },
    product: {
      explore: "Explore",
      search: "Search",
      capture: "Capture",
      saved: "Saved",
      account: "Account",
      login: {
        title: "Sign in",
        subtitle: "Sign in to save menus and capture photos.",
        emailLabel: "Email",
        passwordLabel: "Password",
        signInButton: "Sign in",
        googleButton: "Continue with Google",
        appleButton: "Continue with Apple",
        browseGuest: "Browse without signing in",
        loading: "Loading…",
        signInErrorGeneric: "Sign-in failed. Please try again.",
        forgotPasswordLink: "Forgot password?",
      },
      forgotPassword: {
        title: "Forgot password?",
        subtitle: "Enter your email and we will send you a link to reset your password.",
        emailLabel: "Email",
        sendButton: "Send reset link",
        sending: "Sending…",
        success:
          "If an account exists for that email, you will receive a reset link shortly. Check your inbox.",
        invalidEmail: "Please enter a valid email address.",
        sendErrorGeneric: "Something went wrong. Please try again.",
        backToLogin: "Back to sign in",
      },
      getApp: "Get the app",
      pwaInstall: {
        title: "Install MenúHunter web app",
        description: "Add MenúHunter to this computer for quick access.",
        install: "Install web app",
        dismiss: "Not now",
      },
      appBanner: "Get the full experience in the MenúHunter app",
      exploreViewportError:
        "We couldn't load menus for this area. Try moving the map or refreshing.",
      accountPage: {
        loading: "Loading…",
        personalSection: "Your account",
        savedMenus: "Saved menus",
        settings: "Settings",
        notifications: "Notification preferences",
        restaurantSectionTitle: "Restaurant panel",
        restaurantSectionHint:
          "Manage your daily menu, restaurant profile, and team.",
        openRestaurantPanel: "Open restaurant panel",
        managingRestaurant: "You manage {name}",
        noRestaurantAccessTitle: "Run a restaurant?",
        noRestaurantAccessBody:
          "Restaurant panel access appears after you claim your venue on MenúHunter or when someone on your team adds you.",
        claimRestaurant: "Claim my restaurant",
        signOut: "Sign out",
      },
      accountSettingsPage: {
        backToAccount: "Back to account",
        loading: "Loading…",
        title: "Settings",
        subtitle: "Customise how MenúHunter looks on the web.",
        themeSection: "Appearance",
        themeLight: "Light",
        themeDark: "Dark",
        themeSystem: "System",
        languageSection: "Language",
        languageEs: "Español",
        languageEn: "English",
        languageCa: "Català",
      },
      accountSavedPage: {
        backToAccount: "Back to account",
        loading: "Loading saved menus…",
        title: "Saved menus",
        subtitle: "Your saved daily menus, ready when you want them again.",
        emptyTitle: "No saved menus yet",
        emptyBody: "Explore menus near you and save the ones you like.",
        exploreCta: "Explore nearby",
      },
      accountNotificationsPage: {
        backToAccount: "Back to account",
        loading: "Loading…",
        title: "Notifications",
        subtitle:
          "Push notifications require the mobile app. These preferences apply when you use the app.",
        nearbyLabel: "New menus near me",
        nearbyHint: "Get notified when a new daily menu is published near your location.",
        favoritesLabel: "Favorite restaurant updates",
        favoritesHint: "Get notified when a saved restaurant publishes a new menu.",
        save: "Save preferences",
        saving: "Saving…",
        saved: "Preferences saved",
      },
    },
    restaurantPanel: {
      shellTitle: "Restaurant panel",
      nav: {
        dashboard: "Dashboard",
        menus: "Menus",
        billing: "Billing",
        team: "Team",
        qrcode: "QR code",
        profile: "Profile",
      },
      home: {
        title: "Restaurant dashboard",
        summaryTitle: "Your restaurant",
        restaurantLabel: "Restaurant",
        statusLabel: "Status",
        performanceTitle: "Performance overview",
        performanceHint:
          "These figures show how diners interact with your menu on MenúHunter.",
        performanceComingSoon:
          "More detailed performance metrics are coming soon.",
        thisWeek: "This week",
        kpiMenuViews: "Menu views (7 days)",
        kpiSaved: "Saved by users",
        kpiNearby: "Nearby restaurants",
        kpiNearbyPrice: "Average nearby price",
        noRestaurant: "You are not managing a restaurant yet.",
        loading: "Loading…",
      },
      status: {
        active: "Active subscription",
        trialActive: "Active access",
        notSubscribed: "No active subscription",
        trialEnded: "Access ended",
        subscriptionInactive: "Subscription inactive",
      },
      menus: {
        title: "Menus",
        subtitle:
          "Manage your menú del día photos. The current menu is what diners see on MenúHunter.",
        addMenu: "Add menu photo",
        view: "View",
        viewMenu: "View menu",
        emptyTitle: "No menus yet",
        emptyBody:
          "Upload a photo of your board or menú del día so nearby diners can find you.",
        emptyCta: "Upload first menu",
        noRestaurant: "You are not managing a restaurant yet.",
        loading: "Loading menus…",
        menuFallbackTitle: "Menu",
        currentBadge: "Current",
        verification: {
          verified: "Published",
          pending: "Under review",
          needsFix: "Needs changes",
          unknown: "Unknown status",
        },
      },
      billing: {
        title: "Billing",
        subtitle: "View your subscription status and manage payments securely.",
        summaryTitle: "Your subscription",
        planLabel: "Plan",
        planMonthly: "Monthly",
        planAnnual: "Annual",
        trialEndsLabel: "Access continues until",
        renewsOnLabel: "Renews on",
        accessUntilLabel: "Access until",
        cancelScheduledBadge: "Cancellation scheduled",
        statusPastDue: "Payment overdue",
        noSubscriptionBody:
          "You do not have an active subscription. Subscribe in the MenúHunter app or contact support if you need help.",
        loading: "Loading billing…",
        appleTitle: "iPhone subscription",
        appleBody:
          "This subscription was purchased in the iOS app. It cannot be managed on the web via the payment portal.",
        appleManageHint:
          "Manage your subscription on the platform where you purchased it: Settings → Apple ID → Subscriptions on your iPhone.",
        portalTitle: "Manage in the app",
        portalHint:
          "Google Play Pro subscriptions are managed in the MenúHunter app or in Google Play → Subscriptions.",
        manageSubscription: "Open MenúHunter app",
        opening: "Opening…",
        portalUnavailable:
          "Web Stripe billing is retired. Manage Pro in the app (App Store or Google Play).",
        signInAgain: "Please sign in again to manage billing.",
        noPermission: "You do not have permission to manage billing for this restaurant.",
        noBillingAccount: "No billing account is linked to this restaurant yet.",
        noRestaurant: "You are not managing a restaurant yet.",
      },
      team: {
        title: "Team",
        subtitle: "See who can manage your restaurant from the MenúHunter panel.",
        contextTitle: "Your restaurant",
        restaurantLabel: "Restaurant",
        accessTitle: "Team access",
        accessBody:
          "People with team access can update your menu, restaurant profile, and other settings in the panel. Only give access to people who actually run the venue.",
        membersTitle: "People with access",
        membersHint: "These accounts can sign in to your restaurant panel.",
        emptyTitle: "Just you for now",
        emptyBody:
          "When more people are given access, they will appear here with their email and access level.",
        memberFallback: "Team member",
        joinedLabel: "On the team since {date}",
        manageNote:
          "To invite or remove people from your team, use the MenúHunter app on your phone.",
        noRestaurant: "You are not managing a restaurant yet.",
        loading: "Loading team…",
        roles: {
          owner: "Owner",
          manager: "Manager",
          staff: "Staff",
          unknown: "Access",
        },
      },
      qr: {
        title: "QR code",
        subtitle: "Take diners straight to your menu page on MenúHunter.",
        contextTitle: "Your restaurant",
        restaurantLabel: "Restaurant",
        aboutTitle: "What it is for",
        aboutBody:
          "When someone scans the code, they open your restaurant’s public page with your latest daily menu.",
        usesTitle: "Where to use it",
        useTables: "On tables or table tents",
        useWindows: "In the window or on the door",
        useFlyers: "On printed posters or flyers",
        useSocial: "On social media or WhatsApp",
        scanHint: "Print the code or show it on a screen so guests can scan it with their phone camera.",
        linkTitle: "Public link",
        linkHint: "Share this link if you prefer not to use a QR code.",
        copyLink: "Copy link",
        linkCopied: "Link copied",
        copyFailed: "Could not copy the link",
        openPublicPage: "Open public page",
        noRestaurant: "You are not managing a restaurant yet.",
        loading: "Loading…",
        alt: "Restaurant QR code",
        stickerLangLabel: "Sticker language",
        langEs: "ES",
        langCa: "CA",
        downloadSvg: "Download SVG",
        downloadPng: "Download PNG",
        downloadPdf: "Download PDF",
        layoutLabel: "Sheet layout",
        cutLines: "Cut marks",
        downloading: "Downloading…",
        downloadFailed: "Could not download the file",
        partnerTitle: "Order stickers",
        partnerBody:
          "Order printed stickers from our partner with the MenúHunter design ready to print.",
        partnerOrder: "Order stickers",
        partnerCopyCode: "Copy code",
        partnerCodeCopied: "Code copied",
        partnerRecommendedLayout: "Recommended layout",
      },
      profile: {
        title: "Restaurant profile",
        subtitle:
          "This information appears on your restaurant’s public page on MenúHunter.",
        basicSection: "Basic information",
        nameLabel: "Restaurant name",
        nameHint: "The name diners see when they find your venue.",
        namePlaceholder: "e.g. Bar La Plaza",
        addressLabel: "Address",
        addressHint: "Helps place your restaurant on the map and in search.",
        addressPlaceholder: "Street, number, city…",
        publicPageLabel: "Public page",
        publicPageHint: "How diners see your restaurant on the web.",
        viewPublicPage: "View public page",
        save: "Save changes",
        saving: "Saving…",
        saved: "Changes saved",
        saveError: "Could not save changes. Please try again.",
        loading: "Loading profile…",
        noRestaurant: "You are not managing a restaurant yet.",
        missingNameHint: "Add your restaurant name so diners can recognise you.",
        missingAddressHint: "An address helps show your venue on the map.",
      },
      common: {
        emDash: "—",
        loading: "Loading…",
      },
    },
    communityCta: {
      compactPrefix: "Seen a menu?",
      compactLink: "Upload it in 10 seconds",
      compactSuffix: "and help keep the menus near you fresh.",
      bannerTitle: "Seen a menu? Upload it in 10 seconds.",
      bannerBody:
        "With the MenúHunter app you can help keep the daily menus in your city up to date — we're starting in Barcelona. No payment promises: just community.",
      bannerLink: "Download the app →",
    },
    menuDetailPage: {
      loading: "Loading menu…",
      notFoundTitle: "Menu not found",
      notFoundBody: "The menu you're looking for doesn't exist or has been removed.",
      backHome: "Back to home",
      openAppPrompt:
        "Open this menu in MenúHunter to see more details and save favorites.",
      openInApp: "Open in the app",
      downloadApp: "Download the app",
      menuOfTheDay: "Menu of the day",
      tagsLabel: "Tags",
      allergensLabel: "Allergens",
      menuTextUnavailableShort: "Menu text not available yet.",
      menuTextUnavailableLong:
        "Menu text not available yet, but you can view the uploaded menu image.",
      photoAlt: "Menu from {name}",
      viewRestaurant: "View restaurant",
    },
    explorePage: {
      title: "Menus nearby",
      nearMe: "Near me",
      searchThisArea: "Search this area",
      updating: "Updating…",
      menuFoundOne: "1 menu found",
      menuFoundMany: "menus found",
      recentUploadOne: "1 uploaded recently",
      recentUploadMany: "uploaded recently",
      onMapOne: "1 restaurant on the map",
      onMapMany: "restaurants on the map",
      recentShortOne: "1 recent",
      recentShortMany: "recent",
      onMapShort: "on map",
      listedRestaurants: "Listed restaurants",
      noMenuRestaurants: "Restaurants without a menu",
      listedRestaurant: "Listed restaurant",
      viewMenu: "View menu",
      viewRestaurant: "View restaurant",
      viewMenuWithName: "View menu —",
      viewRestaurantWithName: "View restaurant —",
      restaurant: "Restaurant",
      adjustListPanel: "Adjust list panel",
      loading: "Loading…",
      emptyTitle: "No restaurants in this area",
      emptyBody: "Try zooming out, moving to another area, or enabling your location with “Near me”.",
      listedOnlyHint:
        "No captured menus in this area. These restaurants appear on the map as listed only.",
      hideNoMenu: "Hide restaurants without a menu",
      showNoMenu: "Show restaurants without a menu",
      restaurantFallback: "Restaurant",
      restaurantMarkerAria: "Restaurant",
      menuPriceAria: "Menu price: {price}",
      loadingMap: "Loading map…",
      mapLoadError: "Failed to load Google Maps",
      mapUnavailable: "Map is temporarily unavailable.",
      mapListStillAvailable: "The restaurant list is still available.",
      closeSelectedDetail: "Close details",
      drawerDetails: "Details",
      drawerMenuDelDia: "Menú del día",
      drawerLastUpload: "Last upload",
      drawerIncludes: "Includes",
      drawerIncludeDrink: "Drink",
      drawerIncludeBread: "Bread",
      drawerIncludeDessert: "Dessert",
      drawerIncludeCoffee: "Coffee",
      drawerNotes: "Notes",
      drawerDishes: "Dishes",
      drawerDishesHint: "Open the full menu to see all dishes.",
      drawerNoDishesHint: "Full dish list is on the menu page.",
    },
    searchPage: {
      title: "Search",
      placeholder: "Search restaurants or areas",
      locationHint:
        "Searching near Barcelona by default. Use Explore → Near me for your location.",
      loading: "Searching…",
      emptyTitle: "No results found",
      emptyBody: "Try another restaurant, neighbourhood, or area.",
    },
    features: {
      realMenus: {
        title: "Real Menus",
        description: "See actual menu photos captured daily from restaurants near you.",
      },
      locationBased: {
        title: "Location-Based",
        description: "Find restaurants and menus based on your current location.",
      },
      dailyUpdates: {
        title: "Daily Updates",
        description: "Menus are updated daily so you always see what's available today.",
      },
    },
    staff: {
      question: "Are you staff?",
      login: "Log in to admin panel",
    },
    footer: {
      copyright: "MenúHunter™. All rights reserved.",
    },
    scan: {
      hero: {
        headline: "Discover today's Menú del Día near you",
        subheadline: "Find nearby lunch deals, browse today's dishes and prices, and choose where to eat in seconds.",
        desktopHelper: "Open this on your phone to download",
        links: {
          exploreMenus: "Explore daily menus",
          interactiveMap: "View interactive map",
          restaurants: "For restaurants",
        },
      },
      cta: {
        appStore: "Download on the App Store",
        googlePlay: "Get it on Google Play",
      },
      trust: {
        free: "Free to use",
        barcelona: "Growing daily",
        updated: "Updated regularly",
        pills: [
          "Free for users",
          "iPhone and Android",
          "Real menus",
          "Updated daily",
          "Verified restaurants",
        ],
      },
      howItWorks: {
        title: "How it works",
        find: "Find nearby menus",
        see: "See prices and dishes",
        save: "Save your favourites",
      },
      value: {
        title: "Why MenúHunter",
        updated: "Updated regularly",
        barcelona: "Built for menu hunters in Spain",
        fast: "Fast way to compare nearby lunch options",
      },
      showcase: {
        title: "See it in action",
        subtitle: "Menus on the map, today's dishes, and favourites — all in one app.",
        map: "Map",
        menus: "Menus",
        today: "Today",
      },
      benefits: {
        eyebrow: "For diners",
        title: "Everything you need to choose",
        find: {
          title: "Nearby menus",
          desc: "Find lunch deals around you and compare in seconds.",
        },
        map: {
          title: "Explore menus on the map",
          desc: "Find restaurants and menus by area and choose with the map.",
        },
        dishes: {
          title: "Real dishes and prices",
          desc: "See today's menu and prices before you decide.",
        },
        featured: {
          title: "Featured menus",
          desc: "Discover featured and recommended options nearby.",
        },
        latest: {
          title: "Latest uploads",
          desc: "Check the latest daily menu updates.",
        },
        favourites: {
          title: "Save favourites",
          desc: "Save your favourite spots and decide faster.",
        },
      },
      neighbourhoods: {
        eyebrow: "Browse by area",
        title: "Explore by neighbourhood",
        subtitle: "Discover the best set lunch menus in each neighbourhood.",
      },
      owner: {
        eyebrow: "For restaurants",
        headline: "Want your restaurant on MenúHunter?",
        intro: "MenúHunter helps people nearby discover your daily menu, prices and dishes. Restaurant claim tools are coming soon, but for now the best way to understand the platform is to download the app and see how restaurants appear to nearby diners.",
        benefit1: "See how menus appear to nearby diners",
        benefit2: "Discover how restaurants are listed on the map",
        benefit3: "Keep your menu visible to people looking for lunch nearby",
        benefit4: "Restaurant claim tools are coming soon",
      },
      sections: {
        nearby: {
          title: "Nearby menus",
          desc: "Find menus near you, see what's available around you, and compare options quickly.",
        },
        dishes: {
          eyebrow: "Menu detail",
          title: "Dishes and prices",
          desc: "See today's dishes and prices before you choose.",
          bullet1: "Real dishes and prices for the day",
          bullet2: "Menu photos and captured boards",
          bullet3: "Clear restaurant and menu information",
          bullet4: "Easier decision-making before you go",
        },
        feed: {
          eyebrow: "Discovery",
          title: "Daily discovery",
          desc: "New menus every day and featured options nearby.",
          bullet1: "Newly uploaded menus",
          bullet2: "Featured and local options",
          bullet3: "Nearby discovery at a glance",
          bullet4: "Browse daily choices quickly",
        },
      },
      restaurant: {
        heading: "Own a restaurant?",
        copy: "Claim your page and keep your daily menu visible.",
        button: "Download the app",
      },
    },
    homePage: {
      hero: {
        title: "Menú del día, found faster",
        subtitle:
          "Discover nearby daily menus, real menu photos, prices, favourites, and alerts — all in one map.",
        downloadLabel: "Download MenúHunter",
        exploreMapCta: "Explore the map",
        mapAlt: "Menú del día map on MenúHunter",
        exploreMenus: "Explore menú del día",
        interactiveMap: "View interactive map",
        forRestaurants: "For restaurants",
        showcase: {
          cards: [
            {
              title: "Find today's menu",
              subtitle: "Explore the menú del día map near you and filter by area.",
              imageAlt: "Menú del día map on MenúHunter",
            },
            {
              title: "See real menu photos",
              subtitle: "Compare dishes, prices, and real community captures.",
              imageAlt: "Menu detail with photos on MenúHunter",
            },
            {
              title: "Share lists",
              subtitle: "Invite friends and share menú del día routes.",
              imageAlt: "Shared menú del día lists on MenúHunter",
            },
            {
              title: "Get menu alerts",
              subtitle: "Get notified when something new appears nearby or in your favourites.",
              imageAlt: "Menú del día alerts on MenúHunter",
            },
          ],
        },
      },
      trust: {
        pills: [
          "Free for users",
          "iPhone and Android",
          "Real menus",
          "Uploaded by the community",
          "Fresh menus",
          "Verified restaurants",
        ],
      },
      howItWorks: {
        title: "How it works",
        subtitle: "Discover, compare, and contribute to the menú del día map near you.",
        stepLabel: "Step",
        steps: [
          {
            title: "Find menus near you",
            description:
              "Explore the collaborative menú del día map near you and filter by area.",
          },
          {
            title: "See photos, price, and distance",
            description:
              "Compare menus with real photos, up-to-date prices, and map location.",
          },
          {
            title: "Upload a menu and help others",
            description:
              "Contribute a menú del día you have seen and improve the map for everyone.",
          },
        ],
      },
      differentiators: {
        title: "Why MenúHunter is different",
        items: [
          {
            title: "Powered by the community",
            description:
              "Real menus uploaded by people in your city, not generic directories.",
          },
          {
            title: "Fresh menus today",
            description:
              "We prioritise recent captures so you see what is served today and this week.",
          },
          {
            title: "Verified restaurants",
            description:
              "Venues can claim and verify their profile as a trust layer.",
          },
          {
            title: "iPhone and Android",
            description:
              "The full experience is in the mobile app, available on both stores.",
          },
        ],
      },
      restaurants: {
        eyebrow: "For restaurants",
        headline: "Get discovered by people searching for today's menú del día",
        subtitle:
          "Publish today's menu and be more visible to nearby diners. No commissions.",
        primaryCta: "Claim my restaurant",
        secondaryCta: "See full restaurant details",
        claimHint: "Claim your restaurant from the app in a few steps.",
        menuAlt: "Menú del día detail on MenúHunter",
      },
      neighborhoods: {
        title: "Explore by neighbourhood",
        subtitle: "Explore menú del día by area — we are starting in Barcelona.",
        items: [
          { slug: "menu-del-dia-barcelona", label: "Barcelona" },
          { slug: "menu-del-dia-barcelona-eixample", label: "Eixample" },
          { slug: "menu-del-dia-barcelona-gracia", label: "Gràcia" },
          { slug: "menu-del-dia-barcelona-sant-antoni", label: "Sant Antoni" },
          { slug: "menu-del-dia-barcelona-poblenou", label: "Poblenou" },
          { slug: "menu-del-dia-barcelona-el-raval", label: "El Raval" },
          { slug: "menu-del-dia-barcelona-gotic", label: "Gòtic" },
          { slug: "menu-del-dia-barcelona-born", label: "Born" },
        ],
      },
      closing: {
        title: "Download MenúHunter",
        subtitle:
          "The collaborative menú del día map, in your pocket. Launching in Barcelona.",
        openMap: "Open interactive map",
      },
    },
    communityPage: {
      hero: {
        title: "Restaurants and neighbours, together on the map",
        subtitle:
          "Venues publish their menú del día and the community helps fill gaps with real photos. That is how the map stays fresh and useful.",
      },
      stats: {
        ariaLabel: "Live MenúHunter figures",
        restaurantsListed: "Restaurants on the map",
        liveNote: "Live figure · updates automatically",
      },
      contribute: {
        title: "Seen a menu? Upload it in 10 seconds",
        body: "When a venue has not published today's board yet, your photo helps everyone. Open the app, snap the chalkboard, and keep the map fresh — we are starting in Barcelona.",
        downloadLabel: "Download MenúHunter",
        cta: "Go to download",
      },
      restaurants: {
        title: "Own a restaurant?",
        body: "Publish today's menu, control your profile, and show up when people search nearby. The community complements you — you stay in charge of your venue.",
        cta: "See for restaurants",
      },
      follow: {
        title: "Follow along",
        body: "Daily finds, city tips, and app news on social.",
        socialNavAria: "MenúHunter social links",
      },
      explore: {
        title: "Browse the live map",
        body: "Menus from restaurants and the community, filtered by area, near you.",
        cta: "Open the map",
      },
      ways: {
        title: "More ways to take part",
        subtitle: "Every contribution — yours or the venue's — makes the map more useful.",
        items: [
          {
            title: "Upload a menu as a diner",
            description: "Capture today's menú del día in the app and help fill gaps.",
          },
          {
            title: "Claim your restaurant",
            description: "Publish the official menu, verify your profile, and reach nearby diners.",
          },
          {
            title: "Browse the live map",
            description: "See what is on today and find where to eat.",
          },
          {
            title: "Tag us when you find a gem",
            description: "Share on Instagram and mention @menuhunter.app.",
          },
          {
            title: "Creators and partners",
            description: "Making content or want to collaborate? Email team@menuhunter.app.",
          },
          {
            title: "Refresh stale menus",
            description: "Wrong price or dishes? Upload today's board and we fix it together.",
          },
        ],
      },
    },
    restaurantsPage: {
      hero: {
        eyebrow: "FOR RESTAURANTS",
        title: "Boost visibility for your menú del día",
        subtitle:
          "Reach nearby users looking for lunch options on MenúHunter, from the app and the web.",
        phoneAlt: "A restaurant menú del día on MenúHunter",
        chips: {
          noCommissions: "Free restaurant account",
          planMonthlyAnnual: "Monthly or annual plan",
          platforms: "iPhone and Android",
          availableAcrossSpain: "Available across Spain",
        },
      },
      heroValueProps: {
        title: "Why restaurants use MenúHunter",
        items: [
          {
            title: "Publish in seconds",
            description:
              "Take a photo of today's menu and MenúHunter turns it into a clear digital menu.",
          },
          {
            title: "Get found nearby",
            description:
              "Show up on the map when people nearby are looking for a menú del día.",
          },
          {
            title: "Free to publish",
            description:
              "Restaurants can publish their menú del día easily and keep it updated without friction.",
          },
        ],
      },
      cta: {
        startTrial: "Claim my restaurant",
        seeHowItWorks: "How it works",
        downloadApp: "Download the app",
        howToClaim: "How to claim",
        claimRestaurant: "Claim your restaurant",
        showMenuFree: "Show your menu for free",
      },
      claim: {
        invalidLink:
          "This link does not include a valid restaurant. To claim your restaurant, download the MenúHunter app, create an account, and search for your venue to start the claim from the app.",
        loading: "Loading restaurant details…",
        bannerWithName:
          "Do you manage {{name}}? Download MenúHunter, create an account, and claim your restaurant from the app to publish your menú del día, review your information, and appear as a verified restaurant.",
        bannerGeneric:
          "Do you manage this restaurant? Download MenúHunter, create an account, and claim your restaurant from the app to publish your menú del día, review your information, and appear as a verified restaurant.",
      },
      valueProps: {
        title: "Why join MenúHunter",
        subtitle:
          "The collaborative menú del día map, with verified restaurants and real menus from the community.",
        items: [
          {
            title: "Publish your menú del día in 10 seconds",
            description:
              "Take a photo of today's menu and MenúHunter turns it into a clear digital menu, ready for people to see.",
          },
          {
            title: "Show up on the map when people look for lunch",
            description:
              "Your restaurant appears to nearby people exploring menú del día options.",
          },
          {
            title: "Free access for restaurants",
            description:
              "Restaurants can publish their menú del día for free, keep it updated, and use simple tools built around daily menus.",
          },
          {
            title: "Control photos, price, hours, and details",
            description: "Update your listing and menu anytime from the app.",
          },
          {
            title: "Verified profile to build trust",
            description:
              "When you claim and verify, diners see that you manage your venue.",
          },
          {
            title: "Available on iPhone, Android, and web",
            description:
              "People can find your menú del día from the app or the web, whether they are nearby or checking lunch options from the office.",
          },
        ],
      },
      pricing: {
        headline: "Choose how your restaurant appears on MenuHunter",
        supporting:
          "Start with everything you need to publish and keep your menú del día visible for free. Upgrade to Pro when you want more reach, stronger visibility, and customer insights.",
        tagline: "Free restaurants are listed. Pro restaurants stand out.",
        trialBadge: "Pro",
        plans: {
          free: {
            name: "Free",
            price: "€0",
            billingLabel: "/ month",
            commitment: "No card. No monthly fee.",
            tagline: "Claim your restaurant and keep everything customers need up to date, with no card or monthly charge.",
            cta: "Continue with Free",
            features: {
              claimRestaurant: "Claim and verify your restaurant",
              publishMenu: "Publish and update your Menú del Día",
              detailsHours: "Manage restaurant details and opening hours",
              photosSocial: "Add photos and social links",
              menuQr: "Create and share your menu QR code",
              searchAndMap: "Appear in search and on the map with the standard marker",
              basicViews: "See basic menu views and restaurant saves",
              noMonthlyCharge: "No monthly charge",
            },
          },
          pro: {
            name: "Pro",
            monthlyPrice: "€14.99",
            monthlyLabel: "/ month",
            annualPrice: "€149.99",
            annualLabel: "/ year",
            trialBadge: "",
            tagline:
              "Everything in Free, plus tools to increase visibility, understand customer interest and bring diners back.",
            cta: "Explore Pro",
            features: {
              boostedVisibility: "Greater visibility across MenuHunter",
              featuredCarousels: "Eligibility for Featured on Home",
              followerNotifications: "Alerts for people who saved your restaurant",
              analytics: "Advanced restaurant analytics",
              enhancedProfile: "Enhanced restaurant profile",
              teamAccess: "Access for multiple team members",
              prioritySupport: "Priority support and early access to new tools",
            },
          },
        },
        features: {
          profile: "Restaurant profile on MenúHunter",
          discovery: "Be discovered by people looking for menú del día",
          updateDaily: "Show customers today's menu — every day",
          qrCode: "Share today's menu with a unique QR code",
          photos: "Control your photos and stand out on the map",
          editAnytime: "Edit hours, price, and menu details anytime",
          verified: "Verified owner badge",
          noCommission: "No commission per guest or sale",
          trial: "Monthly or annual plan",
          cancel: "Cancel anytime",
        },
      },
      howItWorks: {
        title: "How it works for restaurants",
        subtitle:
          "Claiming or verifying your profile adds a trust layer. Meanwhile, the community can also help your venue appear on the map.",
        stepLabel: "Step",
        steps: [
          {
            title: "Claim or add your restaurant",
            description:
              "If you already appear on the map, claim it. If not, create it in a few steps from the app.",
          },
          {
            title: "Publish your menú del día",
            description:
              "Upload today's menu photo so people see current dishes and prices.",
          },
          {
            title: "Show on the map and reach people nearby",
            description:
              "When you publish, your restaurant gains visibility for anyone looking for lunch nearby.",
          },
        ],
      },
      community: {
        title: "Community-powered map",
        body:
          "MenúHunter does not rely only on every restaurant publishing every day. The community can also upload real menus, helping more venues appear on the map. When a restaurant is verified, it gains control over its profile and an extra layer of trust.",
      },
      faq: {
        title: "Frequently asked questions",
        items: [
          {
            q: "Does MenúHunter charge commission?",
            a: "No. We do not charge commission per guest or sale. Only the monthly or annual subscription.",
          },
          {
            q: "How much does it cost?",
            a: "Free has no monthly charge. Pro is {{monthlyPrice}} €/month or {{annualPrice}} €/year.",
          },
          {
            q: "Can I use MenúHunter for free?",
            a: "Yes. Restaurants can publish their menú del día for free. Paid plans are optional and add more visibility, reach, and restaurant tools.",
          },
          {
            q: "Can I control my restaurant photos and information?",
            a: "Yes. When you manage your profile you can update your menu, photos, hours, and contact details.",
          },
          {
            q: "What does verified restaurant mean?",
            a: "It means the venue has claimed its profile and can publish and maintain its information with an extra trust layer.",
          },
          {
            q: "Can users upload menus too?",
            a: "Yes. The community can contribute real menus. When you verify your restaurant, you control your profile and how it is presented.",
          },
          {
            q: "Do I need a separate app for restaurants?",
            a: "You manage your restaurant from the MenúHunter app (iPhone or Android). We guide you through listing or claiming.",
          },
        ],
      },
      claimFlow: {
        title: "How to claim your restaurant",
        body:
          "To manage your restaurant on MenúHunter, download the app, create an account, and search for your restaurant. From the restaurant profile, you can start the claim process and complete it inside the app.",
        steps: [
          "Download the MenúHunter app from the App Store or Google Play.",
          "Create an account or sign in with your email.",
          "Use search to find your restaurant.",
          "Open your restaurant profile and start the claim from the app.",
          "If you have a promo or offer code, use it during the claim flow.",
        ],
        ctaTitle: "Get started in the app",
        ctaBody:
          "Open MenúHunter on your phone to claim your restaurant, publish your menú del día, and manage your visibility.",
        supportFallback:
          "If you run into issues claiming your restaurant from the app, you can contact support.",
      },
      links: {
        navAria: "Useful links",
        home: "Home",
        barcelonaMenus: "Menus in Barcelona",
        download: "Download app",
        support: "Support",
        privacy: "Privacy",
        terms: "Terms",
      },
    },
    supportPage: {
      documentTitle: "Support | MenúHunter",
      metaDescription:
        "Contact MenúHunter support for account, restaurant, menu, subscription, or app issues.",
      title: "Support",
      intro:
        "Contact MenúHunter for account issues, restaurant claims, menus, subscriptions, or app problems. The fastest option is in the app; you can also email us if you cannot use it.",
      emailEyebrow: "Email",
      emailTitle: "Email us",
      emailBody:
        "For help with your account, a restaurant, a menu, your subscription, or the app, write to:",
      emailCta: "Email support",
      appEyebrow: "In the app",
      appTitle: "Support from MenúHunter",
      appIntro: "The recommended way to reach our team:",
      appStep1: "Open MenúHunter on your phone.",
      appStep2: "Go to the Profile tab (your account settings).",
      appStep3: "Tap Support, alongside Privacy and Terms.",
      appDetail:
        "Then choose an issue type, add a title and description, and optionally attach up to 3 screenshots before submitting your request.",
      mockupAlt: "MenúHunter in-app support screen (English)",
      mockupImageSrc: "/images/support/in-app-support-en.png",
      includeEyebrow: "What to include",
      includeTitle: "Help us respond faster",
      includeEmail: "The email address you use in the app",
      includeRestaurant: "The restaurant name, if relevant",
      includeScreenshots: "Screenshots, if they help explain the issue",
      includeDescription: "A short description of the problem",
      issuesEyebrow: "Issue types",
      issuesTitle: "What you can contact us about",
      issueAccount: "Account issues",
      issueSubscription: "Subscription & payments",
      issueClaiming: "Claiming or managing a restaurant",
      issueMenu: "Incorrect menu information",
      issueTechnical: "Technical problem",
      issueOther: "Other",
      fallback:
        "If you cannot use the app, in exceptional cases you can email soporte@menuhunter.app.",
      downloadHint: "Don't have the app yet?",
      downloadLink: "Download MenúHunter",
      footerRestaurantsLink: "For restaurants",
    },
    restaurantLanding: {
      invalidLink: "Invalid restaurant link",
      invalidId: "Invalid restaurant ID",
      downloadMenuhunter: "Download MenúHunter",
      opening: "Opening MenúHunter…",
      redirectHint: "If the app doesn't open, you'll be redirected to the app store.",
      viewMenuHint: "To view this restaurant's menu, download the MenúHunter app.",
      downloadOnAppStore: "Download on App Store",
      downloadOnPlay: "Get it on Google Play",
      seeAllOptions: "See all download options",
    },
    restaurantSharePage: {
      loading: "Loading restaurant…",
      notFoundTitle: "Restaurant not available",
      notFoundBody: "This link does not match a public restaurant or it is no longer available.",
      ctaHint: "For the best experience and alerts, open MenúHunter on your phone.",
      openInApp: "Open in app",
      downloadApp: "Download MenúHunter",
      claimBanner: {
        headline: "Are you the owner or manager of this restaurant?",
        subtext: "Download the app and claim the profile from MenúHunter",
        cta: "Claim in the app",
      },
      menusHeading: "Daily menus",
      noMenus: "No menu has been published for this restaurant yet. Check back soon or open the app for more.",
      viewMenuLink: "View menu",
      backHome: "← Back to home",
      errorTitle: "Could not load",
      errorBody: "Check your connection and try again.",
      tabMenu: "Menu",
      tabPhotos: "Photos",
      tabReviews: "Reviews",
      tabInfo: "Info",
      tabDirections: "Directions",
      tabClaim: "Claim",
      reviewsTabTitle: "Reviews in the app",
      reviewsTabBody:
        "Diner ratings and reviews are available in the MenúHunter mobile app. Download the app to read and leave reviews.",
      claimTabIntro:
        "Are you the owner or manager of this restaurant? Download MenúHunter, create an account, and claim the profile from the app.",
      claimTabButton: "Claim in the app",
      categoryDaily: "Daily menu",
      categoryChristmas: "Christmas ({count})",
      christmasHeading: "Christmas menus",
      christmasEmpty: "No public Christmas packages for this restaurant.",
      christmasUntitled: "Christmas package",
      christmasPerPerson: "per person",
      christmasPerPackage: "per package",
      christmasOpenImages: "View menu photos",
      christmasBackToRestaurant: "View restaurant",
      availability: {
        archived: "Withdrawn",
        upcoming: "Upcoming",
        available: "Available",
        expired: "Expired",
        season_confirmed: "Season confirmed",
        undated_unconfirmed: "Dates not stated",
      },
      viewerClose: "Close",
      viewerPrevious: "Previous",
      viewerNext: "Next",
      viewerZoomIn: "Zoom in",
      viewerZoomOut: "Zoom out",
      viewerBroken: "Could not load image",
      viewerLoading: "Loading…",
      viewerOf: "of",
      offeringNotFoundTitle: "Christmas menu unavailable",
      offeringNotFoundBody:
        "This link does not match a public Christmas menu or it is no longer available.",
      offeringWithdrawn: "This package is no longer published.",
      offeringDatesRange: "Confirmed dates: {from} – {to}",
      offeringDatesFrom: "From {from}",
      offeringDatesUntil: "Until {to}",
      offeringSeasonLabel: "Season: {label}",
    },
    verifyClaim: {
      loadingTitle: "Verifying your claim...",
      loadingMessage: "Please wait while we verify your email address.",
      successTitle: "Email verified!",
      successMessage: "Thanks — your email is verified. You can now manage your restaurant in the MenúHunter app.",
      successTeamMessage: "",
      viewInApp: "",
      openApp: "Open MenúHunter app",
      viewOnWeb: "View on web",
      errorTitle: "Verification Failed",
      errorMissingToken: "Verification link is missing.",
      errorInvalidToken:
        "Invalid, expired, or replaced verification link. If you requested another email, use only the link from the latest message.",
      errorRpcFailure: "We couldn't complete verification due to a server error. Please try again later.",
      errorClaimNotFound: "No claim was found for this link.",
      errorVerificationFailed: "Verification failed. The link may have expired or already been used.",
      errorPaymentNotStarted: "Payment not started. Please return to the app to complete payment, then verify your email.",
      errorGeneric: "An error occurred during verification.",
      errorServerError: "Something went wrong on our side. Please try again later.",
      resendTitle: "Resend Verification Email",
      emailLabel: "Email Address",
      emailPlaceholder: "your@email.com",
      resendButton: "Resend Verification Email",
      resendSending: "Sending...",
      resendSent:
        "Verification email sent! Check your inbox. If you requested a resend before, only the newest email has a valid link.",
      resendSectionHint:
        "Requesting a new email invalidates older links. Always open the link from the latest message.",
      resendNoClaim: "No claim found with this email address.",
      resendError: "Failed to resend email.",
      loadingFallback: "Loading...",
      closeTab: "You can close this tab.",
      emailRequired: "Email address is required",
    },
    admin: {
      dashboard: "Admin Dashboard",
      logout: "Logout",
      navGroups: {
        dashboard: "Dashboard",
        dailyOperations: "Daily operations",
        accountsAccess: "Accounts & access",
        geographyRecords: "Geography & records",
        batchContentTools: "Batch content tools",
      },
      tabs: {
        metrics: "Metrics",
        reviewMenus: "Menu review",
        coverage: "Coverage",
        citiesListing: "City selector",
        users: "Users & roles",
        restaurantLifecycle: "Restaurant lifecycle",
        onboarding: "Trial operations",
        photos: "Photo moderation",
        pushNotifications: "Push notifications",
        feedback: "Product feedback",
        supportTickets: "Support tickets",
        interviews: "Field interviews",
        founderAccess: "Founder access",
        complimentaryPro: "Complimentary Pro",
        promoCodes: "Promo codes",
        restaurants: "Restaurants lookup",
        map: "Coverage map",
        areaDensity: "Area density (5 km)",
      },
      coveragePage: {
        title: "Area density (5 km)",
        subtitle:
          "Advanced geographic cell analysis (~5 km radius). Useful for local expansion; not the main city listing score on City coverage & activation.",
      },
      directory: {
        mapTitle: "Coverage map",
        mapSubtitle:
          "Inspect geocoded restaurant coverage and preview city supply. Restaurants without coordinates are not shown here.",
        mapMissingCoordsNote:
          "Missing-coordinate records are handled from Restaurants lookup.",
        restaurantsSubtitle:
          "Restaurant record lookup, city assignment, visibility fixes, and admin/debug actions. Use City coverage & activation for listing decisions.",
        usersSubtitle:
          "Account support, role management, disabled users, and user-level admin actions.",
        mapLegendTitle: "Legend",
        mapLegendClaimed: "Managed / claimed",
        mapLegendUnclaimed: "Community / unclaimed",
        mapLegendHidden: "Hidden or deleted",
        mapLegendNoMenu: "No menu",
        mapViewLifecycle: "View in lifecycle",
        mapViewOwner: "View owner",
      },
      restaurantsLookup: {
        title: "Restaurants lookup",
        subtitle:
          "Use this page for restaurant record lookup, visibility fixes, city assignment, and admin/debug actions. Use City coverage & activation for listing decisions, and Restaurant lifecycle for commercial or claim workflows.",
        visibilityFlowNote:
          "Visibility flow: active → hidden → deleted. Hard delete is destructive and should only be used for clear admin cleanup cases.",
        searchPlaceholder: "Search (name, address, Place ID, or restaurant UUID)…",
        bulkAssignCity: "Assign city to all restaurants with no city",
        bulkAssignModalTitle: "Assign city to all restaurants with no city",
        bulkAssignModalWarning:
          "This is a global maintenance action. It updates every restaurant where city is currently empty, not only the rows visible in this table.",
        bulkAssignTypeConfirm: 'Type ASSIGN CITY to confirm',
        badgeMissingCoords: "Missing coordinates",
        badgeNoCity: "No city",
        badgeNoMenus: "No menus",
        filteredByOwner: "Filtered by owner",
        clearOwnerFilter: "Clear owner filter",
        navigate: "Navigate",
        viewPublicPage: "View public page",
        previewOnMap: "Preview on coverage map",
        cityActivation: "City selector",
        restaurantLifecycle: "Restaurant lifecycle",
        entitlementsDebug: "Entitlements debug",
        ownerAccount: "Owner account",
        maintenance: "Maintenance",
        visibility: "Visibility",
        destructive: "Destructive",
        hardDeleteHelper:
          "Hard delete permanently removes the restaurant record and should only be used for clear cleanup cases.",
        confirmCityTitle: "Change this restaurant's city assignment?",
        confirmCityBody:
          "This affects admin filtering, city coverage analysis, and city activation review. Continue?",
        paginationPrevious: "Previous",
        paginationNext: "Next",
        paginationPage: "Page {page} of {totalPages}",
        paginationShowing: "Showing {from}–{to} of {total}",
      },
      restaurantLifecycle: {
        title: "Restaurant lifecycle",
        subtitle:
          "Track restaurant supply, claim status, paid accounts, founder accounts, and stale claimed restaurants.",
        queues: {
          outreach: "Outreach queue",
          claimed_free: "Claimed Free",
          pro_founder: "Pro & Founder",
          stale_claimed: "Stale claimed",
          billing_attention: "Billing attention",
        },
        queueLabels: {
          outreach: "Community restaurants to approach",
          claimed_free: "Claimed, not Pro",
          pro_founder: "Paid or founder accounts",
          stale_claimed: "Claimed but inactive",
          billing_attention: "Subscription issues",
        },
        queueHelp: {
          outreach:
            "Unclaimed restaurants with community menu activity. Good candidates for claim outreach.",
          claimed_free:
            "Restaurants using the free plan. Monitor activity and identify upgrade candidates.",
          pro_founder:
            "Restaurants with Pro entitlement through payment or founder access.",
          stale_claimed:
            "Claimed or managed restaurants with no live menu activity in the last 30 days.",
          billing_attention: "Restaurants with subscription or entitlement mismatches.",
        },
        queueSummary: {
          outreach: "{{count}} restaurants to approach for claims.",
          claimed_free: "{{count}} restaurants on the free plan.",
          pro_founder: "{{count}} paid or founder accounts.",
          stale_claimed: "{{count}} restaurants need a menu update or follow-up.",
          billing_attention: "{{count}} restaurants with subscription issues.",
        },
        statusBadges: {
          community: "Community",
          high_value: "High-value",
          free: "Free",
          pro: "Pro",
          founder: "Founder",
          stale: "Stale",
          billing_issue: "Billing issue",
          active: "Active",
        },
        staffActions: {
          claim_outreach: "Invite to claim",
          stale_follow_up: "Ask for menu update",
          check_billing: "Review billing",
          founder_monitor: "Monitor founder account",
          publish_menu: "Needs menu published",
          no_action: "No action",
        },
        filters: {
          search: "Search",
          searchPlaceholder: "Name, city, email…",
          city: "City",
          provider: "Provider",
          all: "All",
        },
        table: {
          restaurant: "Restaurant",
          status: "Status",
          activity: "Activity",
          contact: "Contact",
          nextStep: "Next step",
          actions: "Actions",
          noLiveMenus: "No live menus",
          menuSummary: "{{count}} menu · {{community}} community / {{owner}} owner",
          menuSummaryPlural: "{{count}} menus · {{community}} community / {{owner}} owner",
          noOwnerContact: "No owner contact",
          claimed: "Claimed",
          unclaimed: "Unclaimed",
          empty: "No restaurants in this queue match the current filters.",
          showing: "Showing {{shown}} of {{total}}",
          showMore: "Show more",
          details: "Details",
          hideDetails: "Hide details",
        },
        details: {
          planKey: "Plan key",
          providerStatus: "Provider / status",
          liveMenus: "Live menus",
          communityMenus: "Community menus",
          ownerMenus: "Owner menus",
          lastMenuAt: "Last menu at",
          claimStatus: "Claim status",
          commercialSegment: "Commercial segment",
          operationalStatus: "Operational status",
          billingWarning: "Billing sync warning",
        },
        links: {
          openRestaurant: "Open restaurant",
          entitlements: "Entitlements",
          founder: "Founder access",
          copyEmail: "Copy email",
          emailCopied: "Email copied",
        },
      },
      interviews: {
        title: "Field interviews",
        subtitle:
          "Discovery interviews conducted from Field Tools in the mobile app (Restaurant Insights and Consumer Insights).",
        tabs: {
          restaurant: "Restaurants",
          consumer: "Consumers",
        },
        metrics: {
          totalActive: "Active interviews",
          thisWeek: "This week",
          test: "Test",
          linkedRestaurants: "Linked restaurants",
          topInterviewers: "Interviews by team member (top 5)",
        },
        filters: {
          search: "Search",
          searchPlaceholder: "Restaurant, city, interviewer name or email…",
          city: "City",
          cityPlaceholder: "city slug",
          interviewer: "Interviewer",
          allInterviewers: "All interviewers",
          visibility: "Visibility",
          visibilityActive: "Active",
          visibilityTest: "Test",
          visibilityDeleted: "Deleted",
          visibilityAll: "All",
          apply: "Apply filters",
        },
        table: {
          date: "Date",
          respondent: "Restaurant / context",
          city: "City",
          conductedBy: "Conducted by",
          outcome: "Outcome",
          status: "Status",
          actions: "Actions",
        },
        unknownInterviewer: "Unknown interviewer",
        confirmAccountability:
          "{{type}} · {{respondent}} — conducted by {{interviewer}} on {{date}}.",
        statusActive: "Active",
        statusTest: "Test",
        statusDeleted: "Deleted",
        view: "View",
        markTest: "Mark test",
        unmarkTest: "Unmark test",
        deleteInterview: "Delete",
        exportCsv: "Export CSV",
        empty: "No interviews found.",
        showing: "Showing {{shown}} of {{total}}",
        detailTitle: "Interview detail",
        detailPlaceholder: "Select an interview to view full answers.",
        detailCompleted: "Completed",
        detailConductedBy: "Conducted by",
        detailConductedById: "UUID",
        detailAppVersion: "App version",
        detailCity: "City",
        detailRestaurant: "Restaurant",
        detailDuration: "Duration",
        detailDeleted: "Deleted",
        detailDeletedBy: "Deleted by",
        detailAnswers: "Answers",
        openRestaurant: "Open restaurant",
        close: "Close",
        prevPage: "Previous",
        nextPage: "Next",
        pageOf: "Page {{page}} of {{total}}",
        csvDownloaded: "CSV downloaded.",
        actionSuccess: "Interview updated.",
        actionFailed: "Could not update interview.",
        cancel: "Cancel",
        confirmMarkTestTitle: "Mark as test",
        confirmMarkTestMessage: "This interview will be excluded from operational metrics and the mobile dashboard.",
        confirmUnmarkTestTitle: "Unmark test",
        confirmUnmarkTestMessage: "This interview will count as a real interview again.",
        confirmDeleteTitle: "Delete interview",
        confirmDeleteMessage: "This soft-deletes the row. It remains in the database with a deletion reason.",
        deleteReasonTitle: "Deletion reason",
        deleteReasonMessage: "Enter why this interview is being removed (required).",
        deleteReasonPlaceholder: "e.g. staff practice run",
        deleteReasonRequired: "Reason is required.",
      },
      cities: {
        title: "City selector",
        subtitle:
          "Add or remove cities from the consumer city picker. Cities with 10+ restaurants that have a live menu are scoped for adding.",
        subtitleDecision:
          "Listing is manual. Cities with ≥10 live-menu restaurants show as Scoped; adding requires an active GPS region.",
        introManualListing:
          "Listing is manual. Nothing is auto-added to the consumer selector.",
        listingPolicyTitle: "How it works",
        listingPolicyBody:
          "Three simple states for day-to-day use. Deeper activation details stay in the advanced panel below.",
        listingPolicyInSelector:
          "In selector: already shown in the app city picker. Use Remove to take it out.",
        listingPolicyScoped:
          "Scoped: ≥10 restaurants with a live menu, not listed yet. Ready to Add once a GPS region exists.",
        listingPolicyBelow:
          "Below threshold: fewer than 10 restaurants with a live menu. Not a primary candidate.",
        listingPolicyRegionBlock:
          "Add is blocked until the city has an active GPS region (needed for location and coverage).",
        listingPolicyReady:
          "Ready: at least 30 restaurants with live menus, at least 15 active in the last 30 days, latest menu within 7 days, and an active city region.",
        listingPolicyStrong:
          "Strong: at least 50 restaurants with live menus, at least 25 active in the last 30 days, latest menu within 3 days, and an active city region.",
        listingPolicyHidden:
          "Hidden: fewer than 10 visible restaurants, fewer than 5 active in 30 days, missing city region, no menu, latest menu older than 60 days, or the other bucket.",
        listingPolicyWatch:
          "Watch: everything between Hidden and Ready.",
        listingPolicyAreaDensityNote:
          "Area density is useful for local expansion, but city listing decisions should use the city activation readiness status.",
        badgeReadyToList: "Ready to list",
        badgeReadyToListHelp:
          "This city meets the readiness bar but is not listed in user-facing city selectors.",
        badgeListedButWeak: "Listed but weak",
        badgeListedButWeakHelp:
          "This city is visible to users but currently falls below the recommended listing bar.",
        badgeRecommendedHidden: "Recommended hidden",
        badgeRecommendedHiddenHelp:
          "Keep unlisted until supply, freshness, and regions improve.",
        badgeWatchStatus: "Watch",
        badgeWatchHelp:
          "Approaching or needs review before listing.",
        previewOnMap: "Preview on map",
        viewRestaurants: "View restaurants",
        expansionWarning:
          "New city slugs may require app support and a GPS region before they work end to end.",
        readOnlyBanner: "Read-only access. City listing changes require an admin account.",
        activationError:
          "Could not load city activation metrics. Supply counts and activation status are unavailable.",
        readinessError:
          "Could not load city readiness metrics. Supply counts and Ready status are unavailable.",
        summaryListed: "Listed",
        summaryInSelector: "In selector",
        summaryScoped: "Scoped (≥10)",
        summaryBelow: "Below threshold",
        summaryNeedsReview: "Needs review",
        summaryReadyToList: "Ready to list",
        summaryMissingRegion: "Missing region",
        summaryStaleListed: "Stale listed",
        summaryReadyUnlisted: "Ready but unlisted",
        filterAll: "All",
        filterInSelector: "In selector",
        filterScoped: "Scoped",
        filterBelow: "Below threshold",
        filterNeedsReview: "Needs review",
        filterStaleListed: "Stale listed",
        filterReadyUnlisted: "Ready to list",
        filterWatch: "Watch",
        filterHidden: "Hidden",
        filterMissingRegion: "Missing region",
        bucketInSelector: "In selector",
        bucketScoped: "Scoped",
        bucketBelow: "Below threshold",
        addToSelector: "Add",
        removeFromSelector: "Remove",
        noFilterResults: "No cities match this filter.",
        columnCity: "City",
        columnStatus: "Status",
        columnLiveMenus: "Live menus",
        columnDecision: "Decision",
        columnActivation: "Activation",
        columnListed: "Listed",
        columnSupply: "Supply",
        columnFreshness: "Freshness",
        columnRegion: "Region",
        columnActions: "Actions",
        columnVisible: "Visible",
        columnActive30d: "Active 30d",
        columnLastActivity: "Last activity",
        columnClaimed: "Claimed",
        columnUploadMix: "Owner / community 30d",
        columnEnabled: "Enabled",
        columnPriority: "Priority",
        regionOk: "OK",
        regionMissing: "Missing",
        regionCount: "· {n} region",
        noLiveMenus: "No live menus",
        staleListedWarning: "Stale",
        reviewPill: "Listed but weak",
        readyPill: "Ready to list",
        supplyVisible: "{n} visible",
        supplyActive30d: "{n} active 30d",
        systemBucket: "System bucket",
        neverListable: "Never listable",
        disabledLabel: "Disabled",
        blockerLowRecentActivity: "Low recent activity",
        blockerNoLiveMenus: "No live menus",
        blockerMissingRegion: "Missing GPS region",
        blockerLowClaimRate: "Low claim rate",
        blockerLowVisible: "Low visible supply",
        blockerLowActive30d: "Low 30d activity",
        blockerListedButWeak: "Listed below threshold",
        blockerCommunityOnly: "Community-only supply",
        detailsButton: "Details",
        actionsLabel: "Actions",
        detailsClaimed: "Claimed:",
        detailsManaged: "Managed:",
        detailsUploadMix: "Owner / community 30d:",
        detailsActive7d: "Active 7d:",
        detailsLastMenuAt: "Last menu:",
        okToList: "OK to list",
        listBlockedNoRegion: "Cannot list: add an active GPS region first.",
        listBlockedOther: "The “other” bucket cannot be listed in the city picker.",
        listAnywayTitle: "Add city below threshold?",
        listAnywayMessage:
          "This city has fewer than 10 restaurants with a live menu. Adding it may show a thin supply in the picker.",
        listAnywayConfirm: "Add anyway",
        disableWhileListedTitle: "Disable listed city?",
        disableWhileListedMessage:
          "This city is still listed in the app picker. Consider unlisting first.",
        disableWhileListedConfirm: "Disable anyway",
        columnEnabledTitle: "Valid internally (claims, RPCs)",
        columnListedTitle: "Appears in the app location picker",
        columnStatusTitle: "Consumer-aligned supply signal; does not auto-list",
        addCity: "Add city",
        editCity: "Edit city",
        loading: "Loading…",
        enabledLabel: "Enabled (valid internally)",
        listedLabel: "Listed (app picker)",
        officialLabel: "Official",
        sortPriorityLabel: "Sort priority (lower = first in pickers)",
        slugLabel: "Slug (lowercase, URL-safe)",
        labelEn: "Label (EN) *",
        labelEs: "Label (ES)",
        labelCa: "Label (CA)",
        cancel: "Cancel",
        update: "Update",
        add: "Add",
        saving: "Saving…",
        activationStatus: {
          strong: "Strong",
          ready: "Ready",
          watch: "Watch",
          hidden: "Hidden",
        },
        statusListed: "Listed",
        statusReady: "Ready",
        statusHidden: "Hidden",
        statusUnknown: "—",
        yes: "Yes",
        no: "No",
        enable: "Enable",
        disable: "Disable",
        list: "List",
        unlist: "Unlist",
        edit: "Edit",
        cityUpdated: "City updated.",
        cityAdded: "City added.",
        cityEnabled: "City enabled.",
        cityDisabled: "City disabled.",
        cityListed: "City added to the selector.",
        cityUnlisted: "City removed from the selector.",
        slugRequired: "Slug and English label are required.",
        loadFailed: "Failed to load cities:",
        reasonLabels: {
          other_never_listable: "Other is never listable",
          visible_lt_10: "Fewer than 10 visible restaurants",
          active_30d_lt_5: "Fewer than 5 active restaurants in 30d",
          no_region: "No GPS region",
          no_live_menus: "No live menus",
          stale_60d: "Last activity older than 60 days",
          visible_lt_30: "Fewer than 30 visible restaurants",
          active_30d_lt_15: "Fewer than 15 active restaurants in 30d",
          last_activity_older_than_7d: "Last activity older than 7 days",
        },
        warningLabels: {
          listed_but_hidden: "Listed but recommended hidden",
          listed_but_watch: "Listed but still watch status",
          ready_but_unlisted: "Ready but not listed",
          strong_but_unlisted: "Strong but not listed",
          missing_region: "Missing GPS region",
          community_only_supply: "Community-only supply",
          low_claim_rate: "Low claim rate",
        },
        expansionTitle: "Expansion opportunities",
        expansionSubtitle:
          "Coverage clusters that may need a city, region, or backfill before activation.",
        expansionExpand: "Show",
        expansionCollapse: "Hide",
        expansionError: "Could not load expansion opportunities.",
        expansionLoading: "Loading opportunities…",
        expansionNoResults: "No clusters match this filter.",
        clusterNearLabel: "Cluster near {lat}, {lng}",
        oppFilterActionable: "Actionable",
        oppFilterReadyForReview: "Ready for review",
        oppFilterNeedsRegion: "Needs region",
        oppFilterNeedsBackfill: "Needs backfill",
        oppFilterNeedsCity: "Needs city",
        oppFilterAll: "Show all",
        oppSummaryTotal: "{n} total",
        oppSummaryReady: "{n} ready for review",
        oppSummaryRegion: "{n} need region",
        oppSummaryBackfill: "{n} need backfill",
        oppSummaryCity: "{n} need city",
        oppColumnArea: "Area",
        oppColumnSupply: "Supply",
        oppColumnFreshness: "Freshness",
        oppColumnSetup: "Setup needed",
        oppColumnLocation: "Location",
        oppColumnVisible: "Visible",
        oppColumnActive30d: "Active 30d",
        oppColumnLastActivity: "Last activity",
        oppColumnLinkedCity: "Linked city",
        oppColumnRegion: "Region",
        oppColumnStatus: "Status",
        oppViewCoverage: "Advanced: area density",
        oppAreaDensityHelp:
          "Area density is a local expansion drill-down (~5 km). It is not the main city listing score.",
        oppCopySlug: "Copy slug",
        oppOpenCity: "Open city",
        oppCopiedSlug: "Copied to clipboard.",
        oppCopyFailed: "Could not copy to clipboard.",
        deleteCity: "Delete city",
        deleteCityTitle: "Delete city {slug}?",
        deleteCityMessage:
          "This only removes the city registry row. It is allowed because the city is disabled, unlisted, has no region, and has no visible supply.",
        deleteCityConfirm: "Delete",
        cityDeleted: "City deleted.",
        cannotDeleteCity: "Cannot delete city",
        dismissOpportunity: "Dismiss",
        dismissOpportunityTitle: "Dismiss this opportunity?",
        dismissOpportunityMessage:
          "This hides the coverage cluster from the opportunities panel. It does not delete restaurants, menus, or city data.",
        dismissOpportunityConfirm: "Dismiss",
        opportunityDismissed: "Opportunity dismissed.",
        showDismissed: "Show dismissed",
        hideDismissed: "Hide dismissed",
        dismissedEmpty: "No dismissed opportunities.",
        opportunityStatus: {
          needs_city: "Needs city",
          needs_region: "Needs region",
          needs_backfill: "Needs backfill",
          watch: "Watch",
          ready_for_review: "Ready for review",
        },
        opportunitySetup: {
          needs_city: "Needs city",
          needs_region: "Needs region",
          needs_backfill: "Needs backfill",
          watch: "Low activity",
          ready_for_review: "Ready for review",
        },
        opportunityReasons: {
          no_linked_city: "No linked city",
          missing_region: "Missing GPS region",
          misassigned_restaurants: "Misassigned restaurants",
          other_bucketed: "Restaurants in other bucket",
          low_visible: "Low visible count",
          low_active_30d: "Low 30d activity",
          ready_supply: "Supply meets ready threshold",
        },
      },
      metrics: {
        title: "Metrics Dashboard",
        kpi: {
          availableRestaurants: "Available restaurants",
          publishedCapturesAllTime: "Published captures (all-time)",
          menus24h: "Menus (24h)",
          menus7d: "Menus (7d)",
          menus30d: "Menus (30d)",
          users: "Users",
          unavailable: "Unavailable",
        },
        charts: {
          menusOverTime: "Menus Added Over Time",
          menusTooltip: "Menus",
        },
        filters: {
          day: "Day",
          week: "Week",
          month: "Month",
          to: "to",
        },
        empty: {
          noDataForRange: "No data available for the selected date range",
          loading: "Loading chart data...",
        },
      },
      review: {
        title: "Review Menus",
        help: "Help",
        queue: {
          title: "Review Queue",
          searchPlaceholder: "Search restaurants...",
          noMenusFound: "No menus found",
          selectMenu: "Select a menu to review",
        },
        status: {
          all: "All",
          unverified: "Pending Review",
          verified: "Reviewed",
          needsFix: "Needs Fix",
        },
        photo: {
          title: "Menu Photo",
          resetZoom: "Reset Zoom",
          noPhoto: "No photo available",
        },
        preview: {
          title: "App Preview",
          description: "This shows exactly how customers will see the menu in the app.",
          noContent: "No menu content available",
        },
        editor: {
          title: "Menu Structure",
          importOcr: "Import OCR into editor",
          unsavedChanges: "Unsaved changes",
          saved: "Saved",
          menuDate: "Menu Date",
          priceEur: "Price (EUR)",
          internalNote: "Internal Note",
          sectionsItems: "Sections & Items",
          addSection: "+ Add Section",
          sectionName: "Section name",
          addItem: "+ Add Item",
          itemName: "Item name",
          description: "Description (optional)",
          noSections: "No sections yet. Click \"Add Section\" to start.",
        },
        ocrDetails: {
          title: "OCR Details",
          menuTextRaw: "menu_text_raw",
          menuTextEdited: "menu_text_edited",
          dishesExtracted: "dishes_extracted",
          empty: "(empty)",
        },
        metadata: {
          title: "Menu Metadata",
          includesBread: "Includes Bread",
          includesDrink: "Includes Drink",
          dessertCoffeeOption: "Dessert/Coffee Option",
          notSpecified: "Not specified",
          dessert: "Dessert",
          coffee: "Coffee",
          both: "Both",
          neither: "Neither",
          servingDays: "Serving days",
          weekdaysOnly: "Weekdays Only",
          everyDay: "Every day",
          saturdayOnly: "Saturday only",
          sundayOnly: "Sunday only",
          weekendsOnly: "Weekends only",
          startHour: "Start Hour (24h)",
          endHour: "End Hour (24h)",
          cuisineType: "Cuisine Type",
          customCuisineType: "Custom Cuisine Type",
          notes: "Notes",
          notesPlaceholder: "Additional notes...",
        },
        actions: {
          save: "Save",
          saving: "Saving...",
          needsFix: "Needs Fix",
          markReviewed: "Mark Reviewed",
          shortcuts: "Shortcuts: j/k navigate, r=reviewed, f=needs fix, Ctrl/Cmd+S=save",
        },
        tooltips: {
          photo: "The original menu photo captured by users. Verify that:\n• The photo is clear and readable\n• It matches the restaurant name\n• All menu items are visible\n• The menu date is correct\n\nUse mouse wheel to zoom, click and drag to pan when zoomed in.",
          restaurant: "Verify that this restaurant name matches the menu photo. If the name doesn't match, mark the menu as 'Needs Fix' with a note explaining the mismatch.",
          preview: "This shows exactly how customers will see the menu in the app. Use this to verify that all corrections you make will display correctly.",
          menuDate: "The date this menu is valid for. Verify it matches the date shown in the photo. This helps customers know if the menu is current.",
          price: "The total price of the menu in euros. Verify this matches what's shown in the photo. Check for decimal point errors (e.g., 12.50 vs 125.00).",
          sections: "Organize menu items into sections (e.g., Starters, Mains, Desserts). Each item should have:\n• A clear, accurate name\n• Optional description\n• Correct spelling and special characters\n\nCheck that items match the photo and are in the right sections.",
          sectionName: "Section names group related items together (e.g., 'Primeros', 'Segundos', 'Postres'). Verify the grouping matches the menu structure in the photo.",
          itemName: "Menu item name. Verify spelling, special characters (ñ, é, ü), and that it matches what's shown in the photo. Common OCR mistakes: character confusion (0/O, 1/I, 5/S).",
          save: "Save your changes without changing the review status. Changes are auto-saved every 2 seconds, but you can manually save anytime. Use Ctrl/Cmd+S as a shortcut.",
          needsFix: "Mark this menu as needing fixes when:\n• Photo is too blurry or unreadable\n• Restaurant name doesn't match\n• Critical items are missing\n• OCR extraction is too incomplete\n\nAlways add a note explaining what needs to be fixed.",
          reviewed: "Approve this menu when:\n• Photo is clear and matches restaurant\n• All items are correctly extracted\n• Prices are accurate\n• Sections are properly organized\n• Any OCR errors have been corrected\n\nThis makes the menu visible to customers.",
        },
      },
      users: {
        title: "Users & roles",
        subtitle:
          "Use this page for account support, role management, disabled users, and user-level admin actions.",
        crossLinksNote:
          "Use Restaurants lookup for restaurant records, Restaurant lifecycle for claim/commercial workflows, Founder access for founder grants, and Entitlements for billing/access debugging.",
        stateNote:
          "Disabled users cannot use their account while disabled. Deleted users are soft-deleted in admin and are not permanently removed by this action.",
        navigate: "Navigate",
        accountActivity: "Account activity",
        support: "Support",
        accountStatus: "Account status",
        rolesSecurity: "Roles & security",
        destructive: "Destructive",
        linkRestaurantsLookup: "Restaurants lookup",
        linkRestaurantLifecycle: "Restaurant lifecycle",
        linkFounderAccess: "Founder access",
        linkEntitlements: "Entitlements",
        paginationPrevious: "Previous",
        paginationNext: "Next",
        paginationPage: "Page {page} of {totalPages}",
        paginationShowing: "Showing {from}–{to} of {total}",
        list: {
          searchPlaceholder: "Search by email, name, or user UUID…",
          roleFilter: "Filter by role",
          statusFilter: "Filter by status",
          userTypeFilter: "Filter by type",
          noUsers: "No users found",
          columns: {
            user: "User",
            role: "Role",
            userType: "Type",
            status: "Status",
            created: "Created",
            lastSeen: "Last Seen",
            actions: "Actions",
          },
        },
        detail: {
          profile: "Profile",
          kpis: "KPIs",
          edit: "Edit User",
          auditLog: "Audit Log",
          kpiLabels: {
            menusCreated: "Menus Created",
            reviewsCompleted: "Reviews Completed",
            flagsReceived: "Flags Received",
            uploads: "Uploads",
            lastActivity: "Last Activity",
            days7: "7d",
            days30: "30d",
            total: "Total",
          },
        },
        edit: {
          changeRole: "Change Role",
          changeUserType: "Change User Type",
          disableAccount: "Disable Account",
          enableAccount: "Enable Account",
          addNote: "Add Internal Note",
          deleteUser: "Delete User",
          role: "Role",
          userType: "User Type",
          name: "Name",
          status: "Status",
          notes: "Internal Notes",
          reason: "Reason",
          confirmDisableTitle: "Disable this user?",
          confirmDisableMessage: "This user will not be able to use their account while disabled.",
          confirmEnableTitle: "Enable this user?",
          confirmEnableMessage: "This user will be able to use their account again.",
          confirmRoleTitle: "Change user role?",
          confirmRoleBody:
            "This changes the user's access level in MenuHunter admin/app workflows. Continue?",
          confirmDelete: "Marks the user as deleted in admin. Type DELETE to confirm:",
          softDeleteUser: "Soft delete user",
          softDeleteHelper:
            "Marks the user as deleted in admin. This is not the same as the consumer account deletion pipeline.",
          saveRole: "Save role",
          save: "Save",
          cancel: "Cancel",
        },
        status: {
          active: "Active",
          disabled: "Disabled",
          deleted: "Deleted",
        },
        roles: {
          admin: "Admin",
          employee: "Employee",
          staff: "Staff",
          restaurant: "Restaurant",
          user: "User",
        },
        userTypes: {
          consumer: "Consumer",
          capture: "Capture",
          staff: "Staff",
        },
        auditLog: {
          title: "Audit Log",
          noLogs: "No audit logs available",
          columns: {
            timestamp: "Timestamp",
            actor: "Actor",
            action: "Action",
            summary: "Summary",
          },
          actions: {
            user_disable: "User disabled",
            user_enable: "User enabled",
            user_role_change: "Role changed",
            user_delete: "User soft-deleted",
            user_note_update: "Note updated",
            user_type_change: "User type changed",
            user_name_update: "Display name updated",
            userDisable: "User disabled",
            userEnable: "User enabled",
            userRoleChange: "Role changed",
            userDelete: "User soft-deleted",
            userNoteUpdate: "Note updated",
          },
        },
        errors: {
          loadFailed: "Failed to load users",
          updateFailed: "Failed to update user",
          deleteFailed: "Failed to delete user",
          unauthorized: "Unauthorized",
          adminOnly: "Only administrators can perform this action",
        },
      },
      onboarding: {
        title: "Onboarding & Trials",
        kpi: {
          eligibleUnclaimed: "Eligible Unclaimed",
          claimsPending: "Claims Pending",
          activeTrials: "Active Trials",
          expiringSoon: "Expiring in 14 Days",
        },
        filters: {
          status: "Status",
          claimed: "Claimed",
          all: "All",
          claimedOnly: "Claimed",
          unclaimedOnly: "Unclaimed",
          city: "City",
          barrio: "Barrio",
          nearEligible: "Near Eligible",
          expiring14Days: "Expiring in 14 Days",
          search: "Search restaurant...",
        },
        status: {
          not_started: "Not Started",
          near_eligible: "Near Eligible",
          eligible: "Eligible",
          claimed_pending: "Claimed Pending",
          active: "Active",
          expired: "Expired",
          converted: "Converted",
        },
        table: {
          restaurant: "Restaurant",
          location: "Location",
          engagement: "Engagement (30d)",
          progress: "Progress",
          trialStatus: "Trial Status",
          claimed: "Claimed",
          claimStatus: "Claim Status",
          trialEnds: "Trial Ends",
          actions: "Actions",
          viewDetails: "View Details",
          openInApp: "Open in App",
          menuViews: "Views",
          favorites: "Favorites",
          uploads: "Uploads",
          yes: "Yes",
          no: "No",
          none: "None",
          pending: "Pending",
          approved: "Approved",
          rejected: "Rejected",
        },
        drawer: {
          restaurantInfo: "Restaurant Information",
          trialInfo: "Trial Information",
          claimInfo: "Claim Information",
          managers: "Managers",
          engagement: "Engagement (30 days)",
          triggeredBy: "Triggered By",
          actionButtons: {
            approveClaim: "Approve Claim",
            startTrial: "Start Trial",
            copyOutreach: "Copy Outreach Message",
          },
          fields: {
            name: "Name",
            address: "Address",
            googlePlaceId: "Google Place ID",
            restaurantId: "Restaurant ID",
            status: "Status",
            started: "Started",
            ends: "Ends",
            triggered: "Triggered",
            latestClaim: "Latest Claim",
            submittedBy: "Submitted By",
            submittedAt: "Submitted At",
            contactEmail: "Contact Email",
            contactName: "Contact Name",
            user: "User",
            role: "Role",
            verifiedLevel: "Verified Level",
            menuViews: "Menu Views",
            favorites: "Favorites",
            uploads: "Uploads",
            closestThreshold: "Closest Threshold",
          },
        },
        empty: {
          noRestaurants: "No restaurants found",
          selectRestaurant: "Select a restaurant to view details",
        },
        errors: {
          loadFailed: "Failed to load data",
          approveFailed: "Failed to approve claim",
          startTrialFailed: "Failed to start trial",
          copyFailed: "Failed to copy message",
        },
        success: {
          claimApproved: "Claim approved successfully",
          trialStarted: "Trial started successfully",
          messageCopied: "Message copied to clipboard",
        },
      },
      trialOps: {
        pageTitle: "Trial operations",
        rulesHint:
          "The Status column shows one operational state (Stripe subscription first; DB trial row as fallback). Live/test still comes from the synced subscription. Small badges: Review / Needs sync = DB vs Stripe disagreement (details in the drawer); Legacy = migrated onboarding. Use Mismatches or Sync mismatch only for cleanup. Payment method is cached from Stripe.",
        stripeMode: {
          label: "Stripe mode",
          liveOnly: "Live only",
          testOnly: "Test only",
          unknownOnly: "Unknown",
          kpiHint:
            "Default Stripe mode is Live only (hides test subscriptions). KPIs and the table follow the Stripe mode filter and dataset scope.",
          badgeLive: "Live",
          badgeTest: "Test",
          badgeUnknown: "?",
        },
        scope: {
          label: "Dataset",
          trialFocus: "Trial focus",
          allRecords: "All records",
          kpiHintTrialFocus:
            "Default view: trialing, active DB trials, expired-not-converted, or DB/Stripe sync mismatch (healthy converted paid rows are hidden unless mismatched).",
          kpiHintAll:
            "All records: includes converted restaurants and other rows without current trial relevance.",
          filtersCaption:
            "KPIs reflect the dataset (trial focus vs all); quick view and KPI cards filter the table; search and advanced filters only narrow rows.",
        },
        presets: {
          label: "Quick view",
          all: "All",
          active: "Active",
          expiring: "Expiring 7d",
          expiredNc: "Expired (not converted)",
          mismatches: "Mismatches",
          converted: "Converted",
          withExtensions: "With extensions",
        },
        kpi: {
          activeTrials: "Active trials",
          expiring7d: "Expiring in 7 days",
          expiredNotConverted: "Expired, not converted",
          converted: "Converted to paid",
          avgDaysRemaining: "Avg. days remaining",
          extendedThisMonth: "Trials extended (this month)",
        },
        filters: {
          search: "Search name, email, city…",
          stripeMode: "Stripe mode",
          operationalStatus: "Operational status",
          claimStatus: "Claim status",
          paymentMethod: "Payment method on file",
          plan: "Plan",
          trialSource: "Trial source",
          legacy: "Legacy / migrated",
          legacyTooltip:
            "Shows restaurants whose trial or onboarding record comes from an older workflow or migrated data, not only the current claim-flow model.",
          all: "All",
          yes: "Yes",
          no: "No",
          unknown: "Unknown",
          mismatchOnly: "Sync mismatch only",
          mismatchTooltip:
            "Data cleanup: rows where DB trial metadata and Stripe subscription disagree. Severity (Needs sync vs Review) is in the Status column; open the drawer for DB vs Stripe details.",
        },
        opStatus: {
          trialActive: "Active access",
          paidActive: "Paid active",
          expired: "Expired",
          canceled: "Canceled",
          unknown: "Unknown",
        },
        dataQuality: {
          legacy: "Legacy",
          needsSync: "Needs sync",
          review: "Review",
        },
        table: {
          restaurant: "Restaurant",
          city: "City",
          ownerContact: "Owner / contact",
          operationalStatus: "Status",
          start: "Start",
          end: "End",
          daysLeft: "Days left",
          payment: "Payment",
          extensions: "Ext.",
          promo: "Promo",
          lastActivity: "Last activity",
          followUp: "Follow-up",
          actions: "Actions",
          openRowActions: "Open row actions menu",
          operationalStatusTooltip:
            "Single operational state: uses Stripe subscription status when available (trialing → Trial active, active → Paid active, canceled, incomplete_expired, etc.). If Stripe is missing, falls back to the DB trial row. A small badge may flag Legacy data or a DB/Stripe mismatch (open the row for details). Test/unknown Stripe mode appears only when not live.",
        },
        payment: {
          yes: "On file",
          no: "None",
          unknown: "Unknown",
        },
        drawer: {
          title: "Restaurant",
          billing: "Billing",
          stripeCustomer: "Open Stripe customer",
          audit: "Extension history",
          notes: "Internal notes",
          followUp: "Follow-up status",
          saveNotes: "Save notes & status",
          saved: "Saved",
          loadingAudit: "Loading audit…",
          noAudit: "No extension events yet.",
          mismatchWarningSoft:
            "Stripe shows this subscription as trialing, but the DB trial row is still not_started/expired/converted. This is usually metadata lag—webhooks should catch up. The restaurant is on trial in billing.",
          mismatchWarningHard:
            "Database trial state and Stripe subscription state disagree in a way that needs review (e.g. canceled/unpaid while DB still shows active trial, or both active in conflicting ways). Check webhooks and billing.",
          operationalStatusField: "Operational status",
          dbTrialRow: "DB trial row",
          billingStatusCached: "Billing status (cached)",
          stripeSubscriptionState: "Stripe subscription",
          adminLinksTitle: "Admin links",
          linkEntitlements: "Entitlement debug",
          linkRestaurant: "Restaurants (admin)",
          stripeSubscription: "Subscription in Stripe",
          stripeEnvironmentLineLive: "Stripe data: live mode (production).",
          stripeEnvironmentLineTest: "Stripe data: test mode.",
          stripeEnvironmentLineUnknown:
            "Stripe mode unknown (subscription not synced or legacy row)—confirm in Stripe before acting.",
          stripeLinkHintLive: "Opens live Stripe Dashboard",
          stripeLinkHintTest: "Opens test Stripe Dashboard",
          stripeLinkHintUnknown: "Opens live dashboard; confirm ID in Stripe if needed",
          dbTrialEnd: "Trial end (DB)",
          stripeTrialEnd: "Trial end (Stripe)",
        },
        extend: {
          title: "Extend trial",
          currentEnd: "Current trial end",
          preset7: "+7 days",
          preset14: "+14 days",
          preset30: "+30 days",
          custom: "Custom end date",
          reason: "Reason (required)",
          internalNote: "Internal note (optional)",
          submit: "Apply",
          cancel: "Cancel",
          success: "Trial end updated",
          failed: "Could not extend trial",
        },
        pristineReset: {
          title: "Reset to pristine trial",
          warning:
            "Cancels Stripe subscriptions for this restaurant and clears mirrored billing history so the claim flow treats the trial as unused. Billing impact is irreversible—confirm in Stripe if unsure.",
          reason: "Reason (required)",
          internalNote: "Internal note (optional)",
          submit: "Reset",
          cancel: "Cancel",
          success: "Trial reset to pristine",
          failed: "Could not reset trial",
          driftToast:
            "Subscription rows that affect claim eligibility still exist. Check webhooks or DB.",
          verificationFailed: "Reset ran but subscription mirror state could not be verified.",
          blockedManagedToast:
            "Reset blocked: this restaurant has a registered owner, active managers, or a live subscription in a billable state. Cancelling can revoke access.",
          blockedSubscription:
            "A live subscription exists (trialing, active, past_due, or unpaid) in the database.",
          overrideWarning:
            "Override only in exceptional cases. Type the exact phrase to confirm you understand the risk.",
          overrideToggleLabel: "Override protection (dangerous)",
          confirmPhraseInstruction:
            "Type exactly: RESET ACTIVE RESTAURANT",
          invalidConfirmation: "Confirmation phrase does not match.",
        },
      },
      common: {
        loading: "Loading...",
        error: "Error",
        noData: "No data",
      },
    },
  },
  ca: {
    hero: {
      title: "Descobreix el menú del dia, sense donar voltes.",
      subtitle: "L’accés anticipat està obert. Uneix-te als primers testers que descobreixen el menú del dia a Espanya.",
    },
    earlyAccess: {
      title: "Accés early bird (MVP tancat)",
      body: "L’accés anticipat ja està obert. Uneix-te als primers testers i ajuda a donar forma a MenúHunter.",
      emailPlaceholder: "El teu email",
      button: "Uneix-te a l’accés anticipat",
      platformIos: "iOS",
      platformAndroid: "Android",
      platformAria: "Plataforma",
      successTitle: "Estàs a la llista!",
      successWithPlatform:
        "Estàs a la llista d’accés anticipat per a {{platform}}. T’enviarem un correu quan la teva plaça estigui llesta, amb instruccions d’accés anticipat per a {{platform}}.",
      existsTitle: "Ja estàs apuntat",
      existsWithPlatform:
        "Ja eres a la llista; hem actualitzat la teva preferència a {{platform}}. T’enviarem un correu quan la teva plaça estigui llesta, amb instruccions d’accés anticipat per a {{platform}}.",
      instagramLabel: "Veure @menuhunter.app a Instagram",
      instagramButton: "Veure a Instagram",
      disclaimer: "Sense spam. Només avisos d’accés i novetats.",
      targetContext: "Sembla que intentaves obrir un enllaç de l’app. Deixa’ns el teu email i t’avisarem quan el puguis obrir des de MenúHunter.",
      errorPlatform: "Selecciona iOS o Android.",
    },
    menuShare: {
      earlyAccessCta: "Accés early bird",
      subtitle: "Vols fer servir MenúHunter quan llancem?",
    },
    download: {
      ios: "Descarrega per a iOS",
      android: "Descarrega per a Android",
      appStore: "Descarrega a l’App Store",
      playStore: "Consigueix-lo a Google Play",
      scanToDownload: "Escaneja per descarregar MenúHunter",
      freeOnStores: "Gratuït a Android i iOS",
      orVisit: "O visita:",
      openInApp: "Obre a l’app MenúHunter",
      continueOnWeb: "Continua a la web",
    },
    common: {
      goHome: "Anar a l'inici",
      language: "Idioma",
      footerNav: "Peu de pàgina",
      toggleTheme: "Canviar tema",
      switchToLightMode: "Canviar al mode clar",
      switchToDarkMode: "Canviar al mode fosc",
    },
    menuSource: {
      community: "Pujat per usuari",
      venue: "Verificat pel restaurant",
      staff: "Equip MenúHunter",
    },
    menuFreshness: {
      uploadedToday: "Pujat avui",
      uploadedYesterday: "Pujat ahir",
      uploadedHoursAgo: "Pujat fa {hours} h",
      uploadedDaysAgo: "Pujat fa {count} dies",
      uploadedOnDate: "Pujat el {date}",
    },
    product: {
      explore: "Explorar",
      search: "Cercar",
      capture: "Capturar",
      saved: "Desats",
      account: "Compte",
      login: {
        title: "Inicia la sessió",
        subtitle: "Inicia la sessió per desar menús i capturar fotos.",
        emailLabel: "Correu electrònic",
        passwordLabel: "Contrasenya",
        signInButton: "Inicia la sessió",
        googleButton: "Continua amb Google",
        appleButton: "Continuar amb Apple",
        browseGuest: "Explora sense iniciar sessió",
        loading: "Carregant…",
        signInErrorGeneric: "No s'ha pogut iniciar la sessió. Torna-ho a provar.",
        forgotPasswordLink: "Has oblidat la contrasenya?",
      },
      forgotPassword: {
        title: "Has oblidat la contrasenya?",
        subtitle: "Introdueix el teu correu i t'enviarem un enllaç per restablir-la.",
        emailLabel: "Correu electrònic",
        sendButton: "Enviar enllaç",
        sending: "Enviant…",
        success:
          "Si existeix un compte amb aquest correu, rebràs un enllaç aviat. Revisa la safata d'entrada.",
        invalidEmail: "Introdueix un correu electrònic vàlid.",
        sendErrorGeneric: "No s'ha pogut enviar el correu. Torna-ho a provar.",
        backToLogin: "Torna a iniciar sessió",
      },
      getApp: "Descarregar app",
      pwaInstall: {
        title: "Instal·lar la web app de MenúHunter",
        description: "Afegeix MenúHunter a aquest ordinador per accedir-hi ràpidament.",
        install: "Instal·lar web app",
        dismiss: "Ara no",
      },
      appBanner: "Viu l’experiència completa a l’app MenúHunter",
      exploreViewportError:
        "No hem pogut carregar menús en aquesta zona. Prova de moure el mapa o actualitzar la pàgina.",
      accountPage: {
        loading: "Carregant…",
        personalSection: "El teu compte",
        savedMenus: "Menús desats",
        settings: "Ajustos",
        notifications: "Preferències de notificacions",
        restaurantSectionTitle: "Panell del restaurant",
        restaurantSectionHint:
          "Gestiona el menú del dia, el perfil del local i l’equip.",
        openRestaurantPanel: "Obrir panell del restaurant",
        managingRestaurant: "Restaurant que gestiones: {name}",
        noRestaurantAccessTitle: "Tens un restaurant?",
        noRestaurantAccessBody:
          "L’accés al panell del restaurant apareix quan gestiones el teu local a MenúHunter o quan algú del teu equip t’afegeix.",
        claimRestaurant: "Gestionar el meu restaurant",
        signOut: "Tancar sessió",
      },
      accountSettingsPage: {
        backToAccount: "Tornar al compte",
        loading: "Carregant…",
        title: "Ajustos",
        subtitle: "Personalitza com veus MenúHunter a la web.",
        themeSection: "Aparença",
        themeLight: "Clar",
        themeDark: "Fosc",
        themeSystem: "Sistema",
        languageSection: "Idioma",
        languageEs: "Español",
        languageEn: "English",
        languageCa: "Català",
      },
      accountSavedPage: {
        backToAccount: "Tornar al compte",
        loading: "Carregant menús desats…",
        title: "Menús desats",
        subtitle: "Els teus menús del dia desats per tornar-hi quan vulguis.",
        emptyTitle: "Encara no has desat cap menú",
        emptyBody: "Explora menús a prop teu i desa els que t’interessin.",
        exploreCta: "Explorar a prop",
      },
      accountNotificationsPage: {
        backToAccount: "Tornar al compte",
        loading: "Carregant…",
        title: "Notificacions",
        subtitle:
          "Les notificacions push requereixen l’app mòbil. Aquestes preferències s’apliquen quan fas servir l’app.",
        nearbyLabel: "Menús nous a prop meu",
        nearbyHint:
          "Rep avisos quan es publica un menú del dia a prop de la teva ubicació.",
        favoritesLabel: "Actualitzacions de favorits",
        favoritesHint:
          "Rep avisos quan un restaurant desat publica un menú nou.",
        save: "Desar preferències",
        saving: "Desant…",
        saved: "Preferències desades",
      },
    },
    restaurantPanel: {
      shellTitle: "Panell del restaurant",
      nav: {
        dashboard: "Resum",
        menus: "Menús",
        billing: "Facturació",
        team: "Equip",
        qrcode: "Codi QR",
        profile: "Perfil",
      },
      home: {
        title: "Panell del teu restaurant",
        summaryTitle: "El teu restaurant",
        restaurantLabel: "Restaurant",
        statusLabel: "Estat",
        performanceTitle: "Rendiment",
        performanceHint:
          "Aquestes xifres mostren com interactuen els comensals amb el teu menú a MenúHunter.",
        performanceComingSoon:
          "Aviat afegirem mètriques de rendiment més detallades.",
        thisWeek: "Aquesta setmana",
        kpiMenuViews: "Visualitzacions del menú (7 dies)",
        kpiSaved: "Desat per usuaris",
        kpiNearby: "Restaurants propers",
        kpiNearbyPrice: "Preu mitjà proper",
        noRestaurant: "Encara no gestiones cap restaurant.",
        loading: "Carregant…",
      },
      status: {
        active: "Subscripció activa",
        trialActive: "Accés actiu",
        notSubscribed: "Sense subscripció activa",
        trialEnded: "Accés finalitzat",
        subscriptionInactive: "Subscripció inactiva",
      },
      menus: {
        title: "Menús",
        subtitle:
          "Gestiona les fotos del teu menú del dia. El menú actual és el que veuen els comensals a MenúHunter.",
        addMenu: "Afegir foto de menú",
        view: "Veure",
        viewMenu: "Veure menú",
        emptyTitle: "Encara no hi ha menús",
        emptyBody:
          "Puja una foto de la teva carta o menú del dia perquè els comensals propers et puguin trobar.",
        emptyCta: "Pujar primer menú",
        noRestaurant: "Encara no gestiones cap restaurant.",
        loading: "Carregant menús…",
        menuFallbackTitle: "Menú",
        currentBadge: "Actual",
        verification: {
          verified: "Publicat",
          pending: "En revisió",
          needsFix: "Necessita canvis",
          unknown: "Estat desconegut",
        },
      },
      billing: {
        title: "Facturació",
        subtitle:
          "Consulta l’estat de la teva subscripció i gestiona els pagaments de forma segura.",
        summaryTitle: "La teva subscripció",
        planLabel: "Pla",
        planMonthly: "Mensual",
        planAnnual: "Anual",
        trialEndsLabel: "L'accés continua fins al",
        renewsOnLabel: "Propera renovació",
        accessUntilLabel: "Accés fins",
        cancelScheduledBadge: "Cancel·lació programada",
        statusPastDue: "Pagament pendent",
        noSubscriptionBody:
          "No tens una subscripció activa. Pots subscriure’t des de l’app MenúHunter o contactar amb suport si necessites ajuda.",
        loading: "Carregant facturació…",
        appleTitle: "Subscripció a iPhone",
        appleBody:
          "Aquesta subscripció es va comprar a l’app d’iOS. No es pot gestionar des del web amb el portal de pagaments.",
        appleManageHint:
          "Gestiona la subscripció des de la plataforma on la vas comprar: Configuració → Apple ID → Subscripcions al teu iPhone.",
        portalTitle: "Gestiona a l’app",
        portalHint:
          "Les subscripcions Pro de Google Play es gestionen a l’app MenúHunter o a Google Play → Subscripcions.",
        manageSubscription: "Obrir l’app MenúHunter",
        opening: "Obrint…",
        portalUnavailable:
          "La facturació web amb Stripe ja no està disponible. Gestiona Pro a l’app (App Store o Google Play).",
        signInAgain: "Inicia sessió de nou per gestionar la facturació.",
        noPermission: "No tens permís per gestionar la facturació d’aquest restaurant.",
        noBillingAccount: "Encara no hi ha un compte de facturació vinculat a aquest restaurant.",
        noRestaurant: "Encara no gestiones cap restaurant.",
      },
      team: {
        title: "Equip",
        subtitle:
          "Consulta qui pot gestionar el teu restaurant des del panell de MenúHunter.",
        contextTitle: "El teu restaurant",
        restaurantLabel: "Restaurant",
        accessTitle: "Accés a l’equip",
        accessBody:
          "Les persones amb accés a l’equip poden actualitzar el menú, el perfil del restaurant i altres ajustos al panell. Només hi hauria d’haver accés qui realment gestiona el local.",
        membersTitle: "Persones amb accés",
        membersHint: "Aquests comptes poden entrar al panell del teu restaurant.",
        emptyTitle: "Només tu de moment",
        emptyBody:
          "Quan s’afegeixin més persones amb accés, apareixeran aquí amb el correu i el nivell d’accés.",
        memberFallback: "Persona de l’equip",
        joinedLabel: "A l’equip des del {date}",
        manageNote:
          "Per convidar o treure persones de l’equip, fes servir l’app MenúHunter al mòbil.",
        noRestaurant: "Encara no gestiones cap restaurant.",
        loading: "Carregant equip…",
        roles: {
          owner: "Titular",
          manager: "Gestor",
          staff: "Col·laborador",
          unknown: "Accés",
        },
      },
      qr: {
        title: "Codi QR",
        subtitle:
          "Porta els comensals directament a la pàgina del teu menú a MenúHunter.",
        contextTitle: "El teu restaurant",
        restaurantLabel: "Restaurant",
        aboutTitle: "Per a què serveix",
        aboutBody:
          "En escanejar el codi, els comensals obren la pàgina pública del teu restaurant amb el menú del dia actualitzat.",
        usesTitle: "On fer-lo servir",
        useTables: "A les taules o en tentets",
        useWindows: "A l’aparador o a la porta",
        useFlyers: "En cartells o flyers impresos",
        useSocial: "A les xarxes socials o WhatsApp",
        scanHint:
          "Imprimeix el codi o mostra’l en pantalla perquè el puguin escanejar amb la càmera del mòbil.",
        linkTitle: "Enllaç públic",
        linkHint: "Comparteix aquest enllaç si prefereixes no fer servir un codi QR.",
        copyLink: "Copiar enllaç",
        linkCopied: "Enllaç copiat",
        copyFailed: "No s’ha pogut copiar l’enllaç",
        openPublicPage: "Obrir pàgina pública",
        noRestaurant: "Encara no gestiones cap restaurant.",
        loading: "Carregant…",
        alt: "Codi QR del restaurant",
        stickerLangLabel: "Idioma de l’adhesiu",
        langEs: "ES",
        langCa: "CA",
        downloadSvg: "Descarregar SVG",
        downloadPng: "Descarregar PNG",
        downloadPdf: "Descarregar PDF",
        layoutLabel: "Disseny del full",
        cutLines: "Marques de tall",
        downloading: "Descarregant…",
        downloadFailed: "No s’ha pogut descarregar l’arxiu",
        partnerTitle: "Encargar adhesius",
        partnerBody:
          "Encarrega adhesius impresos al nostre partner amb el disseny MenúHunter llest per imprimir.",
        partnerOrder: "Encargar adhesius",
        partnerCopyCode: "Copiar codi",
        partnerCodeCopied: "Codi copiat",
        partnerRecommendedLayout: "Disseny recomanat",
      },
      profile: {
        title: "Perfil del restaurant",
        subtitle:
          "Aquesta informació apareix a la pàgina pública del teu restaurant a MenúHunter.",
        basicSection: "Informació bàsica",
        nameLabel: "Nom del restaurant",
        nameHint: "El nom que veuran els comensals en cercar el teu local.",
        namePlaceholder: "p. ex. Bar La Plaça",
        addressLabel: "Adreça",
        addressHint: "Ajuda a ubicar el teu restaurant al mapa i a les cerques.",
        addressPlaceholder: "Carrer, número, ciutat…",
        publicPageLabel: "Pàgina pública",
        publicPageHint: "Així veuen els comensals el teu restaurant a la web.",
        viewPublicPage: "Veure pàgina pública",
        save: "Desar canvis",
        saving: "Desant…",
        saved: "Canvis desats",
        saveError: "No s’han pogut desar els canvis. Torna-ho a provar.",
        loading: "Carregant perfil…",
        noRestaurant: "Encara no gestiones cap restaurant.",
        missingNameHint: "Afegeix el nom del teu restaurant perquè els comensals et reconeguin.",
        missingAddressHint: "L’adreça ajuda a mostrar el teu local al mapa.",
      },
      common: {
        emDash: "—",
        loading: "Carregant…",
      },
    },
    communityCta: {
      compactPrefix: "Has vist un menú?",
      compactLink: "Puja'l en 10 segons",
      compactSuffix: "i ajuda a mantenir frescos els menús a prop teu.",
      bannerTitle: "Has vist un menú? Puja'l en 10 segons.",
      bannerBody:
        "Amb l'app de MenúHunter pots ajudar a mantenir actualitzats els menús del dia a la teva ciutat — comencem a Barcelona. Sense promeses de pagament: només comunitat.",
      bannerLink: "Descarregar l'app →",
    },
    menuDetailPage: {
      loading: "Carregant menú…",
      notFoundTitle: "Menú no trobat",
      notFoundBody: "El menú que busques no existeix o s'ha eliminat.",
      backHome: "Tornar a l'inici",
      openAppPrompt:
        "Obre aquest menú a MenúHunter per veure més detalls i desar preferits.",
      openInApp: "Obrir a l'app",
      downloadApp: "Descarregar l'app",
      menuOfTheDay: "Menú del dia",
      tagsLabel: "Etiquetes",
      allergensLabel: "Al·lèrgens",
      menuTextUnavailableShort: "Text del menú encara no disponible.",
      menuTextUnavailableLong:
        "Text del menú encara no disponible, però pots veure la imatge del menú pujada.",
      photoAlt: "Menú de {name}",
      viewRestaurant: "Veure restaurant",
    },
    explorePage: {
      title: "Menús a prop",
      nearMe: "A prop meu",
      searchThisArea: "Cercar en aquesta zona",
      updating: "Actualitzant…",
      menuFoundOne: "1 menú trobat",
      menuFoundMany: "menús trobats",
      recentUploadOne: "1 pujat recentment",
      recentUploadMany: "pujats recentment",
      onMapOne: "1 restaurant al mapa",
      onMapMany: "restaurants al mapa",
      recentShortOne: "1 rec.",
      recentShortMany: "rec.",
      onMapShort: "al mapa",
      listedRestaurants: "Restaurants llistats",
      noMenuRestaurants: "Restaurants sense menú",
      listedRestaurant: "Restaurant llistat",
      viewMenu: "Veure menú",
      viewRestaurant: "Veure restaurant",
      viewMenuWithName: "Veure menú —",
      viewRestaurantWithName: "Veure restaurant —",
      restaurant: "Restaurant",
      adjustListPanel: "Ajustar el panell de llista",
      loading: "Carregant…",
      emptyTitle: "No hi ha restaurants en aquesta zona",
      emptyBody:
        "Prova d’allunyar el mapa, moure’t a una altra zona o activar la ubicació amb «A prop meu».",
      listedOnlyHint:
        "No hi ha menús capturats en aquesta zona. Aquests restaurants apareixen al mapa com a llistats.",
      hideNoMenu: "Amagar restaurants sense menú",
      showNoMenu: "Mostrar restaurants sense menú",
      restaurantFallback: "Restaurant",
      restaurantMarkerAria: "Restaurant",
      menuPriceAria: "Preu del menú: {price}",
      loadingMap: "Carregant el mapa…",
      mapLoadError: "No s'ha pogut carregar Google Maps",
      mapUnavailable: "El mapa no està disponible temporalment.",
      mapListStillAvailable: "La llista de restaurants continua disponible.",
      closeSelectedDetail: "Tancar detall",
      drawerDetails: "Detalls",
      drawerMenuDelDia: "Menú del dia",
      drawerLastUpload: "Última pujada",
      drawerIncludes: "Inclou",
      drawerIncludeDrink: "Beguda",
      drawerIncludeBread: "Pa",
      drawerIncludeDessert: "Postre",
      drawerIncludeCoffee: "Cafè",
      drawerNotes: "Notes",
      drawerDishes: "Plats",
      drawerDishesHint: "Obre el menú complet per veure tots els plats.",
      drawerNoDishesHint: "La llista completa de plats és a la pàgina del menú.",
    },
    searchPage: {
      title: "Cercar",
      placeholder: "Cerca restaurants o zones",
      locationHint:
        "Per defecte es cerca a Barcelona. Fes servir Explorar → A prop meu per a la teva ubicació.",
      loading: "Cercant…",
      emptyTitle: "No s’han trobat resultats",
      emptyBody: "Prova amb un altre restaurant, barri o zona.",
    },
    features: {
      realMenus: {
        title: "Menús Reals",
        description: "Veure fotos reals de menús capturades diàriament de restaurants a prop teu.",
      },
      locationBased: {
        title: "Basat en Ubicació",
        description: "Troba restaurants i menús segons la teva ubicació actual.",
      },
      dailyUpdates: {
        title: "Actualitzacions Diàries",
        description: "Els menús s’actualitzen diàriament perquè sempre vegis el que hi ha avui.",
      },
    },
    staff: {
      question: "Ets personal?",
      login: "Inicia sessió al panell d’administració",
    },
    footer: {
      copyright: "MenúHunter™. Tots els drets reservats.",
    },
    scan: {
      hero: {
        headline: "Descobreix el menú del dia d’avui a prop teu",
        subheadline: "Troba ofertes de menú a prop, mira plats i preus del dia i tria on menjar en segons.",
        desktopHelper: "Obre això al mòbil per descarregar",
        links: {
          exploreMenus: "Explora menús del dia",
          interactiveMap: "Veure mapa interactiu",
          restaurants: "Per a restaurants",
        },
      },
      cta: {
        appStore: "Descarrega a l’App Store",
        googlePlay: "Consigueix-lo a Google Play",
      },
      trust: {
        free: "Gratuït",
        barcelona: "Creixent cada dia",
        updated: "Actualitzat a diari",
        pills: [
          "Gratuït per a usuaris",
          "iPhone i Android",
          "Menús reals",
          "Actualitzat a diari",
          "Restaurants verificats",
        ],
      },
      howItWorks: {
        title: "Com funciona",
        find: "Troba menús a prop",
        see: "Veure preus i plats",
        save: "Desa els teus favorits",
      },
      value: {
        title: "Per què MenúHunter",
        updated: "Actualitzat a diari",
        barcelona: "Fet per caçadors de menú a Espanya",
        fast: "Compara opcions de menú a prop en segons",
      },
      showcase: {
        title: "Com es veu",
        subtitle: "Menús al mapa, plats d'avui i favorits en una sola app.",
        map: "Mapa",
        menus: "Menús",
        today: "Avui",
      },
      benefits: {
        eyebrow: "Per a comensals",
        title: "Tot el que necessites per triar",
        find: {
          title: "Menús a prop",
          desc: "Troba ofertes de menú al teu voltant i compara en segons.",
        },
        map: {
          title: "Explora menús al mapa",
          desc: "Localitza restaurants i menús per zona i tria amb el mapa.",
        },
        dishes: {
          title: "Plats i preus reals",
          desc: "Veu el menú del dia i els preus abans de decidir.",
        },
        featured: {
          title: "Menús destacats",
          desc: "Descobreix opcions destacades i recomanades a prop.",
        },
        latest: {
          title: "Últimes pujades",
          desc: "Consulta les últimes actualitzacions de menú del dia.",
        },
        favourites: {
          title: "Desa favorits",
          desc: "Desa els teus llocs favorits i decideix més ràpid.",
        },
      },
      neighbourhoods: {
        eyebrow: "Explora per barri",
        title: "Explora per barri",
        subtitle: "Descobreix els millors menús de migdia a cada barri.",
      },
      owner: {
        eyebrow: "Per a restaurants",
        headline: "Vols el teu restaurant a MenúHunter?",
        intro: "MenúHunter ajuda la gent que està a prop a descobrir el teu menú del dia, preus i plats. Les eines per gestionar el teu restaurant arribaran aviat; de moment, la millor manera d'entendre la plataforma és descarregar l'app i veure com hi apareixen els restaurants per als comensals propers.",
        benefit1: "Mira com es veuen els menús per als comensals propers",
        benefit2: "Descobreix com es mostren els restaurants al mapa",
        benefit3: "Mantén el teu menú visible per a qui busca menjar a prop",
        benefit4: "Les eines per gestionar el teu restaurant arribaran aviat",
      },
      sections: {
        nearby: {
          title: "Menús a prop",
          desc: "Troba menús a prop, mira què hi ha disponible al teu voltant i compara opcions ràpidament.",
        },
        dishes: {
          eyebrow: "Detall del menú",
          title: "Plats i preus",
          desc: "Veure els plats del dia i els preus abans de triar.",
          bullet1: "Plats i preus reals del dia",
          bullet2: "Fotos de menús i cartes capturades",
          bullet3: "Informació clara de restaurant i menú",
          bullet4: "Decideix millor abans d'anar",
        },
        feed: {
          eyebrow: "Descobriment",
          title: "Descobreix cada dia",
          desc: "Menús nous cada dia i opcions destacades a prop.",
          bullet1: "Menús recentment pujats",
          bullet2: "Opcions destacades i locals",
          bullet3: "Descobriment proper en un cop d'ull",
          bullet4: "Navega ràpid per les opcions del dia",
        },
      },
      restaurant: {
        heading: "Tens un restaurant?",
        copy: "Gestiona la teva pàgina i mantén el teu menú del dia visible.",
        button: "Descarrega l'app",
      },
    },
    homePage: {
      hero: {
        title: "Menú del dia, més ràpid",
        subtitle:
          "Descobreix menús del dia a prop, fotos reals, preus, favorits i alertes — tot en un mapa.",
        downloadLabel: "Descarrega MenúHunter",
        exploreMapCta: "Explorar el mapa",
        mapAlt: "Mapa de menús del dia a MenúHunter",
        exploreMenus: "Explorar menús del dia",
        interactiveMap: "Veure mapa interactiu",
        forRestaurants: "Per a restaurants",
        showcase: {
          cards: [
            {
              title: "Troba el menú d'avui",
              subtitle: "Explora el mapa del menú del dia a prop teu i filtra per zona.",
              imageAlt: "Mapa de menús del dia a MenúHunter",
            },
            {
              title: "Fotos reals del menú",
              subtitle: "Compara plats, preus i captures reals de la comunitat.",
              imageAlt: "Detall de menú amb fotos a MenúHunter",
            },
            {
              title: "Comparteix llistes",
              subtitle: "Convida amics i comparteix rutes de menú del dia.",
              imageAlt: "Llistes compartides de menú del dia a MenúHunter",
            },
            {
              title: "Alertes de menú",
              subtitle: "T'avisem quan hi ha novetats a prop o als teus favorits.",
              imageAlt: "Alertes de menú del dia a MenúHunter",
            },
          ],
        },
      },
      trust: {
        pills: [
          "Gratuït per a usuaris",
          "iPhone i Android",
          "Menús reals",
          "Pujat per la comunitat",
          "Menús frescos",
          "Restaurants verificats",
        ],
      },
      howItWorks: {
        title: "Com funciona",
        subtitle: "Descobreix, compara i contribueix al mapa del menú del dia a prop teu.",
        stepLabel: "Pas",
        steps: [
          {
            title: "Troba menús a prop teu",
            description:
              "Explora el mapa col·laboratiu del menú del dia a prop teu i filtra per zona.",
          },
          {
            title: "Mira fotos, preu i distància",
            description:
              "Compara menús amb fotos reals, preu actualitzat i ubicació al mapa.",
          },
          {
            title: "Puja un menú i ajuda altres",
            description:
              "Contribueix amb un menú del dia que hagis vist i millora el mapa per a tothom.",
          },
        ],
      },
      differentiators: {
        title: "Per què MenúHunter és diferent",
        items: [
          {
            title: "Impulsat per la comunitat",
            description:
              "Menús reals pujats per persones a la teva ciutat, no directoris genèrics.",
          },
          {
            title: "Menús frescos d'avui",
            description:
              "Prioritzem captures recents perquè vegis què es serveix avui i aquesta setmana.",
          },
          {
            title: "Restaurants verificats",
            description:
              "Els locals poden gestionar i verificar el seu perfil com a capa de confiança.",
          },
          {
            title: "iPhone i Android",
            description:
              "L'experiència completa és a l'app mòbil, disponible a les dues botigues.",
          },
        ],
      },
      restaurants: {
        eyebrow: "Per a restaurants",
        headline: "Fes que et trobin quan busquen menú del dia",
        subtitle:
          "Publica el menú d'avui i sigues més visible per als comensals propers. Sense comissions.",
        primaryCta: "Gestionar el meu restaurant",
        secondaryCta: "Veure tot per a restaurants",
        claimHint: "Gestiona el teu restaurant des de l'app en pocs passos.",
        menuAlt: "Detall de menú del dia a MenúHunter",
      },
      neighborhoods: {
        title: "Explora per barris",
        subtitle: "Explora menús del dia per zona — comencem a Barcelona.",
        items: [
          { slug: "menu-del-dia-barcelona", label: "Barcelona" },
          { slug: "menu-del-dia-barcelona-eixample", label: "Eixample" },
          { slug: "menu-del-dia-barcelona-gracia", label: "Gràcia" },
          { slug: "menu-del-dia-barcelona-sant-antoni", label: "Sant Antoni" },
          { slug: "menu-del-dia-barcelona-poblenou", label: "Poblenou" },
          { slug: "menu-del-dia-barcelona-el-raval", label: "El Raval" },
          { slug: "menu-del-dia-barcelona-gotic", label: "Gòtic" },
          { slug: "menu-del-dia-barcelona-born", label: "Born" },
        ],
      },
      closing: {
        title: "Descarrega MenúHunter",
        subtitle: "El mapa col·laboratiu del menú del dia, a la butxaca. Llançament a Barcelona.",
        openMap: "Obrir mapa interactiu",
      },
    },
    communityPage: {
      hero: {
        title: "Restaurants i veïns, junts al mapa",
        subtitle:
          "Els locals publiquen el menú del dia i la comunitat ajuda a omplir buits amb fotos reals. Així el mapa es manté fresc i útil.",
      },
      stats: {
        ariaLabel: "Xifres en viu de MenúHunter",
        restaurantsListed: "Restaurants al mapa",
        liveNote: "Xifra en viu · s'actualitza sola",
      },
      contribute: {
        title: "Has vist un menú? Puja'l en 10 segons",
        body: "Quan un local encara no ha publicat el d'avui, la teva foto ajuda tothom. Obre l'app, captura la pissarra i mantén fresc el mapa — comencem a Barcelona.",
        downloadLabel: "Descarrega MenúHunter",
        cta: "Anar a descarregar",
      },
      restaurants: {
        title: "Tens un restaurant?",
        body: "Publica el menú del dia, controla el perfil i destaca quan la gent cerca a prop. La comunitat complementa; tu manes al teu local.",
        cta: "Veure per a restaurants",
      },
      follow: {
        title: "Segueix-nos",
        body: "Descobriments del dia, consells de ciutat i novetats de l'app a les xarxes.",
        socialNavAria: "Xarxes socials de MenúHunter",
      },
      explore: {
        title: "Mira el mapa en viu",
        body: "Menús de restaurants i de la comunitat, filtrats per zona, a prop teu.",
        cta: "Obrir el mapa",
      },
      ways: {
        title: "Més maneres de participar",
        subtitle: "Cada aportació — teva o del local — fa el mapa més útil.",
        items: [
          {
            title: "Puja un menú com a comensal",
            description: "Captura el menú del dia des de l'app i ajuda a omplir buits.",
          },
          {
            title: "Gestiona el teu restaurant",
            description: "Publica el menú oficial, verifica el perfil i arriba a comensals propers.",
          },
          {
            title: "Explora el mapa en viu",
            description: "Descobreix què hi ha avui i troba on menjar.",
          },
          {
            title: "Etiqueta'ns quan trobis una joia",
            description: "Comparteix a Instagram i menciona @menuhunter.app.",
          },
          {
            title: "Creators i partners",
            description: "Fas contingut o vols col·laborar? Escriu-nos a team@menuhunter.app.",
          },
          {
            title: "Actualitza menús desfasats",
            description: "Preu o plats incorrectes? Puja la pissarra d'avui i ho corregim entre tots.",
          },
        ],
      },
    },
    restaurantsPage: {
      hero: {
        eyebrow: "PER A RESTAURANTS",
        title: "Dona més visibilitat al teu menú del dia",
        subtitle:
          "Arriba a persones properes que busquen on dinar a MenúHunter, des de l'app i el web.",
        phoneAlt: "Menú del dia d'un restaurant a MenúHunter",
        chips: {
          noCommissions: "Compte gratis per a restaurants",
          planMonthlyAnnual: "Pla mensual o anual",
          platforms: "iPhone i Android",
          availableAcrossSpain: "Disponible a tot Espanya",
        },
      },
      heroValueProps: {
        title: "Per què els restaurants fan servir MenúHunter",
        items: [
          {
            title: "Publica en segons",
            description:
              "Fes una foto del menú d'avui i MenúHunter el converteix en un menú digital clar.",
          },
          {
            title: "Apareix a prop dels teus clients",
            description:
              "El teu restaurant apareix al mapa quan algú busca un menú del dia a prop.",
          },
          {
            title: "Publica gratis",
            description:
              "Els restaurants poden publicar el seu menú del dia fàcilment i mantenir-lo actualitzat sense complicacions.",
          },
        ],
      },
      cta: {
        startTrial: "Gestionar el meu restaurant",
        seeHowItWorks: "Com funciona",
        downloadApp: "Descarrega l'app",
        howToClaim: "Com gestionar el teu restaurant",
        claimRestaurant: "Gestiona el teu restaurant",
        showMenuFree: "Mostra el teu menú gratis",
      },
      claim: {
        invalidLink:
          "Aquest enllaç no inclou un restaurant vàlid. Per gestionar el teu restaurant, descarrega l'app de MenúHunter, crea un compte i busca el teu local per iniciar la sol·licitud des de l'app.",
        loading: "Carregant dades del restaurant…",
        bannerWithName:
          "Gestiones {{name}}? Descarrega MenúHunter, crea un compte i gestiona el teu restaurant des de l'app per publicar el menú del dia, revisar la informació i aparèixer com a restaurant verificat.",
        bannerGeneric:
          "Gestiones aquest restaurant? Descarrega MenúHunter, crea un compte i gestiona el teu restaurant des de l'app per publicar el menú del dia, revisar la informació i aparèixer com a restaurant verificat.",
      },
      valueProps: {
        title: "Per què unir-te a MenúHunter",
        subtitle:
          "El mapa col·laboratiu del menú del dia, amb restaurants verificats i menús reals de la comunitat.",
        items: [
          {
            title: "Publica el teu menú del dia en 10 segons",
            description:
              "Fes una foto del menú d'avui i MenúHunter el converteix en un menú digital clar, llest perquè la gent el vegi.",
          },
          {
            title: "Apareix al mapa quan la gent busca on menjar",
            description:
              "El teu restaurant es mostra a persones properes que exploren menús del dia.",
          },
          {
            title: "Accés gratis per a restaurants",
            description:
              "Els restaurants poden publicar el seu menú del dia gratis, mantenir-lo actualitzat i fer servir eines senzilles pensades per a menús diaris.",
          },
          {
            title: "Controla fotos, preu, horari i informació",
            description: "Actualitza la teva fitxa i el menú quan vulguis des de l'app.",
          },
          {
            title: "Perfil verificat per generar confiança",
            description:
              "En gestionar i verificar, els comensals veuen que gestiones el teu local.",
          },
          {
            title: "Disponible a iPhone, Android i web",
            description:
              "La gent pot trobar el teu menú del dia des de l'app o el web, tant si és a prop com si busca opcions per dinar des de l'oficina.",
          },
        ],
      },
      pricing: {
        headline: "Tria com apareix el teu restaurant a MenúHunter",
        supporting:
          "Comença gratis amb tot el necessari per publicar i mantenir visible el teu menú del dia. Passa a Pro quan vulguis més abast, més visibilitat i dades sobre els teus clients.",
        tagline: "Els restaurants Free apareixen al llistat. Els restaurants Pro destaquen.",
        trialBadge: "Pro",
        plans: {
          free: {
            name: "Free",
            price: "€0",
            billingLabel: "/ mes",
            commitment: "Sense targeta. Sense quota mensual.",
            tagline: "Gestiona el teu restaurant i mantén al dia tot el que necessiten els clients, sense targeta ni quota mensual.",
            cta: "Continuar amb Free",
            features: {
              claimRestaurant: "Gestiona i verifica el teu restaurant",
              publishMenu: "Publica i actualitza el Menú del Dia",
              detailsHours: "Gestiona les dades del restaurant i l’horari",
              photosSocial: "Afegeix fotos i enllaços socials",
              menuQr: "Crea i comparteix el codi QR del menú",
              searchAndMap: "Apareix a la cerca i al mapa amb el marcador estàndard",
              basicViews: "Consulta visualitzacions bàsiques del menú i desats",
              noMonthlyCharge: "Sense quota mensual",
            },
          },
          pro: {
            name: "Pro",
            monthlyPrice: "€14.99",
            monthlyLabel: "/ mes",
            annualPrice: "€149.99",
            annualLabel: "/ any",
            trialBadge: "",
            tagline:
              "Tot el de Free, més eines per guanyar visibilitat, entendre l’interès dels clients i fer que tornin.",
            cta: "Explorar Pro",
            features: {
              boostedVisibility: "Més visibilitat a MenuHunter",
              featuredCarousels: "Elegibilitat per a Destacats a l’Inici",
              followerNotifications: "Avisos a les persones que han desat el restaurant",
              analytics: "Analítiques avançades del restaurant",
              enhancedProfile: "Perfil de restaurant millorat",
              teamAccess: "Accés per a diversos membres de l’equip",
              prioritySupport: "Suport prioritari i accés anticipat a noves eines",
            },
          },
        },
        features: {
          profile: "Perfil de restaurant a MenúHunter",
          discovery: "Fes que et trobin persones que busquen menú del dia",
          updateDaily: "Mostra el menú d'avui als clients — cada dia",
          qrCode: "Comparteix el menú d'avui amb un codi QR únic",
          photos: "Controla les teves fotos i destaca al mapa",
          editAnytime: "Edita horaris, preu i detalls del menú quan vulguis",
          verified: "Insígnia de propietari verificat",
          noCommission: "Sense comissions per client ni venda",
          trial: "Pla mensual o anual",
          cancel: "Cancel·la quan vulguis",
        },
      },
      howItWorks: {
        title: "Com funciona per a restaurants",
        subtitle:
          "Gestionar o verificar el teu perfil afegeix una capa de confiança. Mentrestant, la comunitat també pot ajudar que el teu local aparegui al mapa.",
        stepLabel: "Pas",
        steps: [
          {
            title: "Gestiona o afegeix el teu restaurant",
            description:
              "Si ja apareixes al mapa, gestiona'l. Si no, crea'l en pocs passos des de l'app.",
          },
          {
            title: "Publica el menú del dia",
            description:
              "Puja la foto del menú d'avui perquè la gent vegi preu i plats actuals.",
          },
          {
            title: "Apareix al mapa i arriba a persones properes",
            description:
              "Quan publiques, el teu restaurant guanya visibilitat per a qui busca on menjar a prop.",
          },
        ],
      },
      community: {
        title: "Mapa impulsat per la comunitat",
        body:
          "MenúHunter no depèn només que cada restaurant publiqui cada dia. La comunitat també pot pujar menús reals, ajudant que més locals apareguin al mapa. Quan un restaurant es verifica, guanya control sobre el seu perfil i una capa extra de confiança.",
      },
      faq: {
        title: "Preguntes freqüents",
        items: [
          {
            q: "MenúHunter cobra comissió?",
            a: "No. No cobrem comissió per client ni venda. Només la subscripció mensual o anual.",
          },
          {
            q: "Quant costa?",
            a: "Free no té càrrec mensual. Pro costa {{monthlyPrice}} €/mes o {{annualPrice}} €/any.",
          },
          {
            q: "Puc fer servir MenúHunter gratis?",
            a: "Sí. Els restaurants poden publicar el seu menú del dia gratis. Els plans de pagament són opcionals i afegeixen més visibilitat, abast i eines per a restaurants.",
          },
          {
            q: "Puc controlar les fotos i la informació del meu restaurant?",
            a: "Sí. En gestionar el teu perfil pots actualitzar menú, fotos, horaris i dades de contacte.",
          },
          {
            q: "Què vol dir restaurant verificat?",
            a: "Indica que el local ha gestionat el seu perfil i pot publicar i mantenir la seva informació amb una capa extra de confiança.",
          },
          {
            q: "Els usuaris també poden pujar menús?",
            a: "Sí. La comunitat pot aportar menús reals. Quan verifiques el teu restaurant, tu controles el teu perfil i com es presenta.",
          },
          {
            q: "Necessito una app especial per a restaurants?",
            a: "Gestiones el teu restaurant des de l'app MenúHunter (iPhone o Android). Et guiem en el procés d'alta o gestió.",
          },
        ],
      },
      claimFlow: {
        title: "Com gestionar el teu restaurant",
        body:
          "Per gestionar el teu restaurant a MenúHunter, descarrega l'app, crea un compte i busca el teu restaurant. Des de la fitxa del restaurant podràs iniciar la gestió i completar el procés dins de l'app.",
        steps: [
          "Descarrega l'app MenúHunter des de l'App Store o Google Play.",
          "Crea un compte o inicia sessió amb el teu correu.",
          "Fes servir el cercador per trobar el teu restaurant.",
          "Obre la fitxa del teu restaurant i comença la gestió des de l'app.",
          "Si tens un codi promocional o oferta, fes-lo servir durant el flux de gestió.",
        ],
        ctaTitle: "Comença des de l'app",
        ctaBody:
          "Obre MenúHunter al mòbil per gestionar el teu restaurant, publicar el teu menú del dia i gestionar la teva visibilitat.",
        supportFallback:
          "Si tens problemes per gestionar el teu restaurant des de l'app, pots contactar amb suport.",
      },
      links: {
        navAria: "Enllaços útils",
        home: "Inici",
        barcelonaMenus: "Menús a Barcelona",
        download: "Descarregar app",
        support: "Suport",
        privacy: "Privacitat",
        terms: "Termes",
      },
    },
    supportPage: {
      documentTitle: "Suport | MenúHunter",
      metaDescription:
        "Contacta amb el suport de MenúHunter per compte, restaurant, menú, subscripció o problemes amb l’app.",
      title: "Suport",
      intro:
        "Contacta amb MenúHunter per problemes de compte, gestió de restaurant, menús, subscripció o l’aplicació. La manera més ràpida és des de l’app; també ens pots escriure per correu si no la pots fer servir.",
      emailEyebrow: "Correu",
      emailTitle: "Escriu-nos",
      emailBody:
        "Per ajuda amb el teu compte, un restaurant, un menú, la subscripció o l’app, escriu a:",
      emailCta: "Enviar correu a suport",
      appEyebrow: "A l’app",
      appTitle: "Suport des de MenúHunter",
      appIntro: "La manera recomanada de contactar amb el nostre equip:",
      appStep1: "Obre MenúHunter al mòbil.",
      appStep2: "Ves a la pestanya Perfil (ajustos del teu compte).",
      appStep3: "Toca Suport, al costat de Privacitat i Termes.",
      appDetail:
        "Després, tria el tipus d’incidència, afegeix un títol i una descripció, i opcionalment adjunta fins a 3 captures abans d’enviar la sol·licitud.",
      mockupAlt: "Pantalla de suport a l’app MenúHunter",
      mockupImageSrc: "/images/support/in-app-support-ca.png",
      includeEyebrow: "Què incloure",
      includeTitle: "Per ajudar-te més de pressa",
      includeEmail: "El correu electrònic que fas servir a l’app",
      includeRestaurant: "El nom del restaurant, si escau",
      includeScreenshots: "Captures de pantalla, si són útils",
      includeDescription: "Una descripció breu del problema",
      issuesEyebrow: "Tipus d’incidència",
      issuesTitle: "Sobre què ens pots escriure",
      issueAccount: "Problemes de compte",
      issueSubscription: "Subscripció i pagaments",
      issueClaiming: "Gestionar un restaurant",
      issueMenu: "Informació incorrecta del menú",
      issueTechnical: "Problema tècnic",
      issueOther: "Altre",
      fallback:
        "Si no pots fer servir l’app, en casos excepcionals pots escriure a soporte@menuhunter.app.",
      downloadHint: "Encara no tens l’app?",
      downloadLink: "Descarregar MenúHunter",
      footerRestaurantsLink: "Per a restaurants",
    },
    restaurantLanding: {
      invalidLink: "Enllaç de restaurant no vàlid",
      invalidId: "ID de restaurant no vàlid",
      downloadMenuhunter: "Descarrega MenúHunter",
      opening: "Obrint MenúHunter…",
      redirectHint: "Si l’app no s’obre, seràs redirigit a la botiga d’aplicacions.",
      viewMenuHint: "Per veure el menú d’aquest restaurant, descarrega l’app MenúHunter.",
      downloadOnAppStore: "Descarrega a l’App Store",
      downloadOnPlay: "Descarrega a Google Play",
      seeAllOptions: "Veure totes les opcions de descàrrega",
    },
    restaurantSharePage: {
      loading: "Carregant restaurant…",
      notFoundTitle: "Restaurant no disponible",
      notFoundBody: "Aquest enllaç no correspon a un restaurant públic o ja no està disponible.",
      ctaHint: "Per alertes i la millor experiència, obre MenúHunter al mòbil.",
      openInApp: "Obrir a l’app",
      downloadApp: "Descarregar MenúHunter",
      claimBanner: {
        headline: "Ets el propietari o gestiones aquest restaurant?",
        subtext: "Descarrega l’app i gestiona la fitxa des de MenúHunter",
        cta: "Gestionar a l’app",
      },
      menusHeading: "Menús del dia",
      noMenus: "Encara no hi ha cap menú publicat per a aquest restaurant. Torna aviat o obre l’app per a més detalls.",
      viewMenuLink: "Veure menú",
      backHome: "← Tornar a l’inici",
      errorTitle: "No s’ha pogut carregar",
      errorBody: "Comprova la connexió i torna-ho a provar.",
      tabMenu: "Menú",
      tabPhotos: "Fotos",
      tabReviews: "Ressenyes",
      tabInfo: "Info",
      tabDirections: "Com arribar",
      tabClaim: "Gestionar",
      reviewsTabTitle: "Ressenyes a l'app",
      reviewsTabBody:
        "Les valoracions i ressenyes de comensals estan disponibles a MenúHunter per a mòbil. Descarrega l'app per llegir i deixar opinions.",
      claimTabIntro:
        "Ets el propietari o gestiones aquest restaurant? Descarrega l’app, crea un compte i gestiona la fitxa des de l’app.",
      claimTabButton: "Gestionar a l’app",
      categoryDaily: "Menú del dia",
      categoryChristmas: "Nadal ({count})",
      christmasHeading: "Menús de Nadal",
      christmasEmpty: "No hi ha paquets de Nadal públics per a aquest restaurant.",
      christmasUntitled: "Paquet de Nadal",
      christmasPerPerson: "per persona",
      christmasPerPackage: "per menú",
      christmasOpenImages: "Veure fotos del menú",
      christmasBackToRestaurant: "Veure restaurant",
      availability: {
        archived: "Retirat",
        upcoming: "Properament",
        available: "Disponible",
        expired: "Caducat",
        season_confirmed: "Temporada confirmada",
        undated_unconfirmed: "Sense dates",
      },
      viewerClose: "Tancar",
      viewerPrevious: "Anterior",
      viewerNext: "Següent",
      viewerZoomIn: "Ampliar",
      viewerZoomOut: "Reduir",
      viewerBroken: "No s’ha pogut carregar la imatge",
      viewerLoading: "Carregant…",
      viewerOf: "de",
      offeringNotFoundTitle: "Menú de Nadal no disponible",
      offeringNotFoundBody:
        "Aquest enllaç no correspon a un menú de Nadal públic o ja no està disponible.",
      offeringWithdrawn: "Aquest paquet ja no està publicat.",
      offeringDatesRange: "Dates confirmades: {from} – {to}",
      offeringDatesFrom: "Des de {from}",
      offeringDatesUntil: "Fins a {to}",
      offeringSeasonLabel: "Temporada: {label}",
    },
    verifyClaim: {
      loadingTitle: "Verificant la teva sol·licitud...",
      loadingMessage: "Espera mentre verifiquem el teu correu electrònic.",
      successTitle: "Correu verificat!",
      successMessage: "Gràcies — el teu correu està verificat. Ara pots gestionar el teu restaurant a l’app de MenúHunter.",
      successTeamMessage: "",
      viewInApp: "",
      openApp: "Obre l’app MenúHunter",
      viewOnWeb: "Veure a la web",
      errorTitle: "Verificació fallida",
      errorMissingToken: "Manca l’enllaç de verificació.",
      errorInvalidToken:
        "Enllaç no vàlid, caducat o substituït per un de nou. Si has demanat un altre correu de verificació, usa només l’enllaç del missatge més recent.",
      errorRpcFailure: "No s’ha pogut completar la verificació per un error del servidor. Torna-ho a provar més tard.",
      errorClaimNotFound: "No s’ha trobat la sol·licitud associada a aquest enllaç.",
      errorVerificationFailed: "La verificació ha fallat. L’enllaç pot haver caducat o ja s’ha fet servir.",
      errorPaymentNotStarted: "El pagament no ha començat. Torna a l’app per completar el pagament i després verifica el teu correu.",
      errorGeneric: "S’ha produït un error durant la verificació.",
      errorServerError: "S’ha produït un error al servidor. Torna-ho a provar més tard.",
      resendTitle: "Reenviar correu de verificació",
      emailLabel: "Correu electrònic",
      emailPlaceholder: "el_teu@email.com",
      resendButton: "Reenviar correu de verificació",
      resendSending: "Enviant...",
      resendSent:
        "Correu enviat! Revisa la bústia d’entrada. Si ja havies demanat un altre, només el darrer missatge té un enllaç vàlid.",
      resendSectionHint:
        "Si demanes un correu nou, els enllaços antics deixen de funcionar. Obre sempre l’enllaç del missatge més recent.",
      resendNoClaim: "No hi ha cap sol·licitud amb aquest correu.",
      resendError: "Error en reenviar el correu.",
      loadingFallback: "Carregant...",
      closeTab: "Pots tancar aquesta pestanya.",
      emailRequired: "El correu electrònic és obligatori",
    },
    admin: ({} as Record<string, unknown>),
  },
};

// Fill ca.admin from en with CA overrides for admin metrics labels
const tr = translations as { ca: { admin: unknown } };
tr.ca.admin = {
  ...translations.en.admin,
  navGroups: {
    dashboard: "Panell",
    dailyOperations: "Operacions diàries",
    accountsAccess: "Comptes i accessos",
    geographyRecords: "Geografia i registres",
    batchContentTools: "Eines de contingut per lots",
  },
  tabs: {
    ...translations.en.admin.tabs,
    reviewMenus: "Revisió de menús",
    citiesListing: "Ciutats del selector",
    restaurantLifecycle: "Cicle de vida",
    pushNotifications: "Notificacions push",
    supportTickets: "Tiquets de suport",
    founderAccess: "Accés founder",
    complimentaryPro: "Pro gratuït",
    promoCodes: "Codis promocionals",
    restaurants: "Cerca de restaurants",
    map: "Mapa de cobertura",
    areaDensity: "Densitat per zona (5 km)",
    users: "Usuaris i rols",
  },
  cities: {
    ...translations.en.admin.cities,
    title: "Ciutats del selector",
    subtitle:
      "Afegeix o treu ciutats del selector de l’app. Amb 10 o més restaurants amb menú en viu, una ciutat queda en abast per afegir-la.",
    subtitleDecision:
      "El llistat és manual. Les ciutats amb ≥10 menús en viu es mostren com a En abast; afegir requereix una regió GPS.",
    expansionWarning:
      "Les ciutats noves poden necessitar suport a l’app i una regió GPS per funcionar correctament de principi a fi.",
    readOnlyBanner:
      "Accés només de lectura. Els canvis de ciutats requereixen un compte admin.",
    readinessError:
      "No s’han pogut carregar les mètriques de preparació. Els recomptes i l’estat Ready no estan disponibles.",
    listAnywayTitle: "Afegir ciutat per sota del llindar?",
    listAnywayMessage:
      "Aquesta ciutat té menys de 10 restaurants amb menú en viu. Afegir-la igual pot mostrar poca oferta al selector.",
    listAnywayConfirm: "Afegir igualment",
    summaryInSelector: "Al selector",
    summaryScoped: "En abast (≥10)",
    summaryBelow: "Per sota",
    filterInSelector: "Al selector",
    filterScoped: "En abast",
    filterBelow: "Per sota",
    bucketInSelector: "Al selector",
    bucketScoped: "En abast",
    bucketBelow: "Per sota",
    addToSelector: "Afegir",
    removeFromSelector: "Treure",
    columnStatus: "Estat",
    columnLiveMenus: "Menús en viu",
    columnEnabledTitle: "Vàlida internament (reclamacions, RPCs)",
    columnListedTitle: "Apareix al selector d’ubicació de l’app",
    columnStatusTitle:
      "Ready = senyal de preparació (reclamacions/menús); no llista automàticament",
    addCity: "Afegir ciutat",
    editCity: "Editar ciutat",
    loading: "Carregant…",
    enabledLabel: "Habilitada (vàlida internament)",
    listedLabel: "Llistada (selector de l’app)",
    officialLabel: "Oficial",
    sortPriorityLabel: "Prioritat (menor = primer als selectors)",
    slugLabel: "Slug (minúscules, URL)",
    labelEn: "Etiqueta (EN) *",
    labelEs: "Etiqueta (ES)",
    labelCa: "Etiqueta (CA)",
    cancel: "Cancel·lar",
    update: "Actualitzar",
    add: "Afegir",
    saving: "Desant…",
    statusListed: "Llistada",
    statusHidden: "Oculta",
    enable: "Habilitar",
    disable: "Deshabilitar",
    list: "Llistar",
    unlist: "Treure de la llista",
    edit: "Editar",
    cityUpdated: "Ciutat actualitzada.",
    cityAdded: "Ciutat afegida.",
    cityEnabled: "Ciutat habilitada.",
    cityDisabled: "Ciutat deshabilitada.",
    cityListed: "Ciutat afegida al selector.",
    cityUnlisted: "Ciutat treta del selector.",
    slugRequired: "El slug i l’etiqueta en anglès són obligatoris.",
    loadFailed: "Error en carregar ciutats:",
  },
  metrics: {
    ...translations.en.admin.metrics,
    kpi: {
      ...translations.en.admin.metrics.kpi,
      availableRestaurants: "Restaurants visibles",
      publishedCapturesAllTime: "Captures publicades (total)",
      unavailable: "No disponible",
    },
  },
};

export type Translations = typeof translations.en;
export const getTranslations = (lang: Language): Translations => translations[lang] as Translations;
